export default {
    normal: {
        unitsPerEm: 2048,
        ascent: 1854,
        widths: {
            '32': 569,
            '33': 569,
            '34': 727,
            '35': 1139,
            '36': 1139,
            '37': 1821,
            '38': 1366,
            '39': 391,
            '40': 682,
            '41': 682,
            '42': 797,
            '43': 1196,
            '44': 569,
            '45': 682,
            '46': 569,
            '47': 569,
            '48': 1139,
            '49': 1139,
            '50': 1139,
            '51': 1139,
            '52': 1139,
            '53': 1139,
            '54': 1139,
            '55': 1139,
            '56': 1139,
            '57': 1139,
            '58': 569,
            '59': 569,
            '60': 1196,
            '61': 1196,
            '62': 1196,
            '63': 1139,
            '64': 2079,
            '65': 1366,
            '66': 1366,
            '67': 1479,
            '68': 1479,
            '69': 1366,
            '70': 1251,
            '71': 1593,
            '72': 1479,
            '73': 569,
            '74': 1024,
            '75': 1366,
            '76': 1139,
            '77': 1706,
            '78': 1479,
            '79': 1593,
            '80': 1366,
            '81': 1593,
            '82': 1479,
            '83': 1366,
            '84': 1251,
            '85': 1479,
            '86': 1366,
            '87': 1933,
            '88': 1366,
            '89': 1366,
            '90': 1251,
            '91': 569,
            '92': 569,
            '93': 569,
            '94': 961,
            '95': 1139,
            '96': 682,
            '97': 1139,
            '98': 1139,
            '99': 1024,
            '100': 1139,
            '101': 1139,
            '102': 569,
            '103': 1139,
            '104': 1139,
            '105': 455,
            '106': 455,
            '107': 1024,
            '108': 455,
            '109': 1706,
            '110': 1139,
            '111': 1139,
            '112': 1139,
            '113': 1139,
            '114': 682,
            '115': 1024,
            '116': 569,
            '117': 1139,
            '118': 1024,
            '119': 1479,
            '120': 1024,
            '121': 1024,
            '122': 1024,
            '123': 684,
            '124': 532,
            '125': 684,
            '126': 1196,
            '160': 569,
            '161': 682,
            '162': 1139,
            '163': 1139,
            '164': 1139,
            '165': 1139,
            '166': 532,
            '167': 1139,
            '168': 682,
            '169': 1509,
            '170': 758,
            '171': 1139,
            '172': 1196,
            '173': 682,
            '174': 1509,
            '175': 1131,
            '176': 819,
            '177': 1124,
            '178': 682,
            '179': 682,
            '180': 682,
            '181': 1180,
            '182': 1100,
            '183': 682,
            '184': 682,
            '185': 682,
            '186': 748,
            '187': 1139,
            '188': 1708,
            '189': 1708,
            '190': 1708,
            '191': 1251,
            '192': 1366,
            '193': 1366,
            '194': 1366,
            '195': 1366,
            '196': 1366,
            '197': 1366,
            '198': 2048,
            '199': 1479,
            '200': 1366,
            '201': 1366,
            '202': 1366,
            '203': 1366,
            '204': 569,
            '205': 569,
            '206': 569,
            '207': 569,
            '208': 1479,
            '209': 1479,
            '210': 1593,
            '211': 1593,
            '212': 1593,
            '213': 1593,
            '214': 1593,
            '215': 1196,
            '216': 1593,
            '217': 1479,
            '218': 1479,
            '219': 1479,
            '220': 1479,
            '221': 1366,
            '222': 1366,
            '223': 1251,
            '224': 1139,
            '225': 1139,
            '226': 1139,
            '227': 1139,
            '228': 1139,
            '229': 1139,
            '230': 1821,
            '231': 1024,
            '232': 1139,
            '233': 1139,
            '234': 1139,
            '235': 1139,
            '236': 569,
            '237': 569,
            '238': 569,
            '239': 569,
            '240': 1139,
            '241': 1139,
            '242': 1139,
            '243': 1139,
            '244': 1139,
            '245': 1139,
            '246': 1139,
            '247': 1124,
            '248': 1251,
            '249': 1139,
            '250': 1139,
            '251': 1139,
            '252': 1139,
            '253': 1024,
            '254': 1139,
            '255': 1024,
            '256': 1366,
            '257': 1139,
            '258': 1366,
            '259': 1139,
            '260': 1366,
            '261': 1139,
            '262': 1479,
            '263': 1024,
            '264': 1479,
            '265': 1024,
            '266': 1479,
            '267': 1024,
            '268': 1479,
            '269': 1024,
            '270': 1479,
            '271': 1259,
            '272': 1479,
            '273': 1139,
            '274': 1366,
            '275': 1139,
            '276': 1366,
            '277': 1139,
            '278': 1366,
            '279': 1139,
            '280': 1366,
            '281': 1139,
            '282': 1366,
            '283': 1139,
            '284': 1593,
            '285': 1139,
            '286': 1593,
            '287': 1139,
            '288': 1593,
            '289': 1139,
            '290': 1593,
            '291': 1139,
            '292': 1479,
            '293': 1139,
            '294': 1479,
            '295': 1139,
            '296': 569,
            '297': 569,
            '298': 569,
            '299': 569,
            '300': 569,
            '301': 569,
            '302': 569,
            '303': 455,
            '304': 569,
            '305': 569,
            '306': 1505,
            '307': 909,
            '308': 1024,
            '309': 455,
            '310': 1366,
            '311': 1024,
            '312': 1024,
            '313': 1139,
            '314': 455,
            '315': 1139,
            '316': 455,
            '317': 1139,
            '318': 597,
            '319': 1139,
            '320': 684,
            '321': 1139,
            '322': 455,
            '323': 1479,
            '324': 1139,
            '325': 1479,
            '326': 1139,
            '327': 1479,
            '328': 1139,
            '329': 1237,
            '330': 1481,
            '331': 1139,
            '332': 1593,
            '333': 1139,
            '334': 1593,
            '335': 1139,
            '336': 1593,
            '337': 1139,
            '338': 2048,
            '339': 1933,
            '340': 1479,
            '341': 682,
            '342': 1479,
            '343': 682,
            '344': 1479,
            '345': 682,
            '346': 1366,
            '347': 1024,
            '348': 1366,
            '349': 1024,
            '350': 1366,
            '351': 1024,
            '352': 1366,
            '353': 1024,
            '354': 1251,
            '355': 569,
            '356': 1251,
            '357': 768,
            '358': 1251,
            '359': 569,
            '360': 1479,
            '361': 1139,
            '362': 1479,
            '363': 1139,
            '364': 1479,
            '365': 1139,
            '366': 1479,
            '367': 1139,
            '368': 1479,
            '369': 1139,
            '370': 1479,
            '371': 1139,
            '372': 1933,
            '373': 1479,
            '374': 1366,
            '375': 1024,
            '376': 1366,
            '377': 1251,
            '378': 1024,
            '379': 1251,
            '380': 1024,
            '381': 1251,
            '382': 1024,
            '383': 455,
            '384': 1139,
            '385': 1553,
            '386': 1344,
            '387': 1139,
            '388': 1344,
            '389': 1139,
            '390': 1479,
            '391': 1479,
            '392': 1024,
            '393': 1479,
            '394': 1658,
            '395': 1344,
            '396': 1139,
            '397': 1140,
            '398': 1366,
            '399': 1541,
            '400': 1237,
            '401': 1251,
            '402': 1139,
            '403': 1593,
            '404': 1278,
            '405': 1804,
            '406': 455,
            '407': 569,
            '408': 1366,
            '409': 1024,
            '410': 455,
            '411': 1024,
            '412': 1824,
            '413': 1479,
            '414': 1139,
            '415': 1593,
            '416': 1756,
            '417': 1343,
            '418': 1778,
            '419': 1367,
            '420': 1545,
            '421': 1139,
            '422': 1366,
            '423': 1366,
            '424': 1024,
            '425': 1266,
            '426': 779,
            '427': 569,
            '428': 1251,
            '429': 569,
            '430': 1251,
            '431': 1749,
            '432': 1371,
            '433': 1531,
            '434': 1479,
            '435': 1582,
            '436': 1024,
            '437': 1251,
            '438': 1024,
            '439': 1251,
            '440': 1251,
            '441': 1116,
            '442': 1116,
            '443': 1139,
            '444': 1139,
            '445': 939,
            '446': 997,
            '447': 1139,
            '448': 532,
            '449': 846,
            '450': 1196,
            '451': 569,
            '452': 2730,
            '453': 2503,
            '454': 2148,
            '455': 2175,
            '456': 1706,
            '457': 924,
            '458': 2503,
            '459': 1934,
            '460': 1579,
            '461': 1366,
            '462': 1139,
            '463': 569,
            '464': 455,
            '465': 1593,
            '466': 1139,
            '467': 1479,
            '468': 1139,
            '469': 1479,
            '470': 1139,
            '471': 1479,
            '472': 1139,
            '473': 1479,
            '474': 1139,
            '475': 1479,
            '476': 1139,
            '477': 1139,
            '478': 1366,
            '479': 1139,
            '480': 1366,
            '481': 1139,
            '482': 2048,
            '483': 1821,
            '484': 1593,
            '485': 1139,
            '486': 1593,
            '487': 1139,
            '488': 1366,
            '489': 1024,
            '490': 1593,
            '491': 1139,
            '492': 1593,
            '493': 1139,
            '494': 1251,
            '495': 1116,
            '496': 455,
            '497': 2730,
            '498': 2503,
            '499': 2148,
            '500': 1593,
            '501': 1139,
            '502': 2118,
            '503': 1266,
            '504': 1479,
            '505': 1139,
            '506': 1366,
            '507': 1139,
            '508': 2048,
            '509': 1821,
            '510': 1593,
            '511': 1251,
            '512': 1366,
            '513': 1139,
            '514': 1366,
            '515': 1139,
            '516': 1366,
            '517': 1139,
            '518': 1366,
            '519': 1139,
            '520': 569,
            '521': 569,
            '522': 569,
            '523': 569,
            '524': 1593,
            '525': 1139,
            '526': 1593,
            '527': 1139,
            '528': 1479,
            '529': 682,
            '530': 1479,
            '531': 682,
            '532': 1479,
            '533': 1139,
            '534': 1479,
            '535': 1139,
            '536': 1366,
            '537': 1024,
            '538': 1251,
            '539': 569,
            '540': 1116,
            '541': 894,
            '542': 1479,
            '543': 1139,
            '544': 1446,
            '545': 1396,
            '546': 1238,
            '547': 1158,
            '548': 1251,
            '549': 1024,
            '550': 1366,
            '551': 1139,
            '552': 1366,
            '553': 1139,
            '554': 1593,
            '555': 1139,
            '556': 1593,
            '557': 1139,
            '558': 1593,
            '559': 1139,
            '560': 1593,
            '561': 1139,
            '562': 1366,
            '563': 1024,
            '564': 715,
            '565': 1402,
            '566': 752,
            '567': 455,
            '568': 1816,
            '569': 1816,
            '570': 1366,
            '571': 1479,
            '572': 1024,
            '573': 1139,
            '574': 1251,
            '575': 1024,
            '576': 1024,
            '577': 1189,
            '578': 928,
            '579': 1366,
            '580': 1479,
            '581': 1368,
            '582': 1366,
            '583': 1139,
            '584': 1024,
            '585': 455,
            '586': 1510,
            '587': 1139,
            '588': 1479,
            '589': 682,
            '590': 1366,
            '591': 1024,
            '592': 1139,
            '593': 1139,
            '594': 1139,
            '595': 1139,
            '596': 1024,
            '597': 1024,
            '598': 1139,
            '599': 1139,
            '600': 1139,
            '601': 1139,
            '602': 1513,
            '603': 939,
            '604': 939,
            '605': 1293,
            '606': 1039,
            '607': 569,
            '608': 1139,
            '609': 1139,
            '610': 1144,
            '611': 1026,
            '612': 1263,
            '613': 1139,
            '614': 1139,
            '615': 1139,
            '616': 455,
            '617': 455,
            '618': 729,
            '619': 670,
            '620': 622,
            '621': 455,
            '622': 1171,
            '623': 1706,
            '624': 1706,
            '625': 1706,
            '626': 1139,
            '627': 1139,
            '628': 1132,
            '629': 1139,
            '630': 1619,
            '631': 1599,
            '632': 1126,
            '633': 682,
            '634': 682,
            '635': 682,
            '636': 682,
            '637': 682,
            '638': 682,
            '639': 682,
            '640': 1109,
            '641': 1109,
            '642': 1024,
            '643': 455,
            '644': 532,
            '645': 455,
            '646': 715,
            '647': 569,
            '648': 569,
            '649': 1139,
            '650': 1164,
            '651': 1120,
            '652': 1024,
            '653': 1479,
            '654': 1024,
            '655': 1064,
            '656': 1024,
            '657': 1108,
            '658': 1116,
            '659': 1116,
            '660': 1024,
            '661': 1024,
            '662': 1024,
            '663': 1024,
            '664': 1593,
            '665': 1088,
            '666': 1039,
            '667': 1144,
            '668': 1131,
            '669': 814,
            '670': 1024,
            '671': 827,
            '672': 1139,
            '673': 1024,
            '674': 1024,
            '675': 1975,
            '676': 1856,
            '677': 2059,
            '678': 1459,
            '679': 879,
            '680': 1472,
            '681': 1564,
            '682': 1354,
            '683': 1295,
            '684': 994,
            '685': 1080,
            '686': 1407,
            '687': 1407,
            '688': 785,
            '689': 785,
            '690': 326,
            '691': 491,
            '692': 491,
            '693': 491,
            '694': 746,
            '695': 985,
            '696': 657,
            '697': 391,
            '698': 727,
            '699': 455,
            '700': 455,
            '701': 455,
            '702': 682,
            '703': 682,
            '704': 714,
            '705': 714,
            '706': 1196,
            '707': 1196,
            '708': 1196,
            '709': 1196,
            '710': 682,
            '711': 682,
            '712': 682,
            '713': 682,
            '714': 682,
            '715': 682,
            '716': 682,
            '717': 682,
            '718': 682,
            '719': 682,
            '720': 569,
            '721': 569,
            '722': 682,
            '723': 682,
            '724': 682,
            '725': 682,
            '726': 682,
            '727': 682,
            '728': 682,
            '729': 682,
            '730': 682,
            '731': 682,
            '732': 682,
            '733': 682,
            '734': 682,
            '735': 682,
            '736': 660,
            '737': 322,
            '738': 696,
            '739': 672,
            '740': 714,
            '741': 784,
            '742': 784,
            '743': 784,
            '744': 784,
            '745': 784,
            '746': 682,
            '747': 682,
            '748': 682,
            '749': 682,
            '750': 682,
            '751': 682,
            '752': 682,
            '753': 682,
            '754': 682,
            '755': 682,
            '756': 682,
            '757': 682,
            '758': 682,
            '759': 682,
            '760': 569,
            '761': 682,
            '762': 682,
            '763': 682,
            '764': 682,
            '765': 814,
            '766': 814,
            '767': 682,
            '768': 0,
            '769': 0,
            '770': 0,
            '771': 0,
            '772': 0,
            '773': 0,
            '774': 0,
            '775': 0,
            '776': 0,
            '777': 0,
            '778': 0,
            '779': 0,
            '780': 0,
            '781': 0,
            '782': 0,
            '783': 0,
            '784': 0,
            '785': 0,
            '786': 0,
            '787': 0,
            '788': 0,
            '789': 0,
            '790': 0,
            '791': 0,
            '792': 0,
            '793': 0,
            '794': 0,
            '795': 0,
            '796': 0,
            '797': 0,
            '798': 0,
            '799': 0,
            '800': 0,
            '801': 0,
            '802': 0,
            '803': 0,
            '804': 0,
            '805': 0,
            '806': 0,
            '807': 0,
            '808': 0,
            '809': 0,
            '810': 0,
            '811': 0,
            '812': 0,
            '813': 0,
            '814': 0,
            '815': 0,
            '816': 0,
            '817': 0,
            '818': 0,
            '819': 0,
            '820': 0,
            '821': 0,
            '822': 0,
            '823': 0,
            '824': 0,
            '825': 0,
            '826': 0,
            '827': 0,
            '828': 0,
            '829': 0,
            '830': 0,
            '831': 0,
            '832': 0,
            '833': 0,
            '834': 0,
            '835': 0,
            '836': 0,
            '837': 0,
            '838': 0,
            '839': 0,
            '840': 0,
            '841': 0,
            '842': 0,
            '843': 0,
            '844': 0,
            '845': 0,
            '846': 0,
            '847': 0,
            '848': 0,
            '849': 0,
            '850': 0,
            '851': 0,
            '852': 0,
            '853': 0,
            '854': 0,
            '855': 0,
            '856': 0,
            '857': 0,
            '858': 0,
            '859': 0,
            '860': 0,
            '861': 0,
            '862': 0,
            '863': 0,
            '864': 0,
            '865': 0,
            '866': 0,
            '867': 0,
            '868': 0,
            '869': 0,
            '870': 0,
            '871': 0,
            '872': 0,
            '873': 0,
            '874': 0,
            '875': 0,
            '876': 0,
            '877': 0,
            '878': 0,
            '879': 0,
            '884': 682,
            '885': 682,
            '890': 682,
            '891': 1024,
            '892': 1024,
            '893': 1024,
            '894': 569,
            '900': 682,
            '901': 682,
            '902': 1367,
            '903': 569,
            '904': 1606,
            '905': 1716,
            '906': 786,
            '908': 1586,
            '910': 1752,
            '911': 1541,
            '912': 455,
            '913': 1366,
            '914': 1366,
            '915': 1128,
            '916': 1368,
            '917': 1366,
            '918': 1251,
            '919': 1479,
            '920': 1593,
            '921': 569,
            '922': 1366,
            '923': 1368,
            '924': 1706,
            '925': 1479,
            '926': 1331,
            '927': 1593,
            '928': 1479,
            '929': 1366,
            '931': 1266,
            '932': 1251,
            '933': 1366,
            '934': 1634,
            '935': 1366,
            '936': 1711,
            '937': 1531,
            '938': 569,
            '939': 1366,
            '940': 1184,
            '941': 913,
            '942': 1139,
            '943': 455,
            '944': 1120,
            '945': 1184,
            '946': 1178,
            '947': 1024,
            '948': 1140,
            '949': 913,
            '950': 903,
            '951': 1139,
            '952': 1139,
            '953': 455,
            '954': 1024,
            '955': 1024,
            '956': 1180,
            '957': 1024,
            '958': 917,
            '959': 1139,
            '960': 1413,
            '961': 1165,
            '962': 987,
            '963': 1264,
            '964': 809,
            '965': 1120,
            '966': 1328,
            '967': 1075,
            '968': 1460,
            '969': 1599,
            '970': 455,
            '971': 1120,
            '972': 1139,
            '973': 1120,
            '974': 1599,
            '976': 1178,
            '977': 1120,
            '978': 1582,
            '979': 1962,
            '980': 1582,
            '981': 1147,
            '982': 1599,
            '983': 1231,
            '984': 1593,
            '985': 1139,
            '986': 1479,
            '987': 1024,
            '988': 1251,
            '989': 827,
            '990': 1279,
            '991': 1084,
            '992': 1549,
            '993': 1181,
            '994': 1824,
            '995': 1706,
            '996': 1381,
            '997': 1139,
            '998': 1380,
            '999': 1024,
            '1000': 1366,
            '1001': 1366,
            '1002': 1248,
            '1003': 1221,
            '1004': 1509,
            '1005': 1134,
            '1006': 950,
            '1007': 839,
            '1008': 1231,
            '1009': 1173,
            '1010': 1024,
            '1011': 455,
            '1012': 1593,
            '1013': 905,
            '1014': 905,
            '1015': 1366,
            '1016': 1139,
            '1017': 1479,
            '1018': 1706,
            '1019': 1408,
            '1020': 1165,
            '1021': 1479,
            '1022': 1479,
            '1023': 1479,
            '1024': 1366,
            '1025': 1367,
            '1026': 1771,
            '1027': 1109,
            '1028': 1472,
            '1029': 1366,
            '1030': 569,
            '1031': 569,
            '1032': 1024,
            '1033': 2165,
            '1034': 2069,
            '1035': 1749,
            '1036': 1193,
            '1037': 1472,
            '1038': 1301,
            '1039': 1472,
            '1040': 1366,
            '1041': 1344,
            '1042': 1366,
            '1043': 1109,
            '1044': 1387,
            '1045': 1366,
            '1046': 1891,
            '1047': 1237,
            '1048': 1472,
            '1049': 1472,
            '1050': 1193,
            '1051': 1344,
            '1052': 1706,
            '1053': 1479,
            '1054': 1593,
            '1055': 1472,
            '1056': 1366,
            '1057': 1479,
            '1058': 1251,
            '1059': 1301,
            '1060': 1557,
            '1061': 1366,
            '1062': 1515,
            '1063': 1365,
            '1064': 1877,
            '1065': 1920,
            '1066': 1621,
            '1067': 1813,
            '1068': 1344,
            '1069': 1472,
            '1070': 2069,
            '1071': 1479,
            '1072': 1139,
            '1073': 1173,
            '1074': 1088,
            '1075': 747,
            '1076': 1195,
            '1077': 1139,
            '1078': 1370,
            '1079': 939,
            '1080': 1144,
            '1081': 1144,
            '1082': 896,
            '1083': 1195,
            '1084': 1408,
            '1085': 1131,
            '1086': 1139,
            '1087': 1109,
            '1088': 1139,
            '1089': 1024,
            '1090': 938,
            '1091': 1024,
            '1092': 1685,
            '1093': 1024,
            '1094': 1173,
            '1095': 1067,
            '1096': 1643,
            '1097': 1685,
            '1098': 1280,
            '1099': 1472,
            '1100': 1067,
            '1101': 1045,
            '1102': 1536,
            '1103': 1109,
            '1104': 1139,
            '1105': 1139,
            '1106': 1139,
            '1107': 747,
            '1108': 1045,
            '1109': 1024,
            '1110': 455,
            '1111': 569,
            '1112': 455,
            '1113': 1856,
            '1114': 1664,
            '1115': 1139,
            '1116': 896,
            '1117': 1144,
            '1118': 1024,
            '1119': 1131,
            '1120': 2740,
            '1121': 1278,
            '1122': 1593,
            '1123': 1255,
            '1124': 1945,
            '1125': 1461,
            '1126': 1368,
            '1127': 1024,
            '1128': 1838,
            '1129': 1424,
            '1130': 1697,
            '1131': 1403,
            '1132': 2157,
            '1133': 1776,
            '1134': 1237,
            '1135': 939,
            '1136': 1631,
            '1137': 1410,
            '1138': 1593,
            '1139': 1139,
            '1140': 1645,
            '1141': 1292,
            '1142': 1645,
            '1143': 1292,
            '1144': 2200,
            '1145': 1836,
            '1146': 1706,
            '1147': 1254,
            '1148': 2439,
            '1149': 1744,
            '1150': 2740,
            '1151': 1278,
            '1152': 1479,
            '1153': 1024,
            '1154': 1031,
            '1155': 0,
            '1156': 0,
            '1157': 0,
            '1158': 0,
            '1159': 0,
            '1160': 0,
            '1161': 0,
            '1162': 1472,
            '1163': 1144,
            '1164': 1344,
            '1165': 1067,
            '1166': 1366,
            '1167': 1139,
            '1168': 1001,
            '1169': 842,
            '1170': 1109,
            '1171': 747,
            '1172': 1373,
            '1173': 1124,
            '1174': 1891,
            '1175': 1370,
            '1176': 1237,
            '1177': 939,
            '1178': 1193,
            '1179': 896,
            '1180': 1193,
            '1181': 896,
            '1182': 1193,
            '1183': 896,
            '1184': 1519,
            '1185': 1097,
            '1186': 1479,
            '1187': 1131,
            '1188': 1801,
            '1189': 1327,
            '1190': 2328,
            '1191': 1782,
            '1192': 1542,
            '1193': 1067,
            '1194': 1479,
            '1195': 1024,
            '1196': 1251,
            '1197': 938,
            '1198': 1139,
            '1199': 1024,
            '1200': 1139,
            '1201': 1024,
            '1202': 1366,
            '1203': 1024,
            '1204': 1895,
            '1205': 1415,
            '1206': 1365,
            '1207': 1067,
            '1208': 1365,
            '1209': 1067,
            '1210': 1365,
            '1211': 1139,
            '1212': 1764,
            '1213': 1364,
            '1214': 1764,
            '1215': 1364,
            '1216': 569,
            '1217': 1891,
            '1218': 1370,
            '1219': 1367,
            '1220': 1128,
            '1221': 1344,
            '1222': 1195,
            '1223': 1479,
            '1224': 1131,
            '1225': 1479,
            '1226': 1131,
            '1227': 1365,
            '1228': 1067,
            '1229': 1706,
            '1230': 1408,
            '1231': 455,
            '1232': 1366,
            '1233': 1139,
            '1234': 1366,
            '1235': 1139,
            '1236': 2048,
            '1237': 1821,
            '1238': 1366,
            '1239': 1139,
            '1240': 1541,
            '1241': 1139,
            '1242': 1541,
            '1243': 1139,
            '1244': 1891,
            '1245': 1370,
            '1246': 1237,
            '1247': 939,
            '1248': 1237,
            '1249': 1116,
            '1250': 1472,
            '1251': 1144,
            '1252': 1472,
            '1253': 1144,
            '1254': 1593,
            '1255': 1139,
            '1256': 1593,
            '1257': 1139,
            '1258': 1593,
            '1259': 1139,
            '1260': 1472,
            '1261': 1045,
            '1262': 1301,
            '1263': 1024,
            '1264': 1301,
            '1265': 1024,
            '1266': 1301,
            '1267': 1024,
            '1268': 1365,
            '1269': 1067,
            '1270': 1109,
            '1271': 747,
            '1272': 1813,
            '1273': 1472,
            '1274': 1109,
            '1275': 747,
            '1276': 1366,
            '1277': 1024,
            '1278': 1366,
            '1279': 1024,
            '1280': 1344,
            '1281': 1139,
            '1282': 1983,
            '1283': 1795,
            '1284': 1958,
            '1285': 1670,
            '1286': 1357,
            '1287': 1043,
            '1288': 1987,
            '1289': 1863,
            '1290': 2118,
            '1291': 1799,
            '1292': 1593,
            '1293': 1144,
            '1294': 1529,
            '1295': 1363,
            '1296': 1237,
            '1297': 939,
            '1298': 1344,
            '1299': 1195,
            '1306': 1593,
            '1307': 1139,
            '1308': 1933,
            '1309': 1479,
            '1425': 0,
            '1426': 0,
            '1427': 0,
            '1428': 0,
            '1429': 0,
            '1430': 0,
            '1431': 0,
            '1432': 0,
            '1433': 0,
            '1434': 0,
            '1435': 0,
            '1436': 0,
            '1437': 0,
            '1438': 0,
            '1439': 0,
            '1440': 0,
            '1441': 0,
            '1442': 0,
            '1443': 0,
            '1444': 0,
            '1445': 0,
            '1446': 0,
            '1447': 0,
            '1448': 0,
            '1449': 0,
            '1450': 0,
            '1451': 0,
            '1452': 0,
            '1453': 0,
            '1454': 0,
            '1455': 0,
            '1456': 0,
            '1457': 0,
            '1458': 0,
            '1459': 0,
            '1460': 0,
            '1461': 0,
            '1462': 0,
            '1463': 0,
            '1464': 0,
            '1465': 0,
            '1466': 0,
            '1467': 0,
            '1468': 0,
            '1469': 0,
            '1470': 784,
            '1471': 0,
            '1472': 1153,
            '1473': 0,
            '1474': 0,
            '1475': 569,
            '1476': 0,
            '1477': 0,
            '1478': 776,
            '1479': 0,
            '1488': 1286,
            '1489': 1225,
            '1490': 866,
            '1491': 1135,
            '1492': 1298,
            '1493': 532,
            '1494': 662,
            '1495': 1348,
            '1496': 1337,
            '1497': 532,
            '1498': 1094,
            '1499': 1075,
            '1500': 1085,
            '1501': 1389,
            '1502': 1407,
            '1503': 532,
            '1504': 797,
            '1505': 1343,
            '1506': 1192,
            '1507': 1276,
            '1508': 1249,
            '1509': 1032,
            '1510': 1116,
            '1511': 1208,
            '1512': 1094,
            '1513': 1495,
            '1514': 1415,
            '1520': 1042,
            '1521': 1042,
            '1522': 1042,
            '1523': 788,
            '1524': 1235,
            '7424': 1016,
            '7425': 1531,
            '7426': 1821,
            '7427': 1088,
            '7428': 1024,
            '7429': 1129,
            '7430': 1129,
            '7431': 1003,
            '7432': 939,
            '7433': 455,
            '7434': 865,
            '7435': 1024,
            '7436': 822,
            '7437': 1408,
            '7438': 1144,
            '7439': 1139,
            '7440': 1024,
            '7441': 1246,
            '7442': 1246,
            '7443': 1246,
            '7444': 1933,
            '7445': 936,
            '7446': 1139,
            '7447': 1139,
            '7448': 1067,
            '7449': 1109,
            '7450': 1109,
            '7451': 938,
            '7452': 1120,
            '7453': 1222,
            '7454': 1502,
            '7455': 1222,
            '7456': 1024,
            '7457': 1479,
            '7458': 1024,
            '7459': 939,
            '7460': 875,
            '7461': 1243,
            '7462': 747,
            '7463': 1024,
            '7464': 1109,
            '7465': 1067,
            '7466': 1460,
            '7467': 1195,
            '7468': 928,
            '7469': 1359,
            '7470': 849,
            '7471': 849,
            '7472': 920,
            '7473': 840,
            '7474': 840,
            '7475': 1016,
            '7476': 878,
            '7477': 342,
            '7478': 644,
            '7479': 870,
            '7480': 720,
            '7481': 1045,
            '7482': 881,
            '7483': 879,
            '7484': 1048,
            '7485': 783,
            '7486': 857,
            '7487': 924,
            '7488': 886,
            '7489': 879,
            '7490': 1275,
            '7491': 762,
            '7492': 762,
            '7493': 772,
            '7494': 1228,
            '7495': 773,
            '7496': 773,
            '7497': 761,
            '7498': 761,
            '7499': 652,
            '7500': 652,
            '7501': 772,
            '7502': 322,
            '7503': 694,
            '7504': 1173,
            '7505': 783,
            '7506': 773,
            '7507': 725,
            '7508': 773,
            '7509': 773,
            '7510': 774,
            '7511': 450,
            '7512': 783,
            '7513': 834,
            '7514': 1173,
            '7515': 658,
            '7516': 800,
            '7517': 789,
            '7518': 658,
            '7519': 774,
            '7520': 901,
            '7521': 703,
            '7522': 322,
            '7523': 491,
            '7524': 783,
            '7525': 658,
            '7526': 789,
            '7527': 658,
            '7528': 777,
            '7529': 901,
            '7530': 703,
            '7531': 1860,
            '7532': 1139,
            '7533': 1139,
            '7534': 569,
            '7535': 1706,
            '7536': 1139,
            '7537': 1139,
            '7538': 682,
            '7539': 682,
            '7540': 1024,
            '7541': 569,
            '7542': 1024,
            '7543': 1139,
            '7544': 779,
            '7545': 1140,
            '7546': 1609,
            '7547': 455,
            '7548': 455,
            '7549': 1139,
            '7550': 1120,
            '7551': 1164,
            '7552': 1139,
            '7553': 1139,
            '7554': 569,
            '7555': 1460,
            '7556': 1024,
            '7557': 455,
            '7558': 1706,
            '7559': 1139,
            '7560': 1139,
            '7561': 682,
            '7562': 1024,
            '7563': 792,
            '7564': 1024,
            '7565': 1024,
            '7566': 1024,
            '7567': 1139,
            '7568': 1139,
            '7569': 1139,
            '7570': 1139,
            '7571': 939,
            '7572': 939,
            '7573': 1332,
            '7574': 455,
            '7575': 1024,
            '7576': 455,
            '7577': 1139,
            '7578': 1116,
            '7579': 772,
            '7580': 725,
            '7581': 713,
            '7582': 764,
            '7583': 652,
            '7584': 469,
            '7585': 469,
            '7586': 772,
            '7587': 785,
            '7588': 322,
            '7589': 322,
            '7590': 322,
            '7591': 322,
            '7592': 554,
            '7593': 322,
            '7594': 322,
            '7595': 563,
            '7596': 1171,
            '7597': 1171,
            '7598': 783,
            '7599': 783,
            '7600': 782,
            '7601': 773,
            '7602': 768,
            '7603': 696,
            '7604': 322,
            '7605': 450,
            '7606': 783,
            '7607': 794,
            '7608': 774,
            '7609': 724,
            '7610': 658,
            '7611': 734,
            '7612': 734,
            '7613': 734,
            '7614': 756,
            '7615': 746,
            '7616': 0,
            '7617': 0,
            '7618': 0,
            '7619': 0,
            '7620': 0,
            '7621': 0,
            '7622': 0,
            '7623': 0,
            '7624': 0,
            '7625': 0,
            '7626': 0,
            '7678': 0,
            '7679': 0,
            '7680': 1366,
            '7681': 1139,
            '7682': 1366,
            '7683': 1139,
            '7684': 1366,
            '7685': 1139,
            '7686': 1366,
            '7687': 1139,
            '7688': 1479,
            '7689': 1024,
            '7690': 1479,
            '7691': 1139,
            '7692': 1479,
            '7693': 1139,
            '7694': 1479,
            '7695': 1139,
            '7696': 1479,
            '7697': 1139,
            '7698': 1479,
            '7699': 1139,
            '7700': 1366,
            '7701': 1139,
            '7702': 1366,
            '7703': 1139,
            '7704': 1366,
            '7705': 1139,
            '7706': 1366,
            '7707': 1139,
            '7708': 1366,
            '7709': 1139,
            '7710': 1251,
            '7711': 569,
            '7712': 1593,
            '7713': 1139,
            '7714': 1479,
            '7715': 1139,
            '7716': 1479,
            '7717': 1139,
            '7718': 1479,
            '7719': 1139,
            '7720': 1479,
            '7721': 1139,
            '7722': 1479,
            '7723': 1139,
            '7724': 569,
            '7725': 455,
            '7726': 569,
            '7727': 569,
            '7728': 1366,
            '7729': 1024,
            '7730': 1366,
            '7731': 1024,
            '7732': 1366,
            '7733': 1024,
            '7734': 1139,
            '7735': 455,
            '7736': 1139,
            '7737': 455,
            '7738': 1139,
            '7739': 455,
            '7740': 1139,
            '7741': 455,
            '7742': 1706,
            '7743': 1706,
            '7744': 1706,
            '7745': 1706,
            '7746': 1706,
            '7747': 1706,
            '7748': 1479,
            '7749': 1139,
            '7750': 1479,
            '7751': 1139,
            '7752': 1479,
            '7753': 1139,
            '7754': 1479,
            '7755': 1139,
            '7756': 1593,
            '7757': 1139,
            '7758': 1593,
            '7759': 1139,
            '7760': 1593,
            '7761': 1139,
            '7762': 1593,
            '7763': 1139,
            '7764': 1366,
            '7765': 1139,
            '7766': 1366,
            '7767': 1139,
            '7768': 1479,
            '7769': 682,
            '7770': 1479,
            '7771': 682,
            '7772': 1479,
            '7773': 682,
            '7774': 1479,
            '7775': 682,
            '7776': 1366,
            '7777': 1024,
            '7778': 1366,
            '7779': 1024,
            '7780': 1366,
            '7781': 1024,
            '7782': 1366,
            '7783': 1024,
            '7784': 1366,
            '7785': 1024,
            '7786': 1251,
            '7787': 569,
            '7788': 1251,
            '7789': 569,
            '7790': 1251,
            '7791': 569,
            '7792': 1251,
            '7793': 569,
            '7794': 1479,
            '7795': 1139,
            '7796': 1479,
            '7797': 1139,
            '7798': 1479,
            '7799': 1139,
            '7800': 1479,
            '7801': 1139,
            '7802': 1479,
            '7803': 1139,
            '7804': 1366,
            '7805': 1024,
            '7806': 1366,
            '7807': 1024,
            '7808': 1933,
            '7809': 1479,
            '7810': 1933,
            '7811': 1479,
            '7812': 1933,
            '7813': 1479,
            '7814': 1933,
            '7815': 1479,
            '7816': 1933,
            '7817': 1479,
            '7818': 1366,
            '7819': 1024,
            '7820': 1366,
            '7821': 1024,
            '7822': 1366,
            '7823': 1024,
            '7824': 1251,
            '7825': 1024,
            '7826': 1251,
            '7827': 1024,
            '7828': 1251,
            '7829': 1024,
            '7830': 1139,
            '7831': 569,
            '7832': 1479,
            '7833': 1024,
            '7834': 1139,
            '7835': 455,
            '7838': 1439,
            '7840': 1366,
            '7841': 1139,
            '7842': 1366,
            '7843': 1139,
            '7844': 1366,
            '7845': 1139,
            '7846': 1366,
            '7847': 1139,
            '7848': 1366,
            '7849': 1139,
            '7850': 1366,
            '7851': 1139,
            '7852': 1366,
            '7853': 1139,
            '7854': 1366,
            '7855': 1139,
            '7856': 1366,
            '7857': 1139,
            '7858': 1366,
            '7859': 1139,
            '7860': 1366,
            '7861': 1139,
            '7862': 1366,
            '7863': 1139,
            '7864': 1366,
            '7865': 1139,
            '7866': 1366,
            '7867': 1139,
            '7868': 1366,
            '7869': 1139,
            '7870': 1366,
            '7871': 1139,
            '7872': 1366,
            '7873': 1139,
            '7874': 1366,
            '7875': 1139,
            '7876': 1366,
            '7877': 1139,
            '7878': 1366,
            '7879': 1139,
            '7880': 569,
            '7881': 455,
            '7882': 569,
            '7883': 455,
            '7884': 1593,
            '7885': 1139,
            '7886': 1593,
            '7887': 1139,
            '7888': 1593,
            '7889': 1139,
            '7890': 1593,
            '7891': 1139,
            '7892': 1593,
            '7893': 1139,
            '7894': 1593,
            '7895': 1139,
            '7896': 1593,
            '7897': 1139,
            '7898': 1756,
            '7899': 1343,
            '7900': 1756,
            '7901': 1343,
            '7902': 1756,
            '7903': 1343,
            '7904': 1756,
            '7905': 1343,
            '7906': 1756,
            '7907': 1343,
            '7908': 1479,
            '7909': 1139,
            '7910': 1479,
            '7911': 1139,
            '7912': 1749,
            '7913': 1371,
            '7914': 1749,
            '7915': 1371,
            '7916': 1749,
            '7917': 1371,
            '7918': 1749,
            '7919': 1371,
            '7920': 1749,
            '7921': 1371,
            '7922': 1366,
            '7923': 1024,
            '7924': 1366,
            '7925': 1024,
            '7926': 1366,
            '7927': 1024,
            '7928': 1366,
            '7929': 1024,
            '7936': 1184,
            '7937': 1184,
            '7938': 1184,
            '7939': 1184,
            '7940': 1184,
            '7941': 1184,
            '7942': 1184,
            '7943': 1184,
            '7944': 1366,
            '7945': 1366,
            '7946': 1666,
            '7947': 1666,
            '7948': 1666,
            '7949': 1666,
            '7950': 1666,
            '7951': 1666,
            '7952': 913,
            '7953': 913,
            '7954': 913,
            '7955': 913,
            '7956': 913,
            '7957': 913,
            '7960': 1566,
            '7961': 1566,
            '7962': 1900,
            '7963': 1900,
            '7964': 1900,
            '7965': 1900,
            '7968': 1139,
            '7969': 1139,
            '7970': 1139,
            '7971': 1139,
            '7972': 1139,
            '7973': 1139,
            '7974': 1139,
            '7975': 1139,
            '7976': 1679,
            '7977': 1679,
            '7978': 2079,
            '7979': 2079,
            '7980': 2079,
            '7981': 2079,
            '7982': 2079,
            '7983': 2079,
            '7984': 455,
            '7985': 455,
            '7986': 455,
            '7987': 455,
            '7988': 455,
            '7989': 455,
            '7990': 455,
            '7991': 455,
            '7992': 769,
            '7993': 769,
            '7994': 1169,
            '7995': 1169,
            '7996': 1169,
            '7997': 1169,
            '7998': 1169,
            '7999': 1169,
            '8000': 1139,
            '8001': 1139,
            '8002': 1139,
            '8003': 1139,
            '8004': 1139,
            '8005': 1139,
            '8008': 1693,
            '8009': 1693,
            '8010': 2093,
            '8011': 2093,
            '8012': 1993,
            '8013': 1993,
            '8016': 1120,
            '8017': 1120,
            '8018': 1120,
            '8019': 1120,
            '8020': 1120,
            '8021': 1120,
            '8022': 1120,
            '8023': 1120,
            '8025': 1666,
            '8027': 1966,
            '8029': 2066,
            '8031': 1966,
            '8032': 1599,
            '8033': 1599,
            '8034': 1599,
            '8035': 1599,
            '8036': 1599,
            '8037': 1599,
            '8038': 1599,
            '8039': 1599,
            '8040': 1631,
            '8041': 1631,
            '8042': 2031,
            '8043': 2031,
            '8044': 1931,
            '8045': 1931,
            '8046': 1931,
            '8047': 1931,
            '8048': 1184,
            '8049': 1184,
            '8050': 913,
            '8051': 913,
            '8052': 1139,
            '8053': 1139,
            '8054': 455,
            '8055': 455,
            '8056': 1139,
            '8057': 1139,
            '8058': 1120,
            '8059': 1120,
            '8060': 1599,
            '8061': 1599,
            '8064': 1184,
            '8065': 1184,
            '8066': 1184,
            '8067': 1184,
            '8068': 1184,
            '8069': 1184,
            '8070': 1184,
            '8071': 1184,
            '8072': 1366,
            '8073': 1366,
            '8074': 1666,
            '8075': 1666,
            '8076': 1666,
            '8077': 1666,
            '8078': 1666,
            '8079': 1666,
            '8080': 1139,
            '8081': 1139,
            '8082': 1139,
            '8083': 1139,
            '8084': 1139,
            '8085': 1139,
            '8086': 1139,
            '8087': 1139,
            '8088': 1679,
            '8089': 1679,
            '8090': 2079,
            '8091': 2079,
            '8092': 2079,
            '8093': 2079,
            '8094': 2079,
            '8095': 2079,
            '8096': 1599,
            '8097': 1599,
            '8098': 1599,
            '8099': 1599,
            '8100': 1599,
            '8101': 1599,
            '8102': 1599,
            '8103': 1599,
            '8104': 1631,
            '8105': 1631,
            '8106': 2031,
            '8107': 2031,
            '8108': 1931,
            '8109': 1931,
            '8110': 1931,
            '8111': 1931,
            '8112': 1184,
            '8113': 1184,
            '8114': 1184,
            '8115': 1184,
            '8116': 1184,
            '8118': 1184,
            '8119': 1184,
            '8120': 1366,
            '8121': 1366,
            '8122': 1366,
            '8123': 1366,
            '8124': 1366,
            '8125': 682,
            '8126': 682,
            '8127': 682,
            '8128': 682,
            '8129': 682,
            '8130': 1139,
            '8131': 1139,
            '8132': 1139,
            '8134': 1139,
            '8135': 1139,
            '8136': 1666,
            '8137': 1666,
            '8138': 1779,
            '8139': 1779,
            '8140': 1479,
            '8141': 682,
            '8142': 682,
            '8143': 682,
            '8144': 455,
            '8145': 455,
            '8146': 455,
            '8147': 455,
            '8150': 455,
            '8151': 455,
            '8152': 569,
            '8153': 569,
            '8154': 869,
            '8155': 869,
            '8157': 682,
            '8158': 682,
            '8159': 682,
            '8160': 1120,
            '8161': 1120,
            '8162': 1120,
            '8163': 1120,
            '8164': 1165,
            '8165': 1165,
            '8166': 1120,
            '8167': 1120,
            '8168': 1366,
            '8169': 1366,
            '8170': 1766,
            '8171': 1816,
            '8172': 1566,
            '8173': 682,
            '8174': 682,
            '8175': 682,
            '8178': 1599,
            '8179': 1599,
            '8180': 1599,
            '8182': 1599,
            '8183': 1599,
            '8184': 1893,
            '8185': 1693,
            '8186': 1831,
            '8187': 1631,
            '8188': 1531,
            '8189': 682,
            '8190': 682,
            '8192': 1024,
            '8193': 2048,
            '8194': 1024,
            '8195': 2048,
            '8196': 683,
            '8197': 512,
            '8198': 341,
            '8199': 1139,
            '8200': 569,
            '8201': 410,
            '8202': 171,
            '8203': 0,
            '8204': 0,
            '8205': 0,
            '8206': 0,
            '8207': 0,
            '8208': 682,
            '8210': 1139,
            '8211': 1139,
            '8212': 2048,
            '8213': 2048,
            '8214': 846,
            '8215': 1131,
            '8216': 455,
            '8217': 455,
            '8218': 455,
            '8219': 455,
            '8220': 682,
            '8221': 682,
            '8222': 682,
            '8223': 682,
            '8224': 1139,
            '8225': 1139,
            '8226': 717,
            '8230': 2048,
            '8234': 0,
            '8235': 0,
            '8236': 0,
            '8237': 0,
            '8238': 0,
            '8239': 410,
            '8240': 2048,
            '8242': 384,
            '8243': 725,
            '8244': 725,
            '8249': 682,
            '8250': 682,
            '8252': 1024,
            '8254': 682,
            '8260': 342,
            '8286': 569,
            '8298': 0,
            '8299': 0,
            '8300': 0,
            '8301': 0,
            '8302': 0,
            '8303': 0,
            '8308': 880,
            '8309': 849,
            '8310': 843,
            '8311': 741,
            '8312': 864,
            '8313': 877,
            '8319': 747,
            '8320': 850,
            '8321': 691,
            '8322': 795,
            '8323': 834,
            '8324': 836,
            '8325': 825,
            '8326': 826,
            '8327': 704,
            '8328': 849,
            '8329': 812,
            '8336': 762,
            '8337': 761,
            '8338': 773,
            '8339': 672,
            '8340': 761,
            '8352': 1139,
            '8353': 1479,
            '8354': 1479,
            '8355': 1139,
            '8356': 1139,
            '8357': 1706,
            '8358': 1479,
            '8359': 2240,
            '8360': 2384,
            '8361': 1933,
            '8362': 1739,
            '8363': 1051,
            '8364': 1139,
            '8365': 1366,
            '8366': 1251,
            '8367': 2048,
            '8368': 1067,
            '8369': 1366,
            '8370': 1593,
            '8371': 1366,
            '8372': 1139,
            '8373': 1479,
            '8383': 1516,
            '8432': 0,
            '8453': 1813,
            '8467': 662,
            '8470': 2197,
            '8471': 1509,
            '8482': 2048,
            '8486': 1573,
            '8494': 1229,
            '8525': 1931,
            '8526': 1003,
            '8531': 1708,
            '8532': 1708,
            '8539': 1708,
            '8540': 1708,
            '8541': 1708,
            '8542': 1708,
            '8580': 1024,
            '8592': 2048,
            '8593': 1024,
            '8594': 2048,
            '8595': 1024,
            '8596': 2048,
            '8597': 1024,
            '8616': 1024,
            '8660': 2048,
            '8706': 1012,
            '8710': 1253,
            '8719': 1686,
            '8721': 1460,
            '8722': 1196,
            '8725': 342,
            '8729': 569,
            '8730': 1124,
            '8734': 1460,
            '8735': 2005,
            '8745': 1472,
            '8747': 561,
            '8776': 1124,
            '8800': 1124,
            '8801': 1195,
            '8802': 2048,
            '8804': 1124,
            '8805': 1124,
            '8962': 1237,
            '8976': 1196,
            '8992': 1237,
            '8993': 1237,
            '9472': 1451,
            '9474': 1280,
            '9484': 1451,
            '9488': 1451,
            '9492': 1451,
            '9496': 1451,
            '9500': 1451,
            '9508': 1451,
            '9516': 1451,
            '9524': 1451,
            '9532': 1451,
            '9552': 1451,
            '9553': 1451,
            '9554': 1451,
            '9555': 1451,
            '9556': 1451,
            '9557': 1451,
            '9558': 1451,
            '9559': 1451,
            '9560': 1451,
            '9561': 1451,
            '9562': 1451,
            '9563': 1451,
            '9564': 1451,
            '9565': 1451,
            '9566': 1451,
            '9567': 1451,
            '9568': 1451,
            '9569': 1451,
            '9570': 1451,
            '9571': 1451,
            '9572': 1451,
            '9573': 1451,
            '9574': 1451,
            '9575': 1451,
            '9576': 1451,
            '9577': 1451,
            '9578': 1451,
            '9579': 1451,
            '9580': 1451,
            '9600': 1451,
            '9604': 1451,
            '9608': 1451,
            '9612': 1451,
            '9616': 1451,
            '9617': 1451,
            '9618': 1451,
            '9619': 1493,
            '9632': 1237,
            '9633': 1237,
            '9642': 726,
            '9643': 726,
            '9644': 2048,
            '9650': 2027,
            '9658': 2027,
            '9660': 2027,
            '9668': 2027,
            '9674': 1012,
            '9675': 1237,
            '9676': 1217,
            '9679': 1237,
            '9680': 1237,
            '9681': 1237,
            '9682': 1237,
            '9683': 1237,
            '9684': 1237,
            '9685': 1237,
            '9686': 1237,
            '9687': 1237,
            '9688': 1237,
            '9689': 1237,
            '9702': 726,
            '9786': 2091,
            '9787': 2155,
            '9788': 1877,
            '9791': 1536,
            '9792': 1536,
            '9793': 1536,
            '9794': 1536,
            '9795': 1536,
            '9796': 1536,
            '9797': 1536,
            '9798': 1536,
            '9799': 1536,
            '9824': 1088,
            '9827': 1344,
            '9829': 1216,
            '9830': 1045,
            '9833': 2048,
            '9834': 1024,
            '9835': 1536,
            '9836': 2048,
            '9839': 1024,
            '11360': 1139,
            '11361': 455,
            '11362': 1139,
            '11363': 1366,
            '11364': 1479,
            '11365': 1139,
            '11366': 569,
            '11367': 1479,
            '11368': 1139,
            '11369': 1366,
            '11370': 1024,
            '11371': 1251,
            '11372': 1024,
            '11373': 1500,
            '11377': 1222,
            '11378': 2124,
            '11379': 1722,
            '11380': 1024,
            '11381': 1182,
            '11382': 871,
            '11383': 1328,
            '11799': 682,
            '42775': 0,
            '42776': 0,
            '42777': 0,
            '42778': 0,
            '42779': 1024,
            '42780': 1024,
            '42781': 569,
            '42782': 569,
            '42783': 569,
            '42784': 0,
            '42785': 0,
            '42888': 682,
            '42889': 569,
            '42890': 896,
            '42891': 391,
            '42892': 391,
            '64257': 1024,
            '64258': 1024,
            '64285': 532,
            '64286': 0,
            '64287': 1042,
            '64288': 1192,
            '64289': 1286,
            '64290': 1135,
            '64291': 1298,
            '64292': 1075,
            '64293': 1085,
            '64294': 1389,
            '64295': 1094,
            '64296': 1415,
            '64297': 1151,
            '64298': 1495,
            '64299': 1495,
            '64300': 1495,
            '64301': 1495,
            '64302': 1286,
            '64303': 1286,
            '64304': 1286,
            '64305': 1225,
            '64306': 866,
            '64307': 1135,
            '64308': 1298,
            '64309': 532,
            '64310': 662,
            '64312': 1337,
            '64313': 532,
            '64314': 1094,
            '64315': 1075,
            '64316': 1085,
            '64318': 1407,
            '64320': 797,
            '64321': 1343,
            '64323': 1276,
            '64324': 1249,
            '64326': 1116,
            '64327': 1208,
            '64328': 1094,
            '64329': 1495,
            '64330': 1415,
            '64331': 532,
            '64332': 1225,
            '64333': 1075,
            '64334': 1249,
            '64335': 1286,
            '65056': 0,
            '65057': 0,
            '65058': 0,
            '65059': 0,
            '65532': 2048,
        },
    },
    bold: {
        unitsPerEm: 2048,
        ascent: 1854,
        widths: {
            '32': 569,
            '33': 682,
            '34': 971,
            '35': 1139,
            '36': 1139,
            '37': 1821,
            '38': 1479,
            '39': 487,
            '40': 682,
            '41': 682,
            '42': 797,
            '43': 1196,
            '44': 569,
            '45': 682,
            '46': 569,
            '47': 569,
            '48': 1139,
            '49': 1139,
            '50': 1139,
            '51': 1139,
            '52': 1139,
            '53': 1139,
            '54': 1139,
            '55': 1139,
            '56': 1139,
            '57': 1139,
            '58': 682,
            '59': 682,
            '60': 1196,
            '61': 1196,
            '62': 1196,
            '63': 1251,
            '64': 1997,
            '65': 1479,
            '66': 1479,
            '67': 1479,
            '68': 1479,
            '69': 1366,
            '70': 1251,
            '71': 1593,
            '72': 1479,
            '73': 569,
            '74': 1139,
            '75': 1479,
            '76': 1251,
            '77': 1706,
            '78': 1479,
            '79': 1593,
            '80': 1366,
            '81': 1593,
            '82': 1479,
            '83': 1366,
            '84': 1251,
            '85': 1479,
            '86': 1366,
            '87': 1933,
            '88': 1366,
            '89': 1366,
            '90': 1251,
            '91': 682,
            '92': 569,
            '93': 682,
            '94': 1196,
            '95': 1139,
            '96': 682,
            '97': 1139,
            '98': 1251,
            '99': 1139,
            '100': 1251,
            '101': 1139,
            '102': 682,
            '103': 1251,
            '104': 1251,
            '105': 569,
            '106': 569,
            '107': 1139,
            '108': 569,
            '109': 1821,
            '110': 1251,
            '111': 1251,
            '112': 1251,
            '113': 1251,
            '114': 797,
            '115': 1139,
            '116': 682,
            '117': 1251,
            '118': 1139,
            '119': 1593,
            '120': 1139,
            '121': 1139,
            '122': 1024,
            '123': 797,
            '124': 573,
            '125': 797,
            '126': 1196,
            '160': 569,
            '161': 682,
            '162': 1139,
            '163': 1139,
            '164': 1139,
            '165': 1139,
            '166': 573,
            '167': 1139,
            '168': 682,
            '169': 1509,
            '170': 758,
            '171': 1139,
            '172': 1196,
            '173': 682,
            '174': 1509,
            '175': 1131,
            '176': 819,
            '177': 1124,
            '178': 682,
            '179': 682,
            '180': 682,
            '181': 1180,
            '182': 1139,
            '183': 682,
            '184': 682,
            '185': 682,
            '186': 748,
            '187': 1139,
            '188': 1708,
            '189': 1708,
            '190': 1708,
            '191': 1251,
            '192': 1479,
            '193': 1479,
            '194': 1479,
            '195': 1479,
            '196': 1479,
            '197': 1479,
            '198': 2048,
            '199': 1479,
            '200': 1366,
            '201': 1366,
            '202': 1366,
            '203': 1366,
            '204': 569,
            '205': 569,
            '206': 569,
            '207': 569,
            '208': 1479,
            '209': 1479,
            '210': 1593,
            '211': 1593,
            '212': 1593,
            '213': 1593,
            '214': 1593,
            '215': 1196,
            '216': 1593,
            '217': 1479,
            '218': 1479,
            '219': 1479,
            '220': 1479,
            '221': 1366,
            '222': 1366,
            '223': 1251,
            '224': 1139,
            '225': 1139,
            '226': 1139,
            '227': 1139,
            '228': 1139,
            '229': 1139,
            '230': 1821,
            '231': 1139,
            '232': 1139,
            '233': 1139,
            '234': 1139,
            '235': 1139,
            '236': 569,
            '237': 569,
            '238': 569,
            '239': 569,
            '240': 1251,
            '241': 1251,
            '242': 1251,
            '243': 1251,
            '244': 1251,
            '245': 1251,
            '246': 1251,
            '247': 1124,
            '248': 1251,
            '249': 1251,
            '250': 1251,
            '251': 1251,
            '252': 1251,
            '253': 1139,
            '254': 1251,
            '255': 1139,
            '256': 1479,
            '257': 1139,
            '258': 1479,
            '259': 1139,
            '260': 1479,
            '261': 1139,
            '262': 1479,
            '263': 1139,
            '264': 1479,
            '265': 1139,
            '266': 1479,
            '267': 1139,
            '268': 1479,
            '269': 1139,
            '270': 1479,
            '271': 1472,
            '272': 1479,
            '273': 1251,
            '274': 1366,
            '275': 1139,
            '276': 1366,
            '277': 1139,
            '278': 1366,
            '279': 1139,
            '280': 1366,
            '281': 1139,
            '282': 1366,
            '283': 1139,
            '284': 1593,
            '285': 1251,
            '286': 1593,
            '287': 1251,
            '288': 1593,
            '289': 1251,
            '290': 1593,
            '291': 1251,
            '292': 1479,
            '293': 1251,
            '294': 1479,
            '295': 1251,
            '296': 569,
            '297': 569,
            '298': 569,
            '299': 569,
            '300': 569,
            '301': 569,
            '302': 569,
            '303': 569,
            '304': 569,
            '305': 569,
            '306': 1607,
            '307': 1139,
            '308': 1139,
            '309': 569,
            '310': 1479,
            '311': 1139,
            '312': 1139,
            '313': 1251,
            '314': 569,
            '315': 1251,
            '316': 569,
            '317': 1251,
            '318': 789,
            '319': 1251,
            '320': 981,
            '321': 1251,
            '322': 569,
            '323': 1479,
            '324': 1251,
            '325': 1479,
            '326': 1251,
            '327': 1479,
            '328': 1251,
            '329': 1451,
            '330': 1481,
            '331': 1251,
            '332': 1593,
            '333': 1251,
            '334': 1593,
            '335': 1251,
            '336': 1593,
            '337': 1251,
            '338': 2048,
            '339': 1933,
            '340': 1479,
            '341': 797,
            '342': 1479,
            '343': 797,
            '344': 1479,
            '345': 797,
            '346': 1366,
            '347': 1139,
            '348': 1366,
            '349': 1139,
            '350': 1366,
            '351': 1139,
            '352': 1366,
            '353': 1139,
            '354': 1251,
            '355': 682,
            '356': 1251,
            '357': 981,
            '358': 1251,
            '359': 682,
            '360': 1479,
            '361': 1251,
            '362': 1479,
            '363': 1251,
            '364': 1479,
            '365': 1251,
            '366': 1479,
            '367': 1251,
            '368': 1479,
            '369': 1251,
            '370': 1479,
            '371': 1251,
            '372': 1933,
            '373': 1593,
            '374': 1366,
            '375': 1139,
            '376': 1366,
            '377': 1251,
            '378': 1024,
            '379': 1251,
            '380': 1024,
            '381': 1251,
            '382': 1024,
            '383': 569,
            '384': 1251,
            '385': 1713,
            '386': 1472,
            '387': 1251,
            '388': 1472,
            '389': 1251,
            '390': 1479,
            '391': 1479,
            '392': 1139,
            '393': 1479,
            '394': 1715,
            '395': 1472,
            '396': 1251,
            '397': 1242,
            '398': 1366,
            '399': 1487,
            '400': 1283,
            '401': 1251,
            '402': 1139,
            '403': 1593,
            '404': 1304,
            '405': 1906,
            '406': 569,
            '407': 569,
            '408': 1479,
            '409': 1139,
            '410': 569,
            '411': 1139,
            '412': 2031,
            '413': 1479,
            '414': 1251,
            '415': 1593,
            '416': 1747,
            '417': 1456,
            '418': 1816,
            '419': 1523,
            '420': 1601,
            '421': 1251,
            '422': 1366,
            '423': 1366,
            '424': 1139,
            '425': 1229,
            '426': 737,
            '427': 682,
            '428': 1251,
            '429': 682,
            '430': 1251,
            '431': 1699,
            '432': 1483,
            '433': 1642,
            '434': 1479,
            '435': 1577,
            '436': 1139,
            '437': 1251,
            '438': 1024,
            '439': 1251,
            '440': 1251,
            '441': 1078,
            '442': 1078,
            '443': 1139,
            '444': 1139,
            '445': 1018,
            '446': 1186,
            '447': 1251,
            '448': 573,
            '449': 1019,
            '450': 1197,
            '451': 682,
            '452': 2730,
            '453': 2503,
            '454': 2275,
            '455': 2390,
            '456': 1820,
            '457': 1138,
            '458': 2618,
            '459': 2048,
            '460': 1820,
            '461': 1479,
            '462': 1139,
            '463': 569,
            '464': 569,
            '465': 1593,
            '466': 1251,
            '467': 1479,
            '468': 1251,
            '469': 1479,
            '470': 1251,
            '471': 1479,
            '472': 1251,
            '473': 1479,
            '474': 1251,
            '475': 1479,
            '476': 1251,
            '477': 1139,
            '478': 1479,
            '479': 1139,
            '480': 1479,
            '481': 1139,
            '482': 2048,
            '483': 1821,
            '484': 1593,
            '485': 1251,
            '486': 1593,
            '487': 1251,
            '488': 1479,
            '489': 1139,
            '490': 1593,
            '491': 1251,
            '492': 1593,
            '493': 1251,
            '494': 1251,
            '495': 1078,
            '496': 569,
            '497': 2730,
            '498': 2503,
            '499': 2275,
            '500': 1593,
            '501': 1251,
            '502': 2115,
            '503': 1362,
            '504': 1479,
            '505': 1251,
            '506': 1479,
            '507': 1139,
            '508': 2048,
            '509': 1821,
            '510': 1593,
            '511': 1251,
            '512': 1479,
            '513': 1139,
            '514': 1479,
            '515': 1139,
            '516': 1366,
            '517': 1139,
            '518': 1366,
            '519': 1139,
            '520': 569,
            '521': 569,
            '522': 569,
            '523': 569,
            '524': 1593,
            '525': 1251,
            '526': 1593,
            '527': 1251,
            '528': 1479,
            '529': 797,
            '530': 1479,
            '531': 797,
            '532': 1479,
            '533': 1251,
            '534': 1479,
            '535': 1251,
            '536': 1366,
            '537': 1139,
            '538': 1251,
            '539': 682,
            '540': 1182,
            '541': 1065,
            '542': 1479,
            '543': 1251,
            '544': 1439,
            '545': 1715,
            '546': 1292,
            '547': 1292,
            '548': 1251,
            '549': 1024,
            '550': 1479,
            '551': 1139,
            '552': 1366,
            '553': 1139,
            '554': 1593,
            '555': 1251,
            '556': 1593,
            '557': 1251,
            '558': 1593,
            '559': 1251,
            '560': 1593,
            '561': 1251,
            '562': 1366,
            '563': 1139,
            '564': 1022,
            '565': 1707,
            '566': 1036,
            '567': 569,
            '568': 1953,
            '569': 1953,
            '570': 1479,
            '571': 1479,
            '572': 1139,
            '573': 1251,
            '574': 1251,
            '575': 1139,
            '576': 1024,
            '577': 1321,
            '578': 991,
            '579': 1479,
            '580': 1479,
            '581': 1366,
            '582': 1366,
            '583': 1139,
            '584': 1139,
            '585': 569,
            '586': 1587,
            '587': 1251,
            '588': 1479,
            '589': 797,
            '590': 1366,
            '591': 1139,
            '592': 1139,
            '593': 1251,
            '594': 1251,
            '595': 1251,
            '596': 1139,
            '597': 1139,
            '598': 1251,
            '599': 1251,
            '600': 1139,
            '601': 1139,
            '602': 1601,
            '603': 1018,
            '604': 1018,
            '605': 1415,
            '606': 1162,
            '607': 682,
            '608': 1251,
            '609': 1251,
            '610': 1200,
            '611': 1139,
            '612': 1230,
            '613': 1251,
            '614': 1251,
            '615': 1251,
            '616': 569,
            '617': 569,
            '618': 830,
            '619': 680,
            '620': 729,
            '621': 569,
            '622': 1236,
            '623': 1821,
            '624': 1821,
            '625': 1821,
            '626': 1251,
            '627': 1251,
            '628': 1259,
            '629': 1251,
            '630': 1707,
            '631': 1730,
            '632': 1535,
            '633': 797,
            '634': 797,
            '635': 797,
            '636': 797,
            '637': 797,
            '638': 797,
            '639': 797,
            '640': 1195,
            '641': 1195,
            '642': 1139,
            '643': 682,
            '644': 682,
            '645': 682,
            '646': 1105,
            '647': 682,
            '648': 682,
            '649': 1251,
            '650': 1272,
            '651': 1192,
            '652': 1139,
            '653': 1593,
            '654': 1139,
            '655': 1169,
            '656': 1024,
            '657': 1392,
            '658': 1078,
            '659': 1078,
            '660': 1139,
            '661': 1139,
            '662': 1139,
            '663': 1139,
            '664': 1593,
            '665': 1259,
            '666': 1162,
            '667': 1200,
            '668': 1237,
            '669': 939,
            '670': 1139,
            '671': 926,
            '672': 1251,
            '673': 1139,
            '674': 1139,
            '675': 2111,
            '676': 1929,
            '677': 2479,
            '678': 1666,
            '679': 1094,
            '680': 1688,
            '681': 1780,
            '682': 1589,
            '683': 1418,
            '684': 1093,
            '685': 1154,
            '686': 1494,
            '687': 1494,
            '688': 753,
            '689': 753,
            '690': 398,
            '691': 516,
            '692': 516,
            '693': 516,
            '694': 768,
            '695': 1071,
            '696': 738,
            '697': 487,
            '698': 971,
            '699': 569,
            '700': 569,
            '701': 569,
            '702': 682,
            '703': 682,
            '704': 768,
            '705': 768,
            '706': 1196,
            '707': 1196,
            '708': 1196,
            '709': 1196,
            '710': 682,
            '711': 682,
            '712': 682,
            '713': 682,
            '714': 682,
            '715': 682,
            '716': 682,
            '717': 682,
            '718': 682,
            '719': 682,
            '720': 682,
            '721': 682,
            '722': 682,
            '723': 682,
            '724': 682,
            '725': 682,
            '726': 682,
            '727': 682,
            '728': 682,
            '729': 682,
            '730': 682,
            '731': 682,
            '732': 682,
            '733': 682,
            '734': 682,
            '735': 682,
            '736': 749,
            '737': 289,
            '738': 770,
            '739': 750,
            '740': 768,
            '741': 784,
            '742': 784,
            '743': 784,
            '744': 784,
            '745': 784,
            '746': 682,
            '747': 682,
            '748': 682,
            '749': 682,
            '750': 1024,
            '751': 682,
            '752': 682,
            '753': 682,
            '754': 682,
            '755': 682,
            '756': 682,
            '757': 682,
            '758': 682,
            '759': 682,
            '760': 682,
            '761': 682,
            '762': 682,
            '763': 682,
            '764': 682,
            '765': 814,
            '766': 814,
            '767': 682,
            '768': 0,
            '769': 0,
            '770': 0,
            '771': 0,
            '772': 0,
            '773': 0,
            '774': 0,
            '775': 0,
            '776': 0,
            '777': 0,
            '778': 0,
            '779': 0,
            '780': 0,
            '781': 0,
            '782': 0,
            '783': 0,
            '784': 0,
            '785': 0,
            '786': 0,
            '787': 0,
            '788': 0,
            '789': 0,
            '790': 0,
            '791': 0,
            '792': 0,
            '793': 0,
            '794': 0,
            '795': 0,
            '796': 0,
            '797': 0,
            '798': 0,
            '799': 0,
            '800': 0,
            '801': 0,
            '802': 0,
            '803': 0,
            '804': 0,
            '805': 0,
            '806': 0,
            '807': 0,
            '808': 0,
            '809': 0,
            '810': 0,
            '811': 0,
            '812': 0,
            '813': 0,
            '814': 0,
            '815': 0,
            '816': 0,
            '817': 0,
            '818': 0,
            '819': 0,
            '820': 0,
            '821': 0,
            '822': 0,
            '823': 0,
            '824': 0,
            '825': 0,
            '826': 0,
            '827': 0,
            '828': 0,
            '829': 0,
            '830': 0,
            '831': 0,
            '832': 0,
            '833': 0,
            '834': 0,
            '835': 0,
            '836': 0,
            '837': 0,
            '838': 0,
            '839': 0,
            '840': 0,
            '841': 0,
            '842': 0,
            '843': 0,
            '844': 0,
            '845': 0,
            '846': 0,
            '847': 0,
            '848': 0,
            '849': 0,
            '850': 0,
            '851': 0,
            '852': 0,
            '853': 0,
            '854': 0,
            '855': 0,
            '856': 0,
            '857': 0,
            '858': 0,
            '859': 0,
            '860': 0,
            '861': 0,
            '862': 0,
            '863': 0,
            '864': 0,
            '865': 0,
            '866': 0,
            '867': 0,
            '868': 0,
            '869': 0,
            '870': 0,
            '871': 0,
            '872': 0,
            '873': 0,
            '874': 0,
            '875': 0,
            '876': 0,
            '877': 0,
            '878': 0,
            '879': 0,
            '884': 682,
            '885': 682,
            '890': 682,
            '891': 1139,
            '892': 1139,
            '893': 1139,
            '894': 682,
            '900': 682,
            '901': 952,
            '902': 1479,
            '903': 682,
            '904': 1747,
            '905': 1855,
            '906': 970,
            '908': 1689,
            '910': 1899,
            '911': 1716,
            '912': 569,
            '913': 1479,
            '914': 1479,
            '915': 1231,
            '916': 1472,
            '917': 1366,
            '918': 1251,
            '919': 1479,
            '920': 1593,
            '921': 569,
            '922': 1479,
            '923': 1366,
            '924': 1706,
            '925': 1479,
            '926': 1318,
            '927': 1593,
            '928': 1479,
            '929': 1366,
            '931': 1229,
            '932': 1251,
            '933': 1366,
            '934': 1681,
            '935': 1366,
            '936': 1657,
            '937': 1642,
            '938': 569,
            '939': 1366,
            '940': 1259,
            '941': 924,
            '942': 1251,
            '943': 569,
            '944': 1192,
            '945': 1259,
            '946': 1250,
            '947': 1139,
            '948': 1242,
            '949': 972,
            '950': 943,
            '951': 1251,
            '952': 1107,
            '953': 569,
            '954': 1142,
            '955': 1139,
            '956': 1253,
            '957': 1139,
            '958': 912,
            '959': 1251,
            '960': 1568,
            '961': 1267,
            '962': 1065,
            '963': 1401,
            '964': 914,
            '965': 1192,
            '966': 1465,
            '967': 1179,
            '968': 1543,
            '969': 1730,
            '970': 569,
            '971': 1192,
            '972': 1251,
            '973': 1192,
            '974': 1730,
            '976': 1250,
            '977': 1192,
            '978': 1577,
            '979': 2050,
            '980': 1577,
            '981': 1535,
            '982': 1730,
            '983': 1385,
            '984': 1593,
            '985': 1251,
            '986': 1479,
            '987': 1139,
            '988': 1251,
            '989': 926,
            '990': 1539,
            '991': 1084,
            '992': 1647,
            '993': 1250,
            '994': 2031,
            '995': 1821,
            '996': 1439,
            '997': 1251,
            '998': 1439,
            '999': 1239,
            '1000': 1366,
            '1001': 1366,
            '1002': 1316,
            '1003': 1236,
            '1004': 1505,
            '1005': 1184,
            '1006': 1038,
            '1007': 900,
            '1008': 1385,
            '1009': 1265,
            '1010': 1139,
            '1011': 569,
            '1012': 1593,
            '1013': 980,
            '1014': 980,
            '1015': 1366,
            '1016': 1251,
            '1017': 1479,
            '1018': 1706,
            '1019': 1515,
            '1020': 1267,
            '1021': 1479,
            '1022': 1479,
            '1023': 1479,
            '1024': 1366,
            '1025': 1370,
            '1026': 1813,
            '1027': 1161,
            '1028': 1457,
            '1029': 1366,
            '1030': 569,
            '1031': 565,
            '1032': 1139,
            '1033': 2240,
            '1034': 2176,
            '1035': 1792,
            '1036': 1250,
            '1037': 1472,
            '1038': 1274,
            '1039': 1472,
            '1040': 1479,
            '1041': 1472,
            '1042': 1479,
            '1043': 1161,
            '1044': 1459,
            '1045': 1366,
            '1046': 1851,
            '1047': 1283,
            '1048': 1472,
            '1049': 1472,
            '1050': 1250,
            '1051': 1437,
            '1052': 1706,
            '1053': 1479,
            '1054': 1593,
            '1055': 1472,
            '1056': 1366,
            '1057': 1479,
            '1058': 1251,
            '1059': 1274,
            '1060': 1748,
            '1061': 1366,
            '1062': 1496,
            '1063': 1439,
            '1064': 2058,
            '1065': 2087,
            '1066': 1781,
            '1067': 2005,
            '1068': 1472,
            '1069': 1457,
            '1070': 2112,
            '1071': 1472,
            '1072': 1139,
            '1073': 1265,
            '1074': 1259,
            '1075': 853,
            '1076': 1300,
            '1077': 1139,
            '1078': 1452,
            '1079': 1018,
            '1080': 1259,
            '1081': 1259,
            '1082': 1025,
            '1083': 1301,
            '1084': 1515,
            '1085': 1237,
            '1086': 1251,
            '1087': 1237,
            '1088': 1251,
            '1089': 1139,
            '1090': 1003,
            '1091': 1139,
            '1092': 1792,
            '1093': 1139,
            '1094': 1259,
            '1095': 1189,
            '1096': 1707,
            '1097': 1728,
            '1098': 1493,
            '1099': 1749,
            '1100': 1259,
            '1101': 1131,
            '1102': 1749,
            '1103': 1195,
            '1104': 1139,
            '1105': 1139,
            '1106': 1251,
            '1107': 853,
            '1108': 1131,
            '1109': 1139,
            '1110': 569,
            '1111': 576,
            '1112': 569,
            '1113': 1984,
            '1114': 1856,
            '1115': 1251,
            '1116': 1025,
            '1117': 1259,
            '1118': 1139,
            '1119': 1237,
            '1120': 2621,
            '1121': 1594,
            '1122': 1780,
            '1123': 1439,
            '1124': 1998,
            '1125': 1630,
            '1126': 1366,
            '1127': 1139,
            '1128': 1896,
            '1129': 1639,
            '1130': 1657,
            '1131': 1543,
            '1132': 2206,
            '1133': 2008,
            '1134': 1283,
            '1135': 1018,
            '1136': 1657,
            '1137': 1543,
            '1138': 1593,
            '1139': 1251,
            '1140': 1669,
            '1141': 1324,
            '1142': 1669,
            '1143': 1324,
            '1144': 2294,
            '1145': 1995,
            '1146': 1668,
            '1147': 1306,
            '1148': 2621,
            '1149': 1845,
            '1150': 2621,
            '1151': 1594,
            '1152': 1479,
            '1153': 1139,
            '1154': 1196,
            '1155': 0,
            '1156': 0,
            '1157': 0,
            '1158': 0,
            '1159': 0,
            '1160': 0,
            '1161': 0,
            '1162': 1472,
            '1163': 1259,
            '1164': 1472,
            '1165': 1259,
            '1166': 1366,
            '1167': 1251,
            '1168': 997,
            '1169': 915,
            '1170': 1161,
            '1171': 853,
            '1172': 1439,
            '1173': 1225,
            '1174': 1851,
            '1175': 1452,
            '1176': 1283,
            '1177': 1018,
            '1178': 1250,
            '1179': 1025,
            '1180': 1250,
            '1181': 1025,
            '1182': 1250,
            '1183': 1025,
            '1184': 1559,
            '1185': 1276,
            '1186': 1479,
            '1187': 1237,
            '1188': 1801,
            '1189': 1462,
            '1190': 2306,
            '1191': 1887,
            '1192': 1479,
            '1193': 1183,
            '1194': 1479,
            '1195': 1139,
            '1196': 1251,
            '1197': 1003,
            '1198': 1139,
            '1199': 1139,
            '1200': 1139,
            '1201': 1139,
            '1202': 1366,
            '1203': 1139,
            '1204': 1746,
            '1205': 1411,
            '1206': 1439,
            '1207': 1189,
            '1208': 1439,
            '1209': 1189,
            '1210': 1439,
            '1211': 1251,
            '1212': 1754,
            '1213': 1389,
            '1214': 1754,
            '1215': 1389,
            '1216': 569,
            '1217': 1851,
            '1218': 1452,
            '1219': 1437,
            '1220': 1224,
            '1221': 1437,
            '1222': 1301,
            '1223': 1479,
            '1224': 1237,
            '1225': 1479,
            '1226': 1237,
            '1227': 1439,
            '1228': 1189,
            '1229': 1706,
            '1230': 1515,
            '1231': 569,
            '1232': 1479,
            '1233': 1139,
            '1234': 1479,
            '1235': 1139,
            '1236': 2048,
            '1237': 1821,
            '1238': 1366,
            '1239': 1139,
            '1240': 1487,
            '1241': 1139,
            '1242': 1487,
            '1243': 1139,
            '1244': 1851,
            '1245': 1452,
            '1246': 1283,
            '1247': 1018,
            '1248': 1283,
            '1249': 1078,
            '1250': 1472,
            '1251': 1259,
            '1252': 1472,
            '1253': 1259,
            '1254': 1593,
            '1255': 1251,
            '1256': 1593,
            '1257': 1251,
            '1258': 1593,
            '1259': 1251,
            '1260': 1457,
            '1261': 1131,
            '1262': 1274,
            '1263': 1139,
            '1264': 1274,
            '1265': 1139,
            '1266': 1274,
            '1267': 1139,
            '1268': 1439,
            '1269': 1189,
            '1270': 1161,
            '1271': 853,
            '1272': 2005,
            '1273': 1749,
            '1274': 1161,
            '1275': 853,
            '1276': 1366,
            '1277': 1139,
            '1278': 1366,
            '1279': 1139,
            '1280': 1472,
            '1281': 1251,
            '1282': 2110,
            '1283': 1914,
            '1284': 1965,
            '1285': 1732,
            '1286': 1347,
            '1287': 1098,
            '1288': 2074,
            '1289': 1957,
            '1290': 2115,
            '1291': 1894,
            '1292': 1593,
            '1293': 1200,
            '1294': 1568,
            '1295': 1435,
            '1296': 1283,
            '1297': 1018,
            '1298': 1437,
            '1299': 1301,
            '1306': 1593,
            '1307': 1251,
            '1308': 1933,
            '1309': 1593,
            '1425': 0,
            '1426': 0,
            '1427': 0,
            '1428': 0,
            '1429': 0,
            '1430': 0,
            '1431': 0,
            '1432': 0,
            '1433': 0,
            '1434': 0,
            '1435': 0,
            '1436': 0,
            '1437': 0,
            '1438': 0,
            '1439': 0,
            '1440': 0,
            '1441': 0,
            '1442': 0,
            '1443': 0,
            '1444': 0,
            '1445': 0,
            '1446': 0,
            '1447': 0,
            '1448': 0,
            '1449': 0,
            '1450': 0,
            '1451': 0,
            '1452': 0,
            '1453': 0,
            '1454': 0,
            '1455': 0,
            '1456': 0,
            '1457': 0,
            '1458': 0,
            '1459': 0,
            '1460': 0,
            '1461': 0,
            '1462': 0,
            '1463': 0,
            '1464': 0,
            '1465': 0,
            '1466': 0,
            '1467': 0,
            '1468': 0,
            '1469': 0,
            '1470': 784,
            '1471': 0,
            '1472': 1153,
            '1473': 0,
            '1474': 0,
            '1475': 682,
            '1476': 0,
            '1477': 0,
            '1478': 862,
            '1479': 0,
            '1488': 1397,
            '1489': 1311,
            '1490': 981,
            '1491': 1192,
            '1492': 1384,
            '1493': 618,
            '1494': 748,
            '1495': 1434,
            '1496': 1409,
            '1497': 618,
            '1498': 1180,
            '1499': 1133,
            '1500': 1171,
            '1501': 1475,
            '1502': 1487,
            '1503': 618,
            '1504': 883,
            '1505': 1430,
            '1506': 1266,
            '1507': 1382,
            '1508': 1335,
            '1509': 1128,
            '1510': 1247,
            '1511': 1339,
            '1512': 1180,
            '1513': 1649,
            '1514': 1470,
            '1520': 1237,
            '1521': 1237,
            '1522': 1237,
            '1523': 831,
            '1524': 1278,
            '7424': 1205,
            '7425': 1589,
            '7426': 1821,
            '7427': 1259,
            '7428': 1139,
            '7429': 1177,
            '7430': 1177,
            '7431': 1025,
            '7432': 1018,
            '7433': 569,
            '7434': 1039,
            '7435': 1142,
            '7436': 926,
            '7437': 1515,
            '7438': 1259,
            '7439': 1251,
            '7440': 1139,
            '7441': 1265,
            '7442': 1265,
            '7443': 1265,
            '7444': 1933,
            '7445': 1170,
            '7446': 1251,
            '7447': 1251,
            '7448': 1257,
            '7449': 1195,
            '7450': 1195,
            '7451': 1003,
            '7452': 1192,
            '7453': 1251,
            '7454': 1572,
            '7455': 1248,
            '7456': 1139,
            '7457': 1593,
            '7458': 1024,
            '7459': 991,
            '7460': 1010,
            '7461': 1260,
            '7462': 853,
            '7463': 1139,
            '7464': 1237,
            '7465': 1257,
            '7466': 1543,
            '7467': 1301,
            '7468': 995,
            '7469': 1425,
            '7470': 930,
            '7471': 930,
            '7472': 931,
            '7473': 853,
            '7474': 853,
            '7475': 1027,
            '7476': 892,
            '7477': 370,
            '7478': 734,
            '7479': 944,
            '7480': 798,
            '7481': 1058,
            '7482': 887,
            '7483': 888,
            '7484': 1062,
            '7485': 890,
            '7486': 859,
            '7487': 940,
            '7488': 887,
            '7489': 891,
            '7490': 1300,
            '7491': 773,
            '7492': 773,
            '7493': 801,
            '7494': 1206,
            '7495': 801,
            '7496': 801,
            '7497': 770,
            '7498': 770,
            '7499': 719,
            '7500': 719,
            '7501': 800,
            '7502': 289,
            '7503': 714,
            '7504': 1156,
            '7505': 754,
            '7506': 840,
            '7507': 778,
            '7508': 841,
            '7509': 841,
            '7510': 800,
            '7511': 444,
            '7512': 754,
            '7513': 834,
            '7514': 1156,
            '7515': 745,
            '7516': 844,
            '7517': 795,
            '7518': 745,
            '7519': 835,
            '7520': 986,
            '7521': 776,
            '7522': 289,
            '7523': 516,
            '7524': 754,
            '7525': 745,
            '7526': 795,
            '7527': 745,
            '7528': 834,
            '7529': 986,
            '7530': 776,
            '7531': 1888,
            '7532': 1251,
            '7533': 1251,
            '7534': 682,
            '7535': 1821,
            '7536': 1251,
            '7537': 1251,
            '7538': 797,
            '7539': 797,
            '7540': 1139,
            '7541': 682,
            '7542': 1024,
            '7543': 1251,
            '7544': 752,
            '7545': 1244,
            '7546': 1787,
            '7547': 569,
            '7548': 569,
            '7549': 1251,
            '7550': 1192,
            '7551': 1272,
            '7552': 1251,
            '7553': 1251,
            '7554': 682,
            '7555': 1573,
            '7556': 1139,
            '7557': 569,
            '7558': 1821,
            '7559': 1251,
            '7560': 1251,
            '7561': 797,
            '7562': 1139,
            '7563': 954,
            '7564': 1139,
            '7565': 1139,
            '7566': 1024,
            '7567': 1139,
            '7568': 1251,
            '7569': 1251,
            '7570': 1139,
            '7571': 1018,
            '7572': 1018,
            '7573': 1342,
            '7574': 569,
            '7575': 1139,
            '7576': 682,
            '7577': 1251,
            '7578': 1078,
            '7579': 801,
            '7580': 778,
            '7581': 778,
            '7582': 840,
            '7583': 719,
            '7584': 496,
            '7585': 496,
            '7586': 800,
            '7587': 753,
            '7588': 372,
            '7589': 289,
            '7590': 289,
            '7591': 372,
            '7592': 630,
            '7593': 398,
            '7594': 336,
            '7595': 585,
            '7596': 1156,
            '7597': 1156,
            '7598': 863,
            '7599': 863,
            '7600': 762,
            '7601': 840,
            '7602': 1027,
            '7603': 770,
            '7604': 569,
            '7605': 444,
            '7606': 832,
            '7607': 862,
            '7608': 746,
            '7609': 746,
            '7610': 745,
            '7611': 740,
            '7612': 740,
            '7613': 958,
            '7614': 778,
            '7615': 744,
            '7616': 0,
            '7617': 0,
            '7618': 0,
            '7619': 0,
            '7620': 0,
            '7621': 0,
            '7622': 0,
            '7623': 0,
            '7624': 0,
            '7625': 0,
            '7626': 0,
            '7678': 0,
            '7679': 0,
            '7680': 1479,
            '7681': 1139,
            '7682': 1479,
            '7683': 1251,
            '7684': 1479,
            '7685': 1251,
            '7686': 1479,
            '7687': 1251,
            '7688': 1479,
            '7689': 1139,
            '7690': 1479,
            '7691': 1251,
            '7692': 1479,
            '7693': 1251,
            '7694': 1479,
            '7695': 1251,
            '7696': 1479,
            '7697': 1251,
            '7698': 1479,
            '7699': 1251,
            '7700': 1366,
            '7701': 1139,
            '7702': 1366,
            '7703': 1139,
            '7704': 1366,
            '7705': 1139,
            '7706': 1366,
            '7707': 1139,
            '7708': 1366,
            '7709': 1139,
            '7710': 1251,
            '7711': 682,
            '7712': 1593,
            '7713': 1251,
            '7714': 1479,
            '7715': 1251,
            '7716': 1479,
            '7717': 1251,
            '7718': 1479,
            '7719': 1251,
            '7720': 1479,
            '7721': 1251,
            '7722': 1479,
            '7723': 1251,
            '7724': 569,
            '7725': 569,
            '7726': 569,
            '7727': 569,
            '7728': 1479,
            '7729': 1139,
            '7730': 1479,
            '7731': 1139,
            '7732': 1479,
            '7733': 1139,
            '7734': 1251,
            '7735': 569,
            '7736': 1251,
            '7737': 569,
            '7738': 1251,
            '7739': 569,
            '7740': 1251,
            '7741': 569,
            '7742': 1706,
            '7743': 1821,
            '7744': 1706,
            '7745': 1821,
            '7746': 1706,
            '7747': 1821,
            '7748': 1479,
            '7749': 1251,
            '7750': 1479,
            '7751': 1251,
            '7752': 1479,
            '7753': 1251,
            '7754': 1479,
            '7755': 1251,
            '7756': 1593,
            '7757': 1251,
            '7758': 1593,
            '7759': 1251,
            '7760': 1593,
            '7761': 1251,
            '7762': 1593,
            '7763': 1251,
            '7764': 1366,
            '7765': 1251,
            '7766': 1366,
            '7767': 1251,
            '7768': 1479,
            '7769': 797,
            '7770': 1479,
            '7771': 797,
            '7772': 1479,
            '7773': 797,
            '7774': 1479,
            '7775': 797,
            '7776': 1366,
            '7777': 1139,
            '7778': 1366,
            '7779': 1139,
            '7780': 1366,
            '7781': 1139,
            '7782': 1366,
            '7783': 1139,
            '7784': 1366,
            '7785': 1139,
            '7786': 1251,
            '7787': 682,
            '7788': 1251,
            '7789': 682,
            '7790': 1251,
            '7791': 682,
            '7792': 1251,
            '7793': 682,
            '7794': 1479,
            '7795': 1251,
            '7796': 1479,
            '7797': 1251,
            '7798': 1479,
            '7799': 1251,
            '7800': 1479,
            '7801': 1251,
            '7802': 1479,
            '7803': 1251,
            '7804': 1366,
            '7805': 1139,
            '7806': 1366,
            '7807': 1139,
            '7808': 1933,
            '7809': 1593,
            '7810': 1933,
            '7811': 1593,
            '7812': 1933,
            '7813': 1593,
            '7814': 1933,
            '7815': 1593,
            '7816': 1933,
            '7817': 1593,
            '7818': 1366,
            '7819': 1139,
            '7820': 1366,
            '7821': 1139,
            '7822': 1366,
            '7823': 1139,
            '7824': 1251,
            '7825': 1024,
            '7826': 1251,
            '7827': 1024,
            '7828': 1251,
            '7829': 1024,
            '7830': 1251,
            '7831': 682,
            '7832': 1593,
            '7833': 1139,
            '7834': 1139,
            '7835': 569,
            '7838': 1465,
            '7840': 1479,
            '7841': 1139,
            '7842': 1479,
            '7843': 1139,
            '7844': 1479,
            '7845': 1139,
            '7846': 1479,
            '7847': 1139,
            '7848': 1479,
            '7849': 1139,
            '7850': 1479,
            '7851': 1139,
            '7852': 1479,
            '7853': 1139,
            '7854': 1479,
            '7855': 1139,
            '7856': 1479,
            '7857': 1139,
            '7858': 1479,
            '7859': 1139,
            '7860': 1479,
            '7861': 1139,
            '7862': 1479,
            '7863': 1139,
            '7864': 1366,
            '7865': 1139,
            '7866': 1366,
            '7867': 1139,
            '7868': 1366,
            '7869': 1139,
            '7870': 1366,
            '7871': 1139,
            '7872': 1366,
            '7873': 1139,
            '7874': 1366,
            '7875': 1139,
            '7876': 1366,
            '7877': 1139,
            '7878': 1366,
            '7879': 1139,
            '7880': 569,
            '7881': 569,
            '7882': 569,
            '7883': 569,
            '7884': 1593,
            '7885': 1251,
            '7886': 1593,
            '7887': 1251,
            '7888': 1593,
            '7889': 1251,
            '7890': 1593,
            '7891': 1251,
            '7892': 1593,
            '7893': 1251,
            '7894': 1593,
            '7895': 1251,
            '7896': 1593,
            '7897': 1251,
            '7898': 1747,
            '7899': 1456,
            '7900': 1747,
            '7901': 1456,
            '7902': 1747,
            '7903': 1456,
            '7904': 1747,
            '7905': 1456,
            '7906': 1747,
            '7907': 1456,
            '7908': 1479,
            '7909': 1251,
            '7910': 1479,
            '7911': 1251,
            '7912': 1699,
            '7913': 1483,
            '7914': 1699,
            '7915': 1483,
            '7916': 1699,
            '7917': 1483,
            '7918': 1699,
            '7919': 1483,
            '7920': 1699,
            '7921': 1483,
            '7922': 1366,
            '7923': 1139,
            '7924': 1366,
            '7925': 1139,
            '7926': 1366,
            '7927': 1139,
            '7928': 1366,
            '7929': 1139,
            '7936': 1259,
            '7937': 1259,
            '7938': 1259,
            '7939': 1259,
            '7940': 1259,
            '7941': 1259,
            '7942': 1259,
            '7943': 1259,
            '7944': 1479,
            '7945': 1479,
            '7946': 1779,
            '7947': 1779,
            '7948': 1779,
            '7949': 1779,
            '7950': 1779,
            '7951': 1779,
            '7952': 972,
            '7953': 972,
            '7954': 972,
            '7955': 972,
            '7956': 972,
            '7957': 972,
            '7960': 1566,
            '7961': 1566,
            '7962': 1966,
            '7963': 1966,
            '7964': 1966,
            '7965': 1966,
            '7968': 1251,
            '7969': 1251,
            '7970': 1251,
            '7971': 1251,
            '7972': 1251,
            '7973': 1251,
            '7974': 1251,
            '7975': 1251,
            '7976': 1679,
            '7977': 1679,
            '7978': 2079,
            '7979': 2079,
            '7980': 2079,
            '7981': 2079,
            '7982': 2079,
            '7983': 2079,
            '7984': 569,
            '7985': 569,
            '7986': 569,
            '7987': 569,
            '7988': 569,
            '7989': 569,
            '7990': 569,
            '7991': 569,
            '7992': 769,
            '7993': 769,
            '7994': 1169,
            '7995': 1169,
            '7996': 1169,
            '7997': 1169,
            '7998': 1169,
            '7999': 1169,
            '8000': 1251,
            '8001': 1251,
            '8002': 1251,
            '8003': 1251,
            '8004': 1251,
            '8005': 1251,
            '8008': 1693,
            '8009': 1693,
            '8010': 2133,
            '8011': 2133,
            '8012': 1993,
            '8013': 1993,
            '8016': 1192,
            '8017': 1192,
            '8018': 1192,
            '8019': 1192,
            '8020': 1192,
            '8021': 1192,
            '8022': 1192,
            '8023': 1192,
            '8025': 1666,
            '8027': 2046,
            '8029': 2146,
            '8031': 1966,
            '8032': 1730,
            '8033': 1730,
            '8034': 1730,
            '8035': 1730,
            '8036': 1730,
            '8037': 1730,
            '8038': 1730,
            '8039': 1730,
            '8040': 1742,
            '8041': 1742,
            '8042': 2182,
            '8043': 2182,
            '8044': 2042,
            '8045': 2042,
            '8046': 2042,
            '8047': 2042,
            '8048': 1259,
            '8049': 1259,
            '8050': 972,
            '8051': 972,
            '8052': 1251,
            '8053': 1251,
            '8054': 569,
            '8055': 569,
            '8056': 1251,
            '8057': 1251,
            '8058': 1192,
            '8059': 1192,
            '8060': 1730,
            '8061': 1730,
            '8064': 1259,
            '8065': 1259,
            '8066': 1259,
            '8067': 1259,
            '8068': 1259,
            '8069': 1259,
            '8070': 1259,
            '8071': 1259,
            '8072': 1479,
            '8073': 1479,
            '8074': 1779,
            '8075': 1779,
            '8076': 1779,
            '8077': 1779,
            '8078': 1779,
            '8079': 1779,
            '8080': 1251,
            '8081': 1251,
            '8082': 1251,
            '8083': 1251,
            '8084': 1251,
            '8085': 1251,
            '8086': 1251,
            '8087': 1251,
            '8088': 1679,
            '8089': 1679,
            '8090': 2079,
            '8091': 2079,
            '8092': 2079,
            '8093': 2079,
            '8094': 2079,
            '8095': 2079,
            '8096': 1730,
            '8097': 1730,
            '8098': 1730,
            '8099': 1730,
            '8100': 1730,
            '8101': 1730,
            '8102': 1730,
            '8103': 1730,
            '8104': 1742,
            '8105': 1742,
            '8106': 2182,
            '8107': 2182,
            '8108': 2042,
            '8109': 2042,
            '8110': 2042,
            '8111': 2042,
            '8112': 1259,
            '8113': 1259,
            '8114': 1259,
            '8115': 1259,
            '8116': 1259,
            '8118': 1259,
            '8119': 1259,
            '8120': 1479,
            '8121': 1479,
            '8122': 1479,
            '8123': 1479,
            '8124': 1479,
            '8125': 682,
            '8126': 682,
            '8127': 682,
            '8128': 682,
            '8129': 682,
            '8130': 1251,
            '8131': 1251,
            '8132': 1251,
            '8134': 1251,
            '8135': 1251,
            '8136': 1766,
            '8137': 1766,
            '8138': 1879,
            '8139': 1879,
            '8140': 1479,
            '8141': 682,
            '8142': 682,
            '8143': 682,
            '8144': 569,
            '8145': 569,
            '8146': 569,
            '8147': 569,
            '8150': 569,
            '8151': 569,
            '8152': 569,
            '8153': 569,
            '8154': 969,
            '8155': 969,
            '8157': 682,
            '8158': 682,
            '8159': 682,
            '8160': 1192,
            '8161': 1192,
            '8162': 1192,
            '8163': 1192,
            '8164': 1267,
            '8165': 1267,
            '8166': 1192,
            '8167': 1192,
            '8168': 1366,
            '8169': 1366,
            '8170': 1766,
            '8171': 1866,
            '8172': 1566,
            '8173': 952,
            '8174': 952,
            '8175': 682,
            '8178': 1730,
            '8179': 1730,
            '8180': 1730,
            '8182': 1730,
            '8183': 1730,
            '8184': 1893,
            '8185': 1693,
            '8186': 1942,
            '8187': 1742,
            '8188': 1642,
            '8189': 682,
            '8190': 682,
            '8192': 1024,
            '8193': 2048,
            '8194': 1024,
            '8195': 2048,
            '8196': 683,
            '8197': 512,
            '8198': 341,
            '8199': 1139,
            '8200': 569,
            '8201': 410,
            '8202': 171,
            '8203': 0,
            '8204': 0,
            '8205': 0,
            '8206': 0,
            '8207': 0,
            '8208': 682,
            '8210': 1139,
            '8211': 1139,
            '8212': 2048,
            '8213': 2048,
            '8214': 1019,
            '8215': 1131,
            '8216': 569,
            '8217': 569,
            '8218': 569,
            '8219': 569,
            '8220': 1024,
            '8221': 1024,
            '8222': 1024,
            '8223': 1024,
            '8224': 1139,
            '8225': 1139,
            '8226': 717,
            '8230': 2048,
            '8234': 0,
            '8235': 0,
            '8236': 0,
            '8237': 0,
            '8238': 0,
            '8239': 410,
            '8240': 2048,
            '8242': 491,
            '8243': 981,
            '8244': 981,
            '8249': 682,
            '8250': 682,
            '8252': 1237,
            '8254': 682,
            '8260': 342,
            '8286': 682,
            '8298': 0,
            '8299': 0,
            '8300': 0,
            '8301': 0,
            '8302': 0,
            '8303': 0,
            '8308': 1013,
            '8309': 962,
            '8310': 943,
            '8311': 845,
            '8312': 968,
            '8313': 972,
            '8319': 811,
            '8320': 923,
            '8321': 847,
            '8322': 910,
            '8323': 947,
            '8324': 976,
            '8325': 939,
            '8326': 930,
            '8327': 819,
            '8328': 959,
            '8329': 922,
            '8336': 773,
            '8337': 770,
            '8338': 840,
            '8339': 750,
            '8340': 770,
            '8352': 1139,
            '8353': 1479,
            '8354': 1479,
            '8355': 1139,
            '8356': 1139,
            '8357': 1821,
            '8358': 1479,
            '8359': 2240,
            '8360': 2509,
            '8361': 1933,
            '8362': 1810,
            '8363': 1051,
            '8364': 1139,
            '8365': 1479,
            '8366': 1251,
            '8367': 2224,
            '8368': 1139,
            '8369': 1366,
            '8370': 1593,
            '8371': 1479,
            '8372': 1366,
            '8373': 1479,
            '8383': 1669,
            '8432': 0,
            '8453': 1813,
            '8467': 1001,
            '8470': 2283,
            '8471': 1509,
            '8482': 2048,
            '8486': 1573,
            '8494': 1229,
            '8525': 2048,
            '8526': 1025,
            '8531': 1708,
            '8532': 1708,
            '8539': 1708,
            '8540': 1708,
            '8541': 1708,
            '8542': 1708,
            '8580': 1139,
            '8592': 2048,
            '8593': 1024,
            '8594': 2048,
            '8595': 1024,
            '8596': 2048,
            '8597': 1024,
            '8616': 1024,
            '8660': 2048,
            '8706': 1012,
            '8710': 1253,
            '8719': 1686,
            '8721': 1460,
            '8722': 1196,
            '8725': 342,
            '8729': 569,
            '8730': 1124,
            '8734': 1460,
            '8735': 2005,
            '8745': 1479,
            '8747': 561,
            '8776': 1124,
            '8800': 1124,
            '8801': 1195,
            '8802': 2048,
            '8804': 1124,
            '8805': 1124,
            '8962': 1237,
            '8976': 1196,
            '8992': 1237,
            '8993': 1237,
            '9472': 1451,
            '9474': 1280,
            '9484': 1451,
            '9488': 1451,
            '9492': 1451,
            '9496': 1451,
            '9500': 1451,
            '9508': 1451,
            '9516': 1451,
            '9524': 1451,
            '9532': 1451,
            '9552': 1451,
            '9553': 1451,
            '9554': 1451,
            '9555': 1451,
            '9556': 1451,
            '9557': 1451,
            '9558': 1451,
            '9559': 1451,
            '9560': 1451,
            '9561': 1451,
            '9562': 1451,
            '9563': 1451,
            '9564': 1451,
            '9565': 1451,
            '9566': 1451,
            '9567': 1451,
            '9568': 1451,
            '9569': 1451,
            '9570': 1451,
            '9571': 1451,
            '9572': 1451,
            '9573': 1451,
            '9574': 1451,
            '9575': 1451,
            '9576': 1451,
            '9577': 1451,
            '9578': 1451,
            '9579': 1451,
            '9580': 1451,
            '9600': 1451,
            '9604': 1451,
            '9608': 1451,
            '9612': 1451,
            '9616': 1451,
            '9617': 1451,
            '9618': 1451,
            '9619': 1493,
            '9632': 1237,
            '9633': 1237,
            '9642': 726,
            '9643': 726,
            '9644': 2048,
            '9650': 2027,
            '9658': 2027,
            '9660': 2027,
            '9668': 2027,
            '9674': 1012,
            '9675': 1237,
            '9676': 1217,
            '9679': 1237,
            '9680': 1237,
            '9681': 1237,
            '9682': 1237,
            '9683': 1237,
            '9684': 1237,
            '9685': 1237,
            '9686': 1237,
            '9687': 1237,
            '9688': 1237,
            '9689': 1237,
            '9702': 726,
            '9786': 2091,
            '9787': 2155,
            '9788': 1877,
            '9791': 1536,
            '9792': 1536,
            '9793': 1536,
            '9794': 1536,
            '9795': 1536,
            '9796': 1536,
            '9797': 1536,
            '9798': 1536,
            '9799': 1536,
            '9824': 1088,
            '9827': 1344,
            '9829': 1216,
            '9830': 1045,
            '9833': 2048,
            '9834': 1024,
            '9835': 1536,
            '9836': 2048,
            '9839': 1024,
            '11360': 1251,
            '11361': 569,
            '11362': 1251,
            '11363': 1366,
            '11364': 1479,
            '11365': 1139,
            '11366': 682,
            '11367': 1479,
            '11368': 1251,
            '11369': 1479,
            '11370': 1139,
            '11371': 1251,
            '11372': 1024,
            '11373': 1563,
            '11377': 1241,
            '11378': 2139,
            '11379': 1758,
            '11380': 1139,
            '11381': 1108,
            '11382': 892,
            '11383': 1465,
            '11799': 682,
            '42775': 0,
            '42776': 0,
            '42777': 0,
            '42778': 0,
            '42779': 1024,
            '42780': 1024,
            '42781': 682,
            '42782': 682,
            '42783': 682,
            '42784': 0,
            '42785': 0,
            '42888': 682,
            '42889': 682,
            '42890': 796,
            '42891': 487,
            '42892': 487,
            '64257': 1251,
            '64258': 1251,
            '64285': 618,
            '64286': 0,
            '64287': 1237,
            '64288': 1266,
            '64289': 1397,
            '64290': 1192,
            '64291': 1384,
            '64292': 1133,
            '64293': 1171,
            '64294': 1475,
            '64295': 1180,
            '64296': 1470,
            '64297': 1237,
            '64298': 1649,
            '64299': 1649,
            '64300': 1649,
            '64301': 1649,
            '64302': 1397,
            '64303': 1397,
            '64304': 1397,
            '64305': 1311,
            '64306': 981,
            '64307': 1192,
            '64308': 1384,
            '64309': 618,
            '64310': 748,
            '64312': 1409,
            '64313': 618,
            '64314': 1180,
            '64315': 1133,
            '64316': 1171,
            '64318': 1487,
            '64320': 883,
            '64321': 1430,
            '64323': 1382,
            '64324': 1335,
            '64326': 1247,
            '64327': 1339,
            '64328': 1180,
            '64329': 1649,
            '64330': 1470,
            '64331': 618,
            '64332': 1311,
            '64333': 1133,
            '64334': 1335,
            '64335': 1368,
            '65056': 0,
            '65057': 0,
            '65058': 0,
            '65059': 0,
            '65532': 2048,
        },
    },
    italic: {
        unitsPerEm: 2048,
        ascent: 1854,
        widths: {
            '32': 569,
            '33': 569,
            '34': 727,
            '35': 1139,
            '36': 1139,
            '37': 1821,
            '38': 1366,
            '39': 391,
            '40': 682,
            '41': 682,
            '42': 797,
            '43': 1196,
            '44': 569,
            '45': 682,
            '46': 569,
            '47': 569,
            '48': 1139,
            '49': 1139,
            '50': 1139,
            '51': 1139,
            '52': 1139,
            '53': 1139,
            '54': 1139,
            '55': 1139,
            '56': 1139,
            '57': 1139,
            '58': 569,
            '59': 569,
            '60': 1196,
            '61': 1196,
            '62': 1196,
            '63': 1139,
            '64': 2079,
            '65': 1366,
            '66': 1366,
            '67': 1479,
            '68': 1479,
            '69': 1366,
            '70': 1251,
            '71': 1593,
            '72': 1479,
            '73': 569,
            '74': 1024,
            '75': 1366,
            '76': 1139,
            '77': 1706,
            '78': 1479,
            '79': 1593,
            '80': 1366,
            '81': 1593,
            '82': 1479,
            '83': 1366,
            '84': 1251,
            '85': 1479,
            '86': 1366,
            '87': 1933,
            '88': 1366,
            '89': 1366,
            '90': 1251,
            '91': 569,
            '92': 569,
            '93': 569,
            '94': 961,
            '95': 1139,
            '96': 682,
            '97': 1139,
            '98': 1139,
            '99': 1024,
            '100': 1139,
            '101': 1139,
            '102': 569,
            '103': 1139,
            '104': 1139,
            '105': 455,
            '106': 455,
            '107': 1024,
            '108': 455,
            '109': 1706,
            '110': 1139,
            '111': 1139,
            '112': 1139,
            '113': 1139,
            '114': 682,
            '115': 1024,
            '116': 569,
            '117': 1139,
            '118': 1024,
            '119': 1479,
            '120': 1024,
            '121': 1024,
            '122': 1024,
            '123': 684,
            '124': 532,
            '125': 684,
            '126': 1196,
            '160': 569,
            '161': 682,
            '162': 1139,
            '163': 1139,
            '164': 1139,
            '165': 1139,
            '166': 532,
            '167': 1139,
            '168': 682,
            '169': 1509,
            '170': 758,
            '171': 1139,
            '172': 1196,
            '173': 682,
            '174': 1509,
            '175': 1131,
            '176': 819,
            '177': 1124,
            '178': 682,
            '179': 682,
            '180': 682,
            '181': 1180,
            '182': 1100,
            '183': 682,
            '184': 682,
            '185': 682,
            '186': 748,
            '187': 1139,
            '188': 1708,
            '189': 1708,
            '190': 1708,
            '191': 1251,
            '192': 1366,
            '193': 1366,
            '194': 1366,
            '195': 1366,
            '196': 1366,
            '197': 1366,
            '198': 2048,
            '199': 1479,
            '200': 1366,
            '201': 1366,
            '202': 1366,
            '203': 1366,
            '204': 569,
            '205': 569,
            '206': 569,
            '207': 569,
            '208': 1479,
            '209': 1479,
            '210': 1593,
            '211': 1593,
            '212': 1593,
            '213': 1593,
            '214': 1593,
            '215': 1196,
            '216': 1593,
            '217': 1479,
            '218': 1479,
            '219': 1479,
            '220': 1479,
            '221': 1366,
            '222': 1366,
            '223': 1251,
            '224': 1139,
            '225': 1139,
            '226': 1139,
            '227': 1139,
            '228': 1139,
            '229': 1139,
            '230': 1821,
            '231': 1024,
            '232': 1139,
            '233': 1139,
            '234': 1139,
            '235': 1139,
            '236': 569,
            '237': 569,
            '238': 569,
            '239': 569,
            '240': 1139,
            '241': 1139,
            '242': 1139,
            '243': 1139,
            '244': 1139,
            '245': 1139,
            '246': 1139,
            '247': 1124,
            '248': 1251,
            '249': 1139,
            '250': 1139,
            '251': 1139,
            '252': 1139,
            '253': 1024,
            '254': 1139,
            '255': 1024,
            '256': 1366,
            '257': 1139,
            '258': 1366,
            '259': 1139,
            '260': 1366,
            '261': 1139,
            '262': 1479,
            '263': 1024,
            '264': 1479,
            '265': 1024,
            '266': 1479,
            '267': 1024,
            '268': 1479,
            '269': 1024,
            '270': 1479,
            '271': 1280,
            '272': 1479,
            '273': 1139,
            '274': 1366,
            '275': 1139,
            '276': 1366,
            '277': 1139,
            '278': 1366,
            '279': 1139,
            '280': 1366,
            '281': 1139,
            '282': 1366,
            '283': 1139,
            '284': 1593,
            '285': 1139,
            '286': 1593,
            '287': 1139,
            '288': 1593,
            '289': 1139,
            '290': 1593,
            '291': 1139,
            '292': 1479,
            '293': 1139,
            '294': 1479,
            '295': 1139,
            '296': 569,
            '297': 455,
            '298': 569,
            '299': 455,
            '300': 569,
            '301': 455,
            '302': 569,
            '303': 455,
            '304': 569,
            '305': 569,
            '306': 1502,
            '307': 909,
            '308': 1024,
            '309': 455,
            '310': 1366,
            '311': 1024,
            '312': 1024,
            '313': 1139,
            '314': 455,
            '315': 1139,
            '316': 455,
            '317': 1139,
            '318': 576,
            '319': 1139,
            '320': 819,
            '321': 1139,
            '322': 455,
            '323': 1479,
            '324': 1139,
            '325': 1479,
            '326': 1139,
            '327': 1479,
            '328': 1139,
            '329': 1259,
            '330': 1481,
            '331': 1139,
            '332': 1593,
            '333': 1139,
            '334': 1593,
            '335': 1139,
            '336': 1593,
            '337': 1139,
            '338': 2048,
            '339': 1933,
            '340': 1479,
            '341': 682,
            '342': 1479,
            '343': 682,
            '344': 1479,
            '345': 682,
            '346': 1366,
            '347': 1024,
            '348': 1366,
            '349': 1024,
            '350': 1366,
            '351': 1024,
            '352': 1366,
            '353': 1024,
            '354': 1251,
            '355': 569,
            '356': 1251,
            '357': 725,
            '358': 1251,
            '359': 569,
            '360': 1479,
            '361': 1139,
            '362': 1479,
            '363': 1139,
            '364': 1479,
            '365': 1139,
            '366': 1479,
            '367': 1139,
            '368': 1479,
            '369': 1139,
            '370': 1479,
            '371': 1139,
            '372': 1933,
            '373': 1479,
            '374': 1366,
            '375': 1024,
            '376': 1366,
            '377': 1251,
            '378': 1024,
            '379': 1251,
            '380': 1024,
            '381': 1251,
            '382': 1024,
            '383': 455,
            '384': 1139,
            '385': 1496,
            '386': 1333,
            '387': 1139,
            '388': 1333,
            '389': 1139,
            '390': 1479,
            '391': 1479,
            '392': 1024,
            '393': 1479,
            '394': 1606,
            '395': 1333,
            '396': 1139,
            '397': 1138,
            '398': 1366,
            '399': 1593,
            '400': 1257,
            '401': 1251,
            '402': 1139,
            '403': 1593,
            '404': 1017,
            '405': 1801,
            '406': 455,
            '407': 569,
            '408': 1366,
            '409': 1024,
            '410': 455,
            '411': 1008,
            '412': 1733,
            '413': 1479,
            '414': 1139,
            '415': 1593,
            '416': 1662,
            '417': 1238,
            '418': 1778,
            '419': 1367,
            '420': 1496,
            '421': 1139,
            '422': 1366,
            '423': 1366,
            '424': 1024,
            '425': 1228,
            '426': 682,
            '427': 569,
            '428': 1251,
            '429': 569,
            '430': 1251,
            '431': 1625,
            '432': 1298,
            '433': 1558,
            '434': 1479,
            '435': 1469,
            '436': 1024,
            '437': 1251,
            '438': 1024,
            '439': 1251,
            '440': 1251,
            '441': 1024,
            '442': 1024,
            '443': 1139,
            '444': 1045,
            '445': 897,
            '446': 1024,
            '447': 1139,
            '448': 532,
            '449': 846,
            '450': 1196,
            '451': 569,
            '452': 2730,
            '453': 2503,
            '454': 2163,
            '455': 2163,
            '456': 1594,
            '457': 910,
            '458': 2503,
            '459': 1934,
            '460': 1594,
            '461': 1366,
            '462': 1139,
            '463': 569,
            '464': 455,
            '465': 1593,
            '466': 1139,
            '467': 1479,
            '468': 1139,
            '469': 1479,
            '470': 1139,
            '471': 1479,
            '472': 1139,
            '473': 1479,
            '474': 1139,
            '475': 1479,
            '476': 1139,
            '477': 1139,
            '478': 1366,
            '479': 1139,
            '480': 1366,
            '481': 1139,
            '482': 2048,
            '483': 1821,
            '484': 1593,
            '485': 1139,
            '486': 1593,
            '487': 1139,
            '488': 1366,
            '489': 1024,
            '490': 1593,
            '491': 1139,
            '492': 1593,
            '493': 1139,
            '494': 1251,
            '495': 1024,
            '496': 455,
            '497': 2730,
            '498': 2503,
            '499': 2163,
            '500': 1593,
            '501': 1139,
            '502': 2118,
            '503': 1265,
            '504': 1479,
            '505': 1139,
            '506': 1366,
            '507': 1139,
            '508': 2048,
            '509': 1821,
            '510': 1593,
            '511': 1251,
            '512': 1366,
            '513': 1139,
            '514': 1366,
            '515': 1139,
            '516': 1366,
            '517': 1139,
            '518': 1366,
            '519': 1139,
            '520': 569,
            '521': 569,
            '522': 569,
            '523': 569,
            '524': 1593,
            '525': 1139,
            '526': 1593,
            '527': 1139,
            '528': 1479,
            '529': 682,
            '530': 1479,
            '531': 682,
            '532': 1479,
            '533': 1139,
            '534': 1479,
            '535': 1139,
            '536': 1366,
            '537': 1024,
            '538': 1251,
            '539': 569,
            '540': 1116,
            '541': 894,
            '542': 1479,
            '543': 1139,
            '544': 1370,
            '545': 1286,
            '546': 1238,
            '547': 1238,
            '548': 1251,
            '549': 1024,
            '550': 1366,
            '551': 1139,
            '552': 1366,
            '553': 1139,
            '554': 1593,
            '555': 1139,
            '556': 1593,
            '557': 1139,
            '558': 1593,
            '559': 1139,
            '560': 1593,
            '561': 1139,
            '562': 1366,
            '563': 1024,
            '564': 602,
            '565': 1288,
            '566': 712,
            '567': 455,
            '568': 1809,
            '569': 1804,
            '570': 1366,
            '571': 1479,
            '572': 1024,
            '573': 1139,
            '574': 1251,
            '575': 1024,
            '576': 1024,
            '577': 1189,
            '578': 928,
            '579': 1366,
            '580': 1479,
            '581': 1366,
            '582': 1366,
            '583': 1139,
            '584': 1024,
            '585': 455,
            '586': 1546,
            '587': 1139,
            '588': 1479,
            '589': 682,
            '590': 1366,
            '591': 1024,
            '592': 1139,
            '593': 1139,
            '594': 1139,
            '595': 1139,
            '596': 1024,
            '597': 1024,
            '598': 1139,
            '599': 1139,
            '600': 1139,
            '601': 1139,
            '602': 1442,
            '603': 900,
            '604': 952,
            '605': 1261,
            '606': 1042,
            '607': 569,
            '608': 1139,
            '609': 1139,
            '610': 1127,
            '611': 1026,
            '612': 1263,
            '613': 1139,
            '614': 1139,
            '615': 1139,
            '616': 455,
            '617': 455,
            '618': 729,
            '619': 455,
            '620': 455,
            '621': 455,
            '622': 1154,
            '623': 1706,
            '624': 1706,
            '625': 1706,
            '626': 1139,
            '627': 1139,
            '628': 1193,
            '629': 1139,
            '630': 1568,
            '631': 1595,
            '632': 1139,
            '633': 682,
            '634': 682,
            '635': 682,
            '636': 682,
            '637': 682,
            '638': 682,
            '639': 682,
            '640': 1094,
            '641': 1094,
            '642': 1024,
            '643': 595,
            '644': 625,
            '645': 593,
            '646': 712,
            '647': 569,
            '648': 569,
            '649': 1139,
            '650': 1153,
            '651': 1126,
            '652': 1024,
            '653': 1479,
            '654': 1024,
            '655': 1054,
            '656': 1024,
            '657': 1121,
            '658': 1024,
            '659': 1024,
            '660': 1024,
            '661': 1024,
            '662': 1024,
            '663': 1024,
            '664': 1593,
            '665': 1048,
            '666': 1042,
            '667': 1127,
            '668': 1127,
            '669': 600,
            '670': 1024,
            '671': 917,
            '672': 1139,
            '673': 1024,
            '674': 1024,
            '675': 1899,
            '676': 1854,
            '677': 1991,
            '678': 1374,
            '679': 944,
            '680': 1451,
            '681': 1538,
            '682': 1314,
            '683': 1215,
            '684': 994,
            '685': 1080,
            '686': 1365,
            '687': 1365,
            '688': 631,
            '689': 631,
            '690': 250,
            '691': 449,
            '692': 449,
            '693': 449,
            '694': 669,
            '695': 1044,
            '696': 713,
            '697': 391,
            '698': 727,
            '699': 455,
            '700': 455,
            '701': 455,
            '702': 682,
            '703': 682,
            '704': 729,
            '705': 729,
            '706': 1196,
            '707': 1196,
            '708': 1196,
            '709': 1196,
            '710': 682,
            '711': 682,
            '712': 682,
            '713': 682,
            '714': 682,
            '715': 682,
            '716': 682,
            '717': 682,
            '718': 682,
            '719': 682,
            '720': 569,
            '721': 569,
            '722': 682,
            '723': 682,
            '724': 682,
            '725': 682,
            '726': 682,
            '727': 682,
            '728': 682,
            '729': 682,
            '730': 682,
            '731': 682,
            '732': 682,
            '733': 682,
            '734': 682,
            '735': 682,
            '736': 747,
            '737': 190,
            '738': 665,
            '739': 689,
            '740': 729,
            '741': 784,
            '742': 784,
            '743': 784,
            '744': 784,
            '745': 784,
            '746': 682,
            '747': 682,
            '748': 682,
            '749': 682,
            '750': 682,
            '751': 682,
            '752': 682,
            '753': 682,
            '754': 682,
            '755': 682,
            '756': 682,
            '757': 682,
            '758': 682,
            '759': 682,
            '760': 569,
            '761': 682,
            '762': 682,
            '763': 682,
            '764': 682,
            '765': 814,
            '766': 814,
            '767': 682,
            '768': 0,
            '769': 0,
            '770': 0,
            '771': 0,
            '772': 0,
            '773': 0,
            '774': 0,
            '775': 0,
            '776': 0,
            '777': 0,
            '778': 0,
            '779': 0,
            '780': 0,
            '781': 0,
            '782': 0,
            '783': 0,
            '784': 0,
            '785': 0,
            '786': 0,
            '787': 0,
            '788': 0,
            '789': 0,
            '790': 0,
            '791': 0,
            '792': 0,
            '793': 0,
            '794': 0,
            '795': 0,
            '796': 0,
            '797': 0,
            '798': 0,
            '799': 0,
            '800': 0,
            '801': 0,
            '802': 0,
            '803': 0,
            '804': 0,
            '805': 0,
            '806': 0,
            '807': 0,
            '808': 0,
            '809': 0,
            '810': 0,
            '811': 0,
            '812': 0,
            '813': 0,
            '814': 0,
            '815': 0,
            '816': 0,
            '817': 0,
            '818': 0,
            '819': 0,
            '820': 0,
            '821': 0,
            '822': 0,
            '823': 0,
            '824': 0,
            '825': 0,
            '826': 0,
            '827': 0,
            '828': 0,
            '829': 0,
            '830': 0,
            '831': 0,
            '832': 0,
            '833': 0,
            '834': 0,
            '835': 0,
            '836': 0,
            '837': 0,
            '838': 0,
            '839': 0,
            '840': 0,
            '841': 0,
            '842': 0,
            '843': 0,
            '844': 0,
            '845': 0,
            '846': 0,
            '847': 0,
            '848': 0,
            '849': 0,
            '850': 0,
            '851': 0,
            '852': 0,
            '853': 0,
            '854': 0,
            '855': 0,
            '856': 0,
            '857': 0,
            '858': 0,
            '859': 0,
            '860': 0,
            '861': 0,
            '862': 0,
            '863': 0,
            '864': 0,
            '865': 0,
            '866': 0,
            '867': 0,
            '868': 0,
            '869': 0,
            '870': 0,
            '871': 0,
            '872': 0,
            '873': 0,
            '874': 0,
            '875': 0,
            '876': 0,
            '877': 0,
            '878': 0,
            '879': 0,
            '884': 682,
            '885': 682,
            '890': 682,
            '891': 1024,
            '892': 1024,
            '893': 1024,
            '894': 569,
            '900': 682,
            '901': 682,
            '902': 1366,
            '903': 569,
            '904': 1615,
            '905': 1733,
            '906': 796,
            '908': 1626,
            '910': 1772,
            '911': 1587,
            '912': 455,
            '913': 1366,
            '914': 1366,
            '915': 1168,
            '916': 1374,
            '917': 1366,
            '918': 1251,
            '919': 1479,
            '920': 1593,
            '921': 569,
            '922': 1366,
            '923': 1366,
            '924': 1706,
            '925': 1479,
            '926': 1328,
            '927': 1593,
            '928': 1484,
            '929': 1366,
            '931': 1228,
            '932': 1251,
            '933': 1366,
            '934': 1714,
            '935': 1366,
            '936': 1701,
            '937': 1558,
            '938': 569,
            '939': 1366,
            '940': 1168,
            '941': 900,
            '942': 1137,
            '943': 455,
            '944': 1126,
            '945': 1168,
            '946': 1170,
            '947': 1024,
            '948': 1138,
            '949': 900,
            '950': 949,
            '951': 1137,
            '952': 1111,
            '953': 455,
            '954': 1024,
            '955': 1008,
            '956': 1122,
            '957': 1024,
            '958': 915,
            '959': 1139,
            '960': 1372,
            '961': 1173,
            '962': 996,
            '963': 1235,
            '964': 766,
            '965': 1126,
            '966': 1336,
            '967': 1118,
            '968': 1490,
            '969': 1595,
            '970': 455,
            '971': 1126,
            '972': 1139,
            '973': 1126,
            '974': 1595,
            '976': 1034,
            '977': 1126,
            '978': 1466,
            '979': 1806,
            '980': 1466,
            '981': 1139,
            '982': 1595,
            '983': 1154,
            '984': 1593,
            '985': 1139,
            '986': 1479,
            '987': 1024,
            '988': 1251,
            '989': 774,
            '990': 1279,
            '991': 1084,
            '992': 1549,
            '993': 1181,
            '994': 1733,
            '995': 1706,
            '996': 1379,
            '997': 1139,
            '998': 1379,
            '999': 1049,
            '1000': 1366,
            '1001': 1366,
            '1002': 1248,
            '1003': 1221,
            '1004': 1527,
            '1005': 1134,
            '1006': 850,
            '1007': 734,
            '1008': 1154,
            '1009': 1186,
            '1010': 1024,
            '1011': 455,
            '1012': 1593,
            '1013': 903,
            '1014': 903,
            '1015': 1366,
            '1016': 1139,
            '1017': 1479,
            '1018': 1706,
            '1019': 1404,
            '1020': 1173,
            '1021': 1479,
            '1022': 1479,
            '1023': 1479,
            '1024': 1366,
            '1025': 1366,
            '1026': 1726,
            '1027': 1114,
            '1028': 1449,
            '1029': 1366,
            '1030': 569,
            '1031': 569,
            '1032': 1024,
            '1033': 2183,
            '1034': 2012,
            '1035': 1729,
            '1036': 1207,
            '1037': 1465,
            '1038': 1309,
            '1039': 1482,
            '1040': 1366,
            '1041': 1333,
            '1042': 1366,
            '1043': 1114,
            '1044': 1442,
            '1045': 1366,
            '1046': 1878,
            '1047': 1257,
            '1048': 1465,
            '1049': 1465,
            '1050': 1207,
            '1051': 1404,
            '1052': 1706,
            '1053': 1479,
            '1054': 1593,
            '1055': 1484,
            '1056': 1366,
            '1057': 1479,
            '1058': 1251,
            '1059': 1309,
            '1060': 1628,
            '1061': 1366,
            '1062': 1489,
            '1063': 1379,
            '1064': 1885,
            '1065': 1890,
            '1066': 1649,
            '1067': 1815,
            '1068': 1333,
            '1069': 1421,
            '1070': 2094,
            '1071': 1396,
            '1072': 1139,
            '1073': 1152,
            '1074': 1069,
            '1075': 1010,
            '1076': 1132,
            '1077': 1139,
            '1078': 1409,
            '1079': 952,
            '1080': 1139,
            '1081': 1139,
            '1082': 967,
            '1083': 1155,
            '1084': 1404,
            '1085': 1127,
            '1086': 1139,
            '1087': 1127,
            '1088': 1139,
            '1089': 1024,
            '1090': 1706,
            '1091': 1024,
            '1092': 1711,
            '1093': 1024,
            '1094': 1171,
            '1095': 1060,
            '1096': 1700,
            '1097': 1743,
            '1098': 1272,
            '1099': 1507,
            '1100': 1077,
            '1101': 1007,
            '1102': 1540,
            '1103': 1094,
            '1104': 1139,
            '1105': 1139,
            '1106': 1139,
            '1107': 774,
            '1108': 1015,
            '1109': 1024,
            '1110': 455,
            '1111': 455,
            '1112': 455,
            '1113': 1864,
            '1114': 1695,
            '1115': 1139,
            '1116': 967,
            '1117': 1139,
            '1118': 1024,
            '1119': 1139,
            '1120': 2666,
            '1121': 1218,
            '1122': 1556,
            '1123': 1595,
            '1124': 1849,
            '1125': 1422,
            '1126': 1368,
            '1127': 1024,
            '1128': 1798,
            '1129': 1394,
            '1130': 1697,
            '1131': 1403,
            '1132': 2097,
            '1133': 1753,
            '1134': 1257,
            '1135': 952,
            '1136': 1701,
            '1137': 1490,
            '1138': 1593,
            '1139': 1139,
            '1140': 1556,
            '1141': 1208,
            '1142': 1556,
            '1143': 1208,
            '1144': 2270,
            '1145': 1881,
            '1146': 1695,
            '1147': 1228,
            '1148': 2626,
            '1149': 1794,
            '1150': 2666,
            '1151': 1218,
            '1152': 1479,
            '1153': 1024,
            '1154': 1139,
            '1155': 0,
            '1156': 0,
            '1157': 0,
            '1158': 0,
            '1159': 0,
            '1160': 0,
            '1161': 0,
            '1162': 1465,
            '1163': 1139,
            '1164': 1333,
            '1165': 1077,
            '1166': 1366,
            '1167': 1139,
            '1168': 1008,
            '1169': 695,
            '1170': 1114,
            '1171': 774,
            '1172': 1320,
            '1173': 1076,
            '1174': 1878,
            '1175': 1409,
            '1176': 1257,
            '1177': 952,
            '1178': 1207,
            '1179': 967,
            '1180': 1207,
            '1181': 967,
            '1182': 1207,
            '1183': 967,
            '1184': 1521,
            '1185': 1162,
            '1186': 1479,
            '1187': 1127,
            '1188': 1825,
            '1189': 1435,
            '1190': 2227,
            '1191': 1719,
            '1192': 1479,
            '1193': 1024,
            '1194': 1479,
            '1195': 1024,
            '1196': 1251,
            '1197': 1706,
            '1198': 1139,
            '1199': 1024,
            '1200': 1139,
            '1201': 1024,
            '1202': 1366,
            '1203': 1024,
            '1204': 1838,
            '1205': 1321,
            '1206': 1379,
            '1207': 1060,
            '1208': 1379,
            '1209': 1060,
            '1210': 1379,
            '1211': 1139,
            '1212': 1741,
            '1213': 1300,
            '1214': 1741,
            '1215': 1300,
            '1216': 569,
            '1217': 1878,
            '1218': 1409,
            '1219': 1284,
            '1220': 1064,
            '1221': 1404,
            '1222': 1155,
            '1223': 1479,
            '1224': 1127,
            '1225': 1479,
            '1226': 1127,
            '1227': 1379,
            '1228': 1060,
            '1229': 1706,
            '1230': 1404,
            '1231': 455,
            '1232': 1366,
            '1233': 1139,
            '1234': 1366,
            '1235': 1139,
            '1236': 2048,
            '1237': 1821,
            '1238': 1366,
            '1239': 1139,
            '1240': 1593,
            '1241': 1139,
            '1242': 1593,
            '1243': 1139,
            '1244': 1878,
            '1245': 1409,
            '1246': 1257,
            '1247': 952,
            '1248': 1257,
            '1249': 1024,
            '1250': 1465,
            '1251': 1139,
            '1252': 1465,
            '1253': 1139,
            '1254': 1593,
            '1255': 1139,
            '1256': 1593,
            '1257': 1139,
            '1258': 1593,
            '1259': 1139,
            '1260': 1421,
            '1261': 1007,
            '1262': 1309,
            '1263': 1024,
            '1264': 1309,
            '1265': 1024,
            '1266': 1309,
            '1267': 1024,
            '1268': 1379,
            '1269': 1060,
            '1270': 1114,
            '1271': 774,
            '1272': 1815,
            '1273': 1507,
            '1274': 1114,
            '1275': 774,
            '1276': 1366,
            '1277': 1024,
            '1278': 1366,
            '1279': 1024,
            '1280': 1366,
            '1281': 1139,
            '1282': 1949,
            '1283': 1707,
            '1284': 1919,
            '1285': 1564,
            '1286': 1257,
            '1287': 952,
            '1288': 2008,
            '1289': 1732,
            '1290': 2074,
            '1291': 1701,
            '1292': 1593,
            '1293': 1127,
            '1294': 1500,
            '1295': 2282,
            '1296': 1257,
            '1297': 900,
            '1298': 1404,
            '1299': 1195,
            '1306': 1593,
            '1307': 1139,
            '1308': 1933,
            '1309': 1479,
            '1425': 0,
            '1426': 0,
            '1427': 0,
            '1428': 0,
            '1429': 0,
            '1430': 0,
            '1431': 0,
            '1432': 0,
            '1433': 0,
            '1434': 0,
            '1435': 0,
            '1436': 0,
            '1437': 0,
            '1438': 0,
            '1439': 0,
            '1440': 0,
            '1441': 0,
            '1442': 0,
            '1443': 0,
            '1444': 0,
            '1445': 0,
            '1446': 0,
            '1447': 0,
            '1448': 0,
            '1449': 0,
            '1450': 0,
            '1451': 0,
            '1452': 0,
            '1453': 0,
            '1454': 0,
            '1455': 0,
            '1456': 0,
            '1457': 0,
            '1458': 0,
            '1459': 0,
            '1460': 0,
            '1461': 0,
            '1462': 0,
            '1463': 0,
            '1464': 0,
            '1465': 0,
            '1466': 0,
            '1467': 0,
            '1468': 0,
            '1469': 0,
            '1470': 784,
            '1471': 0,
            '1472': 1153,
            '1473': 0,
            '1474': 0,
            '1475': 569,
            '1476': 0,
            '1477': 0,
            '1478': 776,
            '1479': 0,
            '1488': 1286,
            '1489': 1225,
            '1490': 866,
            '1491': 1135,
            '1492': 1298,
            '1493': 532,
            '1494': 662,
            '1495': 1348,
            '1496': 1337,
            '1497': 532,
            '1498': 1094,
            '1499': 1075,
            '1500': 1085,
            '1501': 1389,
            '1502': 1407,
            '1503': 532,
            '1504': 797,
            '1505': 1343,
            '1506': 1192,
            '1507': 1276,
            '1508': 1249,
            '1509': 1032,
            '1510': 1116,
            '1511': 1208,
            '1512': 1094,
            '1513': 1495,
            '1514': 1415,
            '1520': 1042,
            '1521': 1042,
            '1522': 1042,
            '1523': 788,
            '1524': 1235,
            '7424': 1023,
            '7425': 1468,
            '7426': 1821,
            '7427': 1025,
            '7428': 1024,
            '7429': 1137,
            '7430': 1137,
            '7431': 965,
            '7432': 952,
            '7433': 455,
            '7434': 848,
            '7435': 1024,
            '7436': 917,
            '7437': 1404,
            '7438': 1200,
            '7439': 1139,
            '7440': 1024,
            '7441': 1139,
            '7442': 1024,
            '7443': 1251,
            '7444': 1933,
            '7445': 936,
            '7446': 1139,
            '7447': 1139,
            '7448': 1096,
            '7449': 1094,
            '7450': 1094,
            '7451': 1053,
            '7452': 1126,
            '7453': 1139,
            '7454': 1429,
            '7455': 1139,
            '7456': 1024,
            '7457': 1479,
            '7458': 1024,
            '7459': 952,
            '7460': 952,
            '7461': 1243,
            '7462': 774,
            '7463': 1024,
            '7464': 1127,
            '7465': 1096,
            '7466': 1490,
            '7467': 1155,
            '7468': 1006,
            '7469': 1469,
            '7470': 929,
            '7471': 929,
            '7472': 976,
            '7473': 925,
            '7474': 925,
            '7475': 1003,
            '7476': 975,
            '7477': 329,
            '7478': 684,
            '7479': 921,
            '7480': 770,
            '7481': 1135,
            '7482': 969,
            '7483': 971,
            '7484': 1017,
            '7485': 783,
            '7486': 897,
            '7487': 935,
            '7488': 812,
            '7489': 909,
            '7490': 1312,
            '7491': 734,
            '7492': 734,
            '7493': 724,
            '7494': 1213,
            '7495': 638,
            '7496': 812,
            '7497': 793,
            '7498': 793,
            '7499': 592,
            '7500': 592,
            '7501': 802,
            '7502': 255,
            '7503': 646,
            '7504': 1023,
            '7505': 629,
            '7506': 808,
            '7507': 727,
            '7508': 808,
            '7509': 808,
            '7510': 751,
            '7511': 400,
            '7512': 724,
            '7513': 956,
            '7514': 1077,
            '7515': 732,
            '7516': 904,
            '7517': 816,
            '7518': 752,
            '7519': 780,
            '7520': 897,
            '7521': 780,
            '7522': 255,
            '7523': 391,
            '7524': 724,
            '7525': 732,
            '7526': 816,
            '7527': 752,
            '7528': 777,
            '7529': 897,
            '7530': 780,
            '7531': 1869,
            '7532': 1139,
            '7533': 1139,
            '7534': 569,
            '7535': 1706,
            '7536': 1139,
            '7537': 1139,
            '7538': 682,
            '7539': 682,
            '7540': 1024,
            '7541': 569,
            '7542': 1024,
            '7543': 1139,
            '7544': 779,
            '7545': 1140,
            '7546': 1560,
            '7547': 455,
            '7548': 455,
            '7549': 1139,
            '7550': 1126,
            '7551': 1153,
            '7552': 1139,
            '7553': 1139,
            '7554': 569,
            '7555': 1410,
            '7556': 1024,
            '7557': 455,
            '7558': 1706,
            '7559': 1139,
            '7560': 1139,
            '7561': 682,
            '7562': 1024,
            '7563': 792,
            '7564': 1024,
            '7565': 1024,
            '7566': 1024,
            '7567': 1139,
            '7568': 1139,
            '7569': 1139,
            '7570': 1139,
            '7571': 900,
            '7572': 952,
            '7573': 1300,
            '7574': 455,
            '7575': 1024,
            '7576': 595,
            '7577': 1139,
            '7578': 1116,
            '7579': 777,
            '7580': 730,
            '7581': 730,
            '7582': 809,
            '7583': 592,
            '7584': 421,
            '7585': 421,
            '7586': 802,
            '7587': 726,
            '7588': 255,
            '7589': 255,
            '7590': 255,
            '7591': 255,
            '7592': 481,
            '7593': 255,
            '7594': 255,
            '7595': 621,
            '7596': 1023,
            '7597': 1023,
            '7598': 629,
            '7599': 629,
            '7600': 722,
            '7601': 808,
            '7602': 808,
            '7603': 704,
            '7604': 391,
            '7605': 400,
            '7606': 629,
            '7607': 823,
            '7608': 629,
            '7609': 629,
            '7610': 732,
            '7611': 671,
            '7612': 671,
            '7613': 752,
            '7614': 700,
            '7615': 809,
            '7616': 0,
            '7617': 0,
            '7618': 0,
            '7619': 0,
            '7620': 0,
            '7621': 0,
            '7622': 0,
            '7623': 0,
            '7624': 0,
            '7625': 0,
            '7626': 0,
            '7678': 0,
            '7679': 0,
            '7680': 1366,
            '7681': 1139,
            '7682': 1366,
            '7683': 1139,
            '7684': 1366,
            '7685': 1139,
            '7686': 1366,
            '7687': 1139,
            '7688': 1479,
            '7689': 1024,
            '7690': 1479,
            '7691': 1139,
            '7692': 1479,
            '7693': 1139,
            '7694': 1479,
            '7695': 1139,
            '7696': 1479,
            '7697': 1139,
            '7698': 1479,
            '7699': 1139,
            '7700': 1366,
            '7701': 1139,
            '7702': 1366,
            '7703': 1139,
            '7704': 1366,
            '7705': 1139,
            '7706': 1366,
            '7707': 1139,
            '7708': 1366,
            '7709': 1139,
            '7710': 1251,
            '7711': 569,
            '7712': 1593,
            '7713': 1139,
            '7714': 1479,
            '7715': 1139,
            '7716': 1479,
            '7717': 1139,
            '7718': 1479,
            '7719': 1139,
            '7720': 1479,
            '7721': 1139,
            '7722': 1479,
            '7723': 1139,
            '7724': 569,
            '7725': 455,
            '7726': 569,
            '7727': 569,
            '7728': 1366,
            '7729': 1024,
            '7730': 1366,
            '7731': 1024,
            '7732': 1366,
            '7733': 1024,
            '7734': 1139,
            '7735': 455,
            '7736': 1139,
            '7737': 455,
            '7738': 1139,
            '7739': 455,
            '7740': 1139,
            '7741': 455,
            '7742': 1706,
            '7743': 1706,
            '7744': 1706,
            '7745': 1706,
            '7746': 1706,
            '7747': 1706,
            '7748': 1479,
            '7749': 1139,
            '7750': 1479,
            '7751': 1139,
            '7752': 1479,
            '7753': 1139,
            '7754': 1479,
            '7755': 1139,
            '7756': 1593,
            '7757': 1139,
            '7758': 1593,
            '7759': 1139,
            '7760': 1593,
            '7761': 1139,
            '7762': 1593,
            '7763': 1139,
            '7764': 1366,
            '7765': 1139,
            '7766': 1366,
            '7767': 1139,
            '7768': 1479,
            '7769': 682,
            '7770': 1479,
            '7771': 682,
            '7772': 1479,
            '7773': 682,
            '7774': 1479,
            '7775': 682,
            '7776': 1366,
            '7777': 1024,
            '7778': 1366,
            '7779': 1024,
            '7780': 1366,
            '7781': 1024,
            '7782': 1366,
            '7783': 1024,
            '7784': 1366,
            '7785': 1024,
            '7786': 1251,
            '7787': 569,
            '7788': 1251,
            '7789': 569,
            '7790': 1251,
            '7791': 569,
            '7792': 1251,
            '7793': 569,
            '7794': 1479,
            '7795': 1139,
            '7796': 1479,
            '7797': 1139,
            '7798': 1479,
            '7799': 1139,
            '7800': 1479,
            '7801': 1139,
            '7802': 1479,
            '7803': 1139,
            '7804': 1366,
            '7805': 1024,
            '7806': 1366,
            '7807': 1024,
            '7808': 1933,
            '7809': 1479,
            '7810': 1933,
            '7811': 1479,
            '7812': 1933,
            '7813': 1479,
            '7814': 1933,
            '7815': 1479,
            '7816': 1933,
            '7817': 1479,
            '7818': 1366,
            '7819': 1024,
            '7820': 1366,
            '7821': 1024,
            '7822': 1366,
            '7823': 1024,
            '7824': 1251,
            '7825': 1024,
            '7826': 1251,
            '7827': 1024,
            '7828': 1251,
            '7829': 1024,
            '7830': 1139,
            '7831': 569,
            '7832': 1479,
            '7833': 1024,
            '7834': 1139,
            '7835': 455,
            '7838': 1378,
            '7840': 1366,
            '7841': 1139,
            '7842': 1366,
            '7843': 1139,
            '7844': 1366,
            '7845': 1139,
            '7846': 1366,
            '7847': 1139,
            '7848': 1366,
            '7849': 1139,
            '7850': 1366,
            '7851': 1139,
            '7852': 1366,
            '7853': 1139,
            '7854': 1366,
            '7855': 1139,
            '7856': 1366,
            '7857': 1139,
            '7858': 1366,
            '7859': 1139,
            '7860': 1366,
            '7861': 1139,
            '7862': 1366,
            '7863': 1139,
            '7864': 1366,
            '7865': 1139,
            '7866': 1366,
            '7867': 1139,
            '7868': 1366,
            '7869': 1139,
            '7870': 1366,
            '7871': 1139,
            '7872': 1366,
            '7873': 1139,
            '7874': 1366,
            '7875': 1139,
            '7876': 1366,
            '7877': 1139,
            '7878': 1366,
            '7879': 1139,
            '7880': 569,
            '7881': 455,
            '7882': 569,
            '7883': 455,
            '7884': 1593,
            '7885': 1139,
            '7886': 1593,
            '7887': 1139,
            '7888': 1593,
            '7889': 1139,
            '7890': 1593,
            '7891': 1139,
            '7892': 1593,
            '7893': 1139,
            '7894': 1593,
            '7895': 1139,
            '7896': 1593,
            '7897': 1139,
            '7898': 1662,
            '7899': 1238,
            '7900': 1662,
            '7901': 1238,
            '7902': 1662,
            '7903': 1238,
            '7904': 1662,
            '7905': 1238,
            '7906': 1662,
            '7907': 1238,
            '7908': 1479,
            '7909': 1139,
            '7910': 1479,
            '7911': 1139,
            '7912': 1625,
            '7913': 1298,
            '7914': 1625,
            '7915': 1298,
            '7916': 1625,
            '7917': 1298,
            '7918': 1625,
            '7919': 1298,
            '7920': 1625,
            '7921': 1298,
            '7922': 1366,
            '7923': 1024,
            '7924': 1366,
            '7925': 1024,
            '7926': 1366,
            '7927': 1024,
            '7928': 1366,
            '7929': 1024,
            '7936': 1168,
            '7937': 1168,
            '7938': 1168,
            '7939': 1168,
            '7940': 1168,
            '7941': 1168,
            '7942': 1168,
            '7943': 1168,
            '7944': 1366,
            '7945': 1366,
            '7946': 1666,
            '7947': 1666,
            '7948': 1666,
            '7949': 1666,
            '7950': 1666,
            '7951': 1666,
            '7952': 900,
            '7953': 900,
            '7954': 900,
            '7955': 900,
            '7956': 900,
            '7957': 900,
            '7960': 1566,
            '7961': 1566,
            '7962': 1966,
            '7963': 1966,
            '7964': 1966,
            '7965': 1966,
            '7968': 1137,
            '7969': 1137,
            '7970': 1137,
            '7971': 1137,
            '7972': 1137,
            '7973': 1137,
            '7974': 1137,
            '7975': 1137,
            '7976': 1679,
            '7977': 1679,
            '7978': 2079,
            '7979': 2079,
            '7980': 2079,
            '7981': 2079,
            '7982': 2079,
            '7983': 2079,
            '7984': 455,
            '7985': 455,
            '7986': 455,
            '7987': 455,
            '7988': 455,
            '7989': 455,
            '7990': 455,
            '7991': 455,
            '7992': 769,
            '7993': 769,
            '7994': 1169,
            '7995': 1169,
            '7996': 1169,
            '7997': 1169,
            '7998': 1169,
            '7999': 1169,
            '8000': 1139,
            '8001': 1139,
            '8002': 1139,
            '8003': 1139,
            '8004': 1139,
            '8005': 1139,
            '8008': 1693,
            '8009': 1693,
            '8010': 2093,
            '8011': 2093,
            '8012': 1993,
            '8013': 1993,
            '8016': 1126,
            '8017': 1126,
            '8018': 1126,
            '8019': 1126,
            '8020': 1126,
            '8021': 1126,
            '8022': 1126,
            '8023': 1126,
            '8025': 1666,
            '8027': 1966,
            '8029': 2066,
            '8031': 1966,
            '8032': 1595,
            '8033': 1595,
            '8034': 1595,
            '8035': 1595,
            '8036': 1595,
            '8037': 1595,
            '8038': 1595,
            '8039': 1595,
            '8040': 1658,
            '8041': 1658,
            '8042': 2058,
            '8043': 2058,
            '8044': 1958,
            '8045': 1958,
            '8046': 1958,
            '8047': 1958,
            '8048': 1168,
            '8049': 1168,
            '8050': 900,
            '8051': 900,
            '8052': 1137,
            '8053': 1137,
            '8054': 455,
            '8055': 455,
            '8056': 1139,
            '8057': 1139,
            '8058': 1126,
            '8059': 1126,
            '8060': 1595,
            '8061': 1595,
            '8064': 1168,
            '8065': 1168,
            '8066': 1168,
            '8067': 1168,
            '8068': 1168,
            '8069': 1168,
            '8070': 1168,
            '8071': 1168,
            '8072': 1366,
            '8073': 1366,
            '8074': 1666,
            '8075': 1666,
            '8076': 1666,
            '8077': 1666,
            '8078': 1666,
            '8079': 1666,
            '8080': 1137,
            '8081': 1137,
            '8082': 1137,
            '8083': 1137,
            '8084': 1137,
            '8085': 1137,
            '8086': 1137,
            '8087': 1137,
            '8088': 1679,
            '8089': 1679,
            '8090': 2079,
            '8091': 2079,
            '8092': 2079,
            '8093': 2079,
            '8094': 2079,
            '8095': 2079,
            '8096': 1595,
            '8097': 1595,
            '8098': 1595,
            '8099': 1595,
            '8100': 1595,
            '8101': 1595,
            '8102': 1595,
            '8103': 1595,
            '8104': 1658,
            '8105': 1658,
            '8106': 2058,
            '8107': 2058,
            '8108': 1958,
            '8109': 1958,
            '8110': 1958,
            '8111': 1958,
            '8112': 1168,
            '8113': 1168,
            '8114': 1168,
            '8115': 1168,
            '8116': 1168,
            '8118': 1168,
            '8119': 1168,
            '8120': 1366,
            '8121': 1366,
            '8122': 1366,
            '8123': 1366,
            '8124': 1366,
            '8125': 682,
            '8126': 682,
            '8127': 682,
            '8128': 682,
            '8129': 682,
            '8130': 1137,
            '8131': 1137,
            '8132': 1137,
            '8134': 1137,
            '8135': 1137,
            '8136': 1666,
            '8137': 1666,
            '8138': 1779,
            '8139': 1779,
            '8140': 1479,
            '8141': 682,
            '8142': 682,
            '8143': 682,
            '8144': 455,
            '8145': 455,
            '8146': 455,
            '8147': 455,
            '8150': 455,
            '8151': 455,
            '8152': 569,
            '8153': 569,
            '8154': 869,
            '8155': 869,
            '8157': 682,
            '8158': 682,
            '8159': 682,
            '8160': 1126,
            '8161': 1126,
            '8162': 1126,
            '8163': 1126,
            '8164': 1173,
            '8165': 1173,
            '8166': 1126,
            '8167': 1126,
            '8168': 1366,
            '8169': 1366,
            '8170': 1666,
            '8171': 1766,
            '8172': 1566,
            '8173': 682,
            '8174': 682,
            '8175': 682,
            '8178': 1595,
            '8179': 1595,
            '8180': 1595,
            '8182': 1595,
            '8183': 1595,
            '8184': 1893,
            '8185': 1693,
            '8186': 1858,
            '8187': 1658,
            '8188': 1558,
            '8189': 682,
            '8190': 682,
            '8192': 1024,
            '8193': 2048,
            '8194': 1024,
            '8195': 2048,
            '8196': 683,
            '8197': 512,
            '8198': 341,
            '8199': 1139,
            '8200': 569,
            '8201': 410,
            '8202': 171,
            '8203': 0,
            '8204': 0,
            '8205': 0,
            '8206': 0,
            '8207': 0,
            '8208': 682,
            '8210': 1139,
            '8211': 1139,
            '8212': 2048,
            '8213': 2048,
            '8214': 846,
            '8215': 1131,
            '8216': 455,
            '8217': 455,
            '8218': 455,
            '8219': 455,
            '8220': 682,
            '8221': 682,
            '8222': 682,
            '8223': 682,
            '8224': 1139,
            '8225': 1139,
            '8226': 717,
            '8230': 2048,
            '8234': 0,
            '8235': 0,
            '8236': 0,
            '8237': 0,
            '8238': 0,
            '8239': 410,
            '8240': 2048,
            '8242': 384,
            '8243': 725,
            '8244': 725,
            '8249': 682,
            '8250': 682,
            '8252': 1024,
            '8254': 682,
            '8260': 342,
            '8286': 569,
            '8298': 0,
            '8299': 0,
            '8300': 0,
            '8301': 0,
            '8302': 0,
            '8303': 0,
            '8308': 887,
            '8309': 861,
            '8310': 850,
            '8311': 777,
            '8312': 885,
            '8313': 916,
            '8319': 747,
            '8320': 863,
            '8321': 646,
            '8322': 781,
            '8323': 812,
            '8324': 821,
            '8325': 823,
            '8326': 824,
            '8327': 718,
            '8328': 858,
            '8329': 811,
            '8336': 734,
            '8337': 793,
            '8338': 808,
            '8339': 780,
            '8340': 793,
            '8352': 1139,
            '8353': 1479,
            '8354': 1479,
            '8355': 1139,
            '8356': 1139,
            '8357': 1706,
            '8358': 1479,
            '8359': 2240,
            '8360': 2314,
            '8361': 1933,
            '8362': 1739,
            '8363': 1051,
            '8364': 1139,
            '8365': 1366,
            '8366': 1251,
            '8367': 2048,
            '8368': 1067,
            '8369': 1366,
            '8370': 1593,
            '8371': 1366,
            '8372': 1366,
            '8373': 1479,
            '8383': 1607,
            '8432': 0,
            '8453': 1813,
            '8467': 662,
            '8470': 2218,
            '8471': 1509,
            '8482': 2048,
            '8486': 1573,
            '8494': 1229,
            '8525': 1931,
            '8526': 1003,
            '8531': 1708,
            '8532': 1708,
            '8539': 1708,
            '8540': 1708,
            '8541': 1708,
            '8542': 1708,
            '8580': 1024,
            '8592': 2048,
            '8593': 1024,
            '8594': 2048,
            '8595': 1024,
            '8596': 2048,
            '8597': 1024,
            '8616': 1024,
            '8660': 2048,
            '8706': 1012,
            '8710': 1253,
            '8719': 1686,
            '8721': 1460,
            '8722': 1196,
            '8725': 342,
            '8729': 569,
            '8730': 1124,
            '8734': 1460,
            '8735': 2005,
            '8745': 1472,
            '8747': 561,
            '8776': 1124,
            '8800': 1124,
            '8801': 1196,
            '8802': 2048,
            '8804': 1124,
            '8805': 1124,
            '8962': 1237,
            '8976': 1196,
            '8992': 1237,
            '8993': 1237,
            '9472': 1451,
            '9474': 1280,
            '9484': 1451,
            '9488': 1451,
            '9492': 1451,
            '9496': 1451,
            '9500': 1451,
            '9508': 1451,
            '9516': 1451,
            '9524': 1451,
            '9532': 1451,
            '9552': 1451,
            '9553': 1451,
            '9554': 1451,
            '9555': 1451,
            '9556': 1451,
            '9557': 1451,
            '9558': 1451,
            '9559': 1451,
            '9560': 1451,
            '9561': 1451,
            '9562': 1451,
            '9563': 1451,
            '9564': 1451,
            '9565': 1451,
            '9566': 1451,
            '9567': 1451,
            '9568': 1451,
            '9569': 1451,
            '9570': 1451,
            '9571': 1451,
            '9572': 1451,
            '9573': 1451,
            '9574': 1451,
            '9575': 1451,
            '9576': 1451,
            '9577': 1451,
            '9578': 1451,
            '9579': 1451,
            '9580': 1451,
            '9600': 1451,
            '9604': 1451,
            '9608': 1451,
            '9612': 1451,
            '9616': 1451,
            '9617': 1451,
            '9618': 1451,
            '9619': 1493,
            '9632': 1237,
            '9633': 1237,
            '9642': 726,
            '9643': 726,
            '9644': 2048,
            '9650': 2027,
            '9658': 2027,
            '9660': 2027,
            '9668': 2027,
            '9674': 1012,
            '9675': 1237,
            '9676': 1217,
            '9679': 1237,
            '9680': 1237,
            '9681': 1237,
            '9682': 1237,
            '9683': 1237,
            '9684': 1237,
            '9685': 1237,
            '9686': 1237,
            '9687': 1237,
            '9688': 1237,
            '9689': 1237,
            '9702': 726,
            '9786': 2091,
            '9787': 2155,
            '9788': 1877,
            '9791': 1536,
            '9792': 1536,
            '9793': 1536,
            '9794': 1536,
            '9795': 1536,
            '9796': 1536,
            '9797': 1536,
            '9798': 1536,
            '9799': 1536,
            '9824': 1088,
            '9827': 1344,
            '9829': 1216,
            '9830': 1045,
            '9833': 2048,
            '9834': 1024,
            '9835': 1536,
            '9836': 2048,
            '9839': 1024,
            '11360': 1139,
            '11361': 455,
            '11362': 1139,
            '11363': 1366,
            '11364': 1479,
            '11365': 1139,
            '11366': 569,
            '11367': 1479,
            '11368': 1139,
            '11369': 1366,
            '11370': 1024,
            '11371': 1251,
            '11372': 1024,
            '11373': 1546,
            '11377': 1232,
            '11378': 2124,
            '11379': 1722,
            '11380': 1024,
            '11381': 1232,
            '11382': 899,
            '11383': 1336,
            '11799': 682,
            '42775': 0,
            '42776': 0,
            '42777': 0,
            '42778': 0,
            '42779': 1024,
            '42780': 1024,
            '42781': 569,
            '42782': 569,
            '42783': 569,
            '42784': 0,
            '42785': 0,
            '42888': 682,
            '42889': 569,
            '42890': 896,
            '42891': 391,
            '42892': 391,
            '64257': 1024,
            '64258': 1024,
            '64285': 532,
            '64286': 0,
            '64287': 1042,
            '64288': 1192,
            '64289': 1286,
            '64290': 1135,
            '64291': 1298,
            '64292': 1075,
            '64293': 1085,
            '64294': 1389,
            '64295': 1094,
            '64296': 1415,
            '64297': 1151,
            '64298': 1495,
            '64299': 1495,
            '64300': 1495,
            '64301': 1495,
            '64302': 1286,
            '64303': 1286,
            '64304': 1286,
            '64305': 1225,
            '64306': 866,
            '64307': 1135,
            '64308': 1298,
            '64309': 532,
            '64310': 662,
            '64312': 1337,
            '64313': 532,
            '64314': 1094,
            '64315': 1075,
            '64316': 1085,
            '64318': 1407,
            '64320': 797,
            '64321': 1343,
            '64323': 1276,
            '64324': 1249,
            '64326': 1116,
            '64327': 1208,
            '64328': 1094,
            '64329': 1495,
            '64330': 1415,
            '64331': 532,
            '64332': 1225,
            '64333': 1075,
            '64334': 1249,
            '64335': 1286,
            '65056': 0,
            '65057': 0,
            '65058': 0,
            '65059': 0,
            '65532': 2048,
        },
    },
    bolditalic: {
        unitsPerEm: 2048,
        ascent: 1854,
        widths: {
            '32': 569,
            '33': 682,
            '34': 971,
            '35': 1139,
            '36': 1139,
            '37': 1821,
            '38': 1479,
            '39': 487,
            '40': 682,
            '41': 682,
            '42': 797,
            '43': 1196,
            '44': 569,
            '45': 682,
            '46': 569,
            '47': 569,
            '48': 1139,
            '49': 1139,
            '50': 1139,
            '51': 1139,
            '52': 1139,
            '53': 1139,
            '54': 1139,
            '55': 1139,
            '56': 1139,
            '57': 1139,
            '58': 682,
            '59': 682,
            '60': 1196,
            '61': 1196,
            '62': 1196,
            '63': 1251,
            '64': 1997,
            '65': 1479,
            '66': 1479,
            '67': 1479,
            '68': 1479,
            '69': 1366,
            '70': 1251,
            '71': 1593,
            '72': 1479,
            '73': 569,
            '74': 1139,
            '75': 1479,
            '76': 1251,
            '77': 1706,
            '78': 1479,
            '79': 1593,
            '80': 1366,
            '81': 1593,
            '82': 1479,
            '83': 1366,
            '84': 1251,
            '85': 1479,
            '86': 1366,
            '87': 1933,
            '88': 1366,
            '89': 1366,
            '90': 1251,
            '91': 682,
            '92': 569,
            '93': 682,
            '94': 1196,
            '95': 1139,
            '96': 682,
            '97': 1139,
            '98': 1251,
            '99': 1139,
            '100': 1251,
            '101': 1139,
            '102': 682,
            '103': 1251,
            '104': 1251,
            '105': 569,
            '106': 569,
            '107': 1139,
            '108': 569,
            '109': 1821,
            '110': 1251,
            '111': 1251,
            '112': 1251,
            '113': 1251,
            '114': 797,
            '115': 1139,
            '116': 682,
            '117': 1251,
            '118': 1139,
            '119': 1593,
            '120': 1139,
            '121': 1139,
            '122': 1024,
            '123': 797,
            '124': 573,
            '125': 797,
            '126': 1196,
            '160': 569,
            '161': 682,
            '162': 1139,
            '163': 1139,
            '164': 1139,
            '165': 1139,
            '166': 573,
            '167': 1139,
            '168': 682,
            '169': 1509,
            '170': 758,
            '171': 1139,
            '172': 1196,
            '173': 682,
            '174': 1509,
            '175': 1131,
            '176': 819,
            '177': 1124,
            '178': 682,
            '179': 682,
            '180': 682,
            '181': 1180,
            '182': 1139,
            '183': 682,
            '184': 682,
            '185': 682,
            '186': 748,
            '187': 1139,
            '188': 1708,
            '189': 1708,
            '190': 1708,
            '191': 1251,
            '192': 1479,
            '193': 1479,
            '194': 1479,
            '195': 1479,
            '196': 1479,
            '197': 1479,
            '198': 2048,
            '199': 1479,
            '200': 1366,
            '201': 1366,
            '202': 1366,
            '203': 1366,
            '204': 569,
            '205': 569,
            '206': 569,
            '207': 569,
            '208': 1479,
            '209': 1479,
            '210': 1593,
            '211': 1593,
            '212': 1593,
            '213': 1593,
            '214': 1593,
            '215': 1196,
            '216': 1593,
            '217': 1479,
            '218': 1479,
            '219': 1479,
            '220': 1479,
            '221': 1366,
            '222': 1366,
            '223': 1251,
            '224': 1139,
            '225': 1139,
            '226': 1139,
            '227': 1139,
            '228': 1139,
            '229': 1139,
            '230': 1821,
            '231': 1139,
            '232': 1139,
            '233': 1139,
            '234': 1139,
            '235': 1139,
            '236': 569,
            '237': 569,
            '238': 569,
            '239': 569,
            '240': 1251,
            '241': 1251,
            '242': 1251,
            '243': 1251,
            '244': 1251,
            '245': 1251,
            '246': 1251,
            '247': 1124,
            '248': 1251,
            '249': 1251,
            '250': 1251,
            '251': 1251,
            '252': 1251,
            '253': 1139,
            '254': 1251,
            '255': 1139,
            '256': 1479,
            '257': 1139,
            '258': 1479,
            '259': 1139,
            '260': 1479,
            '261': 1139,
            '262': 1479,
            '263': 1139,
            '264': 1479,
            '265': 1139,
            '266': 1479,
            '267': 1139,
            '268': 1479,
            '269': 1139,
            '270': 1479,
            '271': 1515,
            '272': 1479,
            '273': 1251,
            '274': 1366,
            '275': 1139,
            '276': 1366,
            '277': 1139,
            '278': 1366,
            '279': 1139,
            '280': 1366,
            '281': 1139,
            '282': 1366,
            '283': 1139,
            '284': 1593,
            '285': 1251,
            '286': 1593,
            '287': 1251,
            '288': 1593,
            '289': 1251,
            '290': 1593,
            '291': 1251,
            '292': 1479,
            '293': 1251,
            '294': 1479,
            '295': 1251,
            '296': 569,
            '297': 569,
            '298': 569,
            '299': 569,
            '300': 569,
            '301': 569,
            '302': 569,
            '303': 569,
            '304': 569,
            '305': 569,
            '306': 1602,
            '307': 1139,
            '308': 1139,
            '309': 569,
            '310': 1479,
            '311': 1139,
            '312': 1139,
            '313': 1251,
            '314': 569,
            '315': 1251,
            '316': 569,
            '317': 1251,
            '318': 811,
            '319': 1251,
            '320': 981,
            '321': 1251,
            '322': 569,
            '323': 1479,
            '324': 1251,
            '325': 1479,
            '326': 1251,
            '327': 1479,
            '328': 1251,
            '329': 1451,
            '330': 1481,
            '331': 1251,
            '332': 1593,
            '333': 1251,
            '334': 1593,
            '335': 1251,
            '336': 1593,
            '337': 1251,
            '338': 2048,
            '339': 1933,
            '340': 1479,
            '341': 797,
            '342': 1479,
            '343': 797,
            '344': 1479,
            '345': 797,
            '346': 1366,
            '347': 1139,
            '348': 1366,
            '349': 1139,
            '350': 1366,
            '351': 1139,
            '352': 1366,
            '353': 1139,
            '354': 1251,
            '355': 682,
            '356': 1251,
            '357': 981,
            '358': 1251,
            '359': 682,
            '360': 1479,
            '361': 1251,
            '362': 1479,
            '363': 1251,
            '364': 1479,
            '365': 1251,
            '366': 1479,
            '367': 1251,
            '368': 1479,
            '369': 1251,
            '370': 1479,
            '371': 1251,
            '372': 1933,
            '373': 1593,
            '374': 1366,
            '375': 1139,
            '376': 1366,
            '377': 1251,
            '378': 1024,
            '379': 1251,
            '380': 1024,
            '381': 1251,
            '382': 1024,
            '383': 569,
            '384': 1251,
            '385': 1630,
            '386': 1450,
            '387': 1251,
            '388': 1450,
            '389': 1251,
            '390': 1479,
            '391': 1479,
            '392': 1139,
            '393': 1479,
            '394': 1623,
            '395': 1366,
            '396': 1251,
            '397': 1250,
            '398': 1366,
            '399': 1531,
            '400': 1316,
            '401': 1251,
            '402': 1139,
            '403': 1593,
            '404': 1271,
            '405': 1912,
            '406': 569,
            '407': 569,
            '408': 1479,
            '409': 1139,
            '410': 569,
            '411': 1139,
            '412': 1865,
            '413': 1479,
            '414': 1251,
            '415': 1593,
            '416': 1715,
            '417': 1375,
            '418': 1851,
            '419': 1502,
            '420': 1516,
            '421': 1251,
            '422': 1366,
            '423': 1366,
            '424': 1139,
            '425': 1209,
            '426': 737,
            '427': 682,
            '428': 1251,
            '429': 682,
            '430': 1251,
            '431': 1656,
            '432': 1462,
            '433': 1599,
            '434': 1479,
            '435': 1466,
            '436': 1139,
            '437': 1251,
            '438': 1024,
            '439': 1251,
            '440': 1251,
            '441': 1078,
            '442': 1078,
            '443': 1139,
            '444': 1139,
            '445': 1018,
            '446': 1139,
            '447': 1264,
            '448': 573,
            '449': 1019,
            '450': 1197,
            '451': 682,
            '452': 2730,
            '453': 2503,
            '454': 2275,
            '455': 2390,
            '456': 1820,
            '457': 1138,
            '458': 2618,
            '459': 2048,
            '460': 1820,
            '461': 1479,
            '462': 1139,
            '463': 569,
            '464': 569,
            '465': 1593,
            '466': 1251,
            '467': 1479,
            '468': 1251,
            '469': 1479,
            '470': 1251,
            '471': 1479,
            '472': 1251,
            '473': 1479,
            '474': 1251,
            '475': 1479,
            '476': 1251,
            '477': 1139,
            '478': 1479,
            '479': 1139,
            '480': 1479,
            '481': 1139,
            '482': 2048,
            '483': 1821,
            '484': 1593,
            '485': 1251,
            '486': 1593,
            '487': 1251,
            '488': 1479,
            '489': 1139,
            '490': 1593,
            '491': 1251,
            '492': 1593,
            '493': 1251,
            '494': 1251,
            '495': 1078,
            '496': 569,
            '497': 2730,
            '498': 2503,
            '499': 2275,
            '500': 1593,
            '501': 1251,
            '502': 2120,
            '503': 1410,
            '504': 1479,
            '505': 1251,
            '506': 1479,
            '507': 1139,
            '508': 2048,
            '509': 1821,
            '510': 1593,
            '511': 1251,
            '512': 1479,
            '513': 1139,
            '514': 1479,
            '515': 1139,
            '516': 1366,
            '517': 1139,
            '518': 1366,
            '519': 1139,
            '520': 569,
            '521': 569,
            '522': 569,
            '523': 569,
            '524': 1593,
            '525': 1251,
            '526': 1593,
            '527': 1251,
            '528': 1479,
            '529': 797,
            '530': 1479,
            '531': 797,
            '532': 1479,
            '533': 1251,
            '534': 1479,
            '535': 1251,
            '536': 1366,
            '537': 1139,
            '538': 1251,
            '539': 682,
            '540': 1182,
            '541': 1065,
            '542': 1479,
            '543': 1251,
            '544': 1450,
            '545': 1620,
            '546': 1292,
            '547': 1292,
            '548': 1251,
            '549': 1024,
            '550': 1479,
            '551': 1139,
            '552': 1366,
            '553': 1139,
            '554': 1593,
            '555': 1251,
            '556': 1593,
            '557': 1251,
            '558': 1593,
            '559': 1251,
            '560': 1593,
            '561': 1251,
            '562': 1366,
            '563': 1139,
            '564': 926,
            '565': 1608,
            '566': 1043,
            '567': 569,
            '568': 1953,
            '569': 1949,
            '570': 1479,
            '571': 1479,
            '572': 1139,
            '573': 1251,
            '574': 1251,
            '575': 1139,
            '576': 1024,
            '577': 1321,
            '578': 991,
            '579': 1479,
            '580': 1479,
            '581': 1366,
            '582': 1366,
            '583': 1139,
            '584': 1139,
            '585': 569,
            '586': 1599,
            '587': 1251,
            '588': 1479,
            '589': 797,
            '590': 1366,
            '591': 1139,
            '592': 1139,
            '593': 1251,
            '594': 1251,
            '595': 1251,
            '596': 1139,
            '597': 1139,
            '598': 1251,
            '599': 1251,
            '600': 1139,
            '601': 1139,
            '602': 1516,
            '603': 980,
            '604': 1045,
            '605': 1372,
            '606': 1171,
            '607': 682,
            '608': 1251,
            '609': 1251,
            '610': 1221,
            '611': 1139,
            '612': 1230,
            '613': 1251,
            '614': 1251,
            '615': 1251,
            '616': 569,
            '617': 569,
            '618': 830,
            '619': 569,
            '620': 644,
            '621': 569,
            '622': 1219,
            '623': 1821,
            '624': 1821,
            '625': 1821,
            '626': 1251,
            '627': 1251,
            '628': 1328,
            '629': 1251,
            '630': 1745,
            '631': 1709,
            '632': 1551,
            '633': 797,
            '634': 797,
            '635': 797,
            '636': 797,
            '637': 797,
            '638': 797,
            '639': 797,
            '640': 1206,
            '641': 1206,
            '642': 1139,
            '643': 654,
            '644': 654,
            '645': 682,
            '646': 1094,
            '647': 682,
            '648': 682,
            '649': 1251,
            '650': 1272,
            '651': 1211,
            '652': 1139,
            '653': 1593,
            '654': 1139,
            '655': 1134,
            '656': 1024,
            '657': 1426,
            '658': 1078,
            '659': 1078,
            '660': 1026,
            '661': 1026,
            '662': 1026,
            '663': 1139,
            '664': 1593,
            '665': 1270,
            '666': 1171,
            '667': 1221,
            '668': 1237,
            '669': 834,
            '670': 1139,
            '671': 922,
            '672': 1251,
            '673': 1026,
            '674': 1026,
            '675': 2048,
            '676': 1919,
            '677': 2451,
            '678': 1669,
            '679': 1175,
            '680': 1719,
            '681': 1763,
            '682': 1589,
            '683': 1354,
            '684': 1093,
            '685': 1154,
            '686': 1445,
            '687': 1445,
            '688': 824,
            '689': 824,
            '690': 396,
            '691': 572,
            '692': 572,
            '693': 572,
            '694': 819,
            '695': 1136,
            '696': 829,
            '697': 487,
            '698': 971,
            '699': 569,
            '700': 569,
            '701': 569,
            '702': 682,
            '703': 682,
            '704': 775,
            '705': 775,
            '706': 1196,
            '707': 1196,
            '708': 1196,
            '709': 1196,
            '710': 682,
            '711': 682,
            '712': 682,
            '713': 682,
            '714': 682,
            '715': 682,
            '716': 682,
            '717': 682,
            '718': 682,
            '719': 682,
            '720': 682,
            '721': 682,
            '722': 682,
            '723': 682,
            '724': 682,
            '725': 682,
            '726': 682,
            '727': 682,
            '728': 682,
            '729': 682,
            '730': 682,
            '731': 682,
            '732': 682,
            '733': 682,
            '734': 682,
            '735': 682,
            '736': 830,
            '737': 367,
            '738': 762,
            '739': 816,
            '740': 775,
            '741': 784,
            '742': 784,
            '743': 784,
            '744': 784,
            '745': 784,
            '746': 682,
            '747': 682,
            '748': 682,
            '749': 682,
            '750': 1024,
            '751': 682,
            '752': 682,
            '753': 682,
            '754': 682,
            '755': 682,
            '756': 682,
            '757': 682,
            '758': 682,
            '759': 682,
            '760': 682,
            '761': 682,
            '762': 682,
            '763': 682,
            '764': 682,
            '765': 814,
            '766': 814,
            '767': 682,
            '768': 0,
            '769': 0,
            '770': 0,
            '771': 0,
            '772': 0,
            '773': 0,
            '774': 0,
            '775': 0,
            '776': 0,
            '777': 0,
            '778': 0,
            '779': 0,
            '780': 0,
            '781': 0,
            '782': 0,
            '783': 0,
            '784': 0,
            '785': 0,
            '786': 0,
            '787': 0,
            '788': 0,
            '789': 0,
            '790': 0,
            '791': 0,
            '792': 0,
            '793': 0,
            '794': 0,
            '795': 0,
            '796': 0,
            '797': 0,
            '798': 0,
            '799': 0,
            '800': 0,
            '801': 0,
            '802': 0,
            '803': 0,
            '804': 0,
            '805': 0,
            '806': 0,
            '807': 0,
            '808': 0,
            '809': 0,
            '810': 0,
            '811': 0,
            '812': 0,
            '813': 0,
            '814': 0,
            '815': 0,
            '816': 0,
            '817': 0,
            '818': 0,
            '819': 0,
            '820': 0,
            '821': 0,
            '822': 0,
            '823': 0,
            '824': 0,
            '825': 0,
            '826': 0,
            '827': 0,
            '828': 0,
            '829': 0,
            '830': 0,
            '831': 0,
            '832': 0,
            '833': 0,
            '834': 0,
            '835': 0,
            '836': 0,
            '837': 0,
            '838': 0,
            '839': 0,
            '840': 0,
            '841': 0,
            '842': 0,
            '843': 0,
            '844': 0,
            '845': 0,
            '846': 0,
            '847': 0,
            '848': 0,
            '849': 0,
            '850': 0,
            '851': 0,
            '852': 0,
            '853': 0,
            '854': 0,
            '855': 0,
            '856': 0,
            '857': 0,
            '858': 0,
            '859': 0,
            '860': 0,
            '861': 0,
            '862': 0,
            '863': 0,
            '864': 0,
            '865': 0,
            '866': 0,
            '867': 0,
            '868': 0,
            '869': 0,
            '870': 0,
            '871': 0,
            '872': 0,
            '873': 0,
            '874': 0,
            '875': 0,
            '876': 0,
            '877': 0,
            '878': 0,
            '879': 0,
            '884': 682,
            '885': 682,
            '890': 682,
            '891': 1139,
            '892': 1139,
            '893': 1139,
            '894': 682,
            '900': 682,
            '901': 682,
            '902': 1479,
            '903': 682,
            '904': 1749,
            '905': 1855,
            '906': 969,
            '908': 1729,
            '910': 1905,
            '911': 1735,
            '912': 569,
            '913': 1479,
            '914': 1479,
            '915': 1249,
            '916': 1375,
            '917': 1366,
            '918': 1251,
            '919': 1479,
            '920': 1593,
            '921': 569,
            '922': 1479,
            '923': 1366,
            '924': 1706,
            '925': 1479,
            '926': 1346,
            '927': 1593,
            '928': 1470,
            '929': 1366,
            '931': 1209,
            '932': 1251,
            '933': 1366,
            '934': 1684,
            '935': 1366,
            '936': 1697,
            '937': 1599,
            '938': 569,
            '939': 1366,
            '940': 1270,
            '941': 980,
            '942': 1251,
            '943': 569,
            '944': 1211,
            '945': 1270,
            '946': 1271,
            '947': 1139,
            '948': 1250,
            '949': 980,
            '950': 1007,
            '951': 1251,
            '952': 1142,
            '953': 569,
            '954': 1159,
            '955': 1139,
            '956': 1235,
            '957': 1139,
            '958': 921,
            '959': 1251,
            '960': 1458,
            '961': 1240,
            '962': 1090,
            '963': 1359,
            '964': 837,
            '965': 1211,
            '966': 1441,
            '967': 1183,
            '968': 1583,
            '969': 1709,
            '970': 569,
            '971': 1211,
            '972': 1251,
            '973': 1211,
            '974': 1709,
            '976': 1155,
            '977': 1211,
            '978': 1533,
            '979': 2033,
            '980': 1533,
            '981': 1551,
            '982': 1709,
            '983': 1385,
            '984': 1593,
            '985': 1251,
            '986': 1479,
            '987': 1139,
            '988': 1251,
            '989': 961,
            '990': 1539,
            '991': 1084,
            '992': 1647,
            '993': 1250,
            '994': 1865,
            '995': 1821,
            '996': 1373,
            '997': 1251,
            '998': 1450,
            '999': 1239,
            '1000': 1366,
            '1001': 1366,
            '1002': 1316,
            '1003': 1236,
            '1004': 1505,
            '1005': 1184,
            '1006': 1038,
            '1007': 900,
            '1008': 1385,
            '1009': 1265,
            '1010': 1139,
            '1011': 569,
            '1012': 1593,
            '1013': 981,
            '1014': 981,
            '1015': 1366,
            '1016': 1251,
            '1017': 1479,
            '1018': 1706,
            '1019': 1515,
            '1020': 1240,
            '1021': 1479,
            '1022': 1479,
            '1023': 1479,
            '1024': 1366,
            '1025': 1366,
            '1026': 1814,
            '1027': 1257,
            '1028': 1472,
            '1029': 1366,
            '1030': 569,
            '1031': 569,
            '1032': 1139,
            '1033': 2241,
            '1034': 2134,
            '1035': 1748,
            '1036': 1259,
            '1037': 1473,
            '1038': 1387,
            '1039': 1473,
            '1040': 1479,
            '1041': 1450,
            '1042': 1479,
            '1043': 1257,
            '1044': 1479,
            '1045': 1366,
            '1046': 1899,
            '1047': 1316,
            '1048': 1473,
            '1049': 1473,
            '1050': 1259,
            '1051': 1407,
            '1052': 1706,
            '1053': 1479,
            '1054': 1593,
            '1055': 1473,
            '1056': 1366,
            '1057': 1479,
            '1058': 1251,
            '1059': 1387,
            '1060': 1599,
            '1061': 1366,
            '1062': 1493,
            '1063': 1450,
            '1064': 2005,
            '1065': 2025,
            '1066': 1749,
            '1067': 2048,
            '1068': 1450,
            '1069': 1472,
            '1070': 2134,
            '1071': 1493,
            '1072': 1139,
            '1073': 1268,
            '1074': 1237,
            '1075': 1093,
            '1076': 1266,
            '1077': 1139,
            '1078': 1508,
            '1079': 1045,
            '1080': 1251,
            '1081': 1251,
            '1082': 1038,
            '1083': 1274,
            '1084': 1515,
            '1085': 1237,
            '1086': 1251,
            '1087': 1251,
            '1088': 1251,
            '1089': 1139,
            '1090': 1821,
            '1091': 1139,
            '1092': 1812,
            '1093': 1139,
            '1094': 1323,
            '1095': 1194,
            '1096': 1821,
            '1097': 1915,
            '1098': 1448,
            '1099': 1749,
            '1100': 1216,
            '1101': 1130,
            '1102': 1771,
            '1103': 1206,
            '1104': 1139,
            '1105': 1139,
            '1106': 1251,
            '1107': 961,
            '1108': 1153,
            '1109': 1139,
            '1110': 569,
            '1111': 569,
            '1112': 569,
            '1113': 1985,
            '1114': 1855,
            '1115': 1251,
            '1116': 1038,
            '1117': 1251,
            '1118': 1139,
            '1119': 1251,
            '1120': 2653,
            '1121': 1594,
            '1122': 1683,
            '1123': 1735,
            '1124': 1987,
            '1125': 1637,
            '1126': 1366,
            '1127': 1139,
            '1128': 1896,
            '1129': 1639,
            '1130': 1657,
            '1131': 1543,
            '1132': 2218,
            '1133': 2003,
            '1134': 1316,
            '1135': 1045,
            '1136': 1697,
            '1137': 1583,
            '1138': 1593,
            '1139': 1251,
            '1140': 1606,
            '1141': 1257,
            '1142': 1606,
            '1143': 1257,
            '1144': 2327,
            '1145': 2010,
            '1146': 1698,
            '1147': 1328,
            '1148': 2653,
            '1149': 1858,
            '1150': 2653,
            '1151': 1594,
            '1152': 1479,
            '1153': 1026,
            '1154': 1196,
            '1155': 0,
            '1156': 0,
            '1157': 0,
            '1158': 0,
            '1159': 0,
            '1160': 0,
            '1161': 0,
            '1162': 1473,
            '1163': 1251,
            '1164': 1450,
            '1165': 1216,
            '1166': 1366,
            '1167': 1251,
            '1168': 1178,
            '1169': 956,
            '1170': 1257,
            '1171': 961,
            '1172': 1365,
            '1173': 1183,
            '1174': 1899,
            '1175': 1508,
            '1176': 1316,
            '1177': 1045,
            '1178': 1259,
            '1179': 1038,
            '1180': 1259,
            '1181': 1038,
            '1182': 1259,
            '1183': 1038,
            '1184': 1567,
            '1185': 1254,
            '1186': 1479,
            '1187': 1237,
            '1188': 1787,
            '1189': 1423,
            '1190': 2287,
            '1191': 1867,
            '1192': 1485,
            '1193': 1157,
            '1194': 1479,
            '1195': 1139,
            '1196': 1251,
            '1197': 1821,
            '1198': 1139,
            '1199': 1139,
            '1200': 1139,
            '1201': 1139,
            '1202': 1366,
            '1203': 1139,
            '1204': 1786,
            '1205': 1455,
            '1206': 1450,
            '1207': 1194,
            '1208': 1450,
            '1209': 1194,
            '1210': 1450,
            '1211': 1251,
            '1212': 1760,
            '1213': 1328,
            '1214': 1760,
            '1215': 1328,
            '1216': 569,
            '1217': 1899,
            '1218': 1508,
            '1219': 1350,
            '1220': 1193,
            '1221': 1407,
            '1222': 1274,
            '1223': 1479,
            '1224': 1237,
            '1225': 1479,
            '1226': 1237,
            '1227': 1450,
            '1228': 1194,
            '1229': 1706,
            '1230': 1515,
            '1231': 569,
            '1232': 1479,
            '1233': 1139,
            '1234': 1479,
            '1235': 1139,
            '1236': 2048,
            '1237': 1821,
            '1238': 1366,
            '1239': 1139,
            '1240': 1531,
            '1241': 1139,
            '1242': 1531,
            '1243': 1139,
            '1244': 1899,
            '1245': 1508,
            '1246': 1316,
            '1247': 1045,
            '1248': 1251,
            '1249': 1078,
            '1250': 1473,
            '1251': 1251,
            '1252': 1473,
            '1253': 1251,
            '1254': 1593,
            '1255': 1251,
            '1256': 1593,
            '1257': 1251,
            '1258': 1593,
            '1259': 1251,
            '1260': 1472,
            '1261': 1130,
            '1262': 1387,
            '1263': 1139,
            '1264': 1387,
            '1265': 1139,
            '1266': 1387,
            '1267': 1139,
            '1268': 1450,
            '1269': 1194,
            '1270': 1257,
            '1271': 961,
            '1272': 2048,
            '1273': 1749,
            '1274': 1257,
            '1275': 961,
            '1276': 1366,
            '1277': 1139,
            '1278': 1366,
            '1279': 1139,
            '1280': 1366,
            '1281': 1251,
            '1282': 2006,
            '1283': 1909,
            '1284': 2009,
            '1285': 1738,
            '1286': 1316,
            '1287': 1045,
            '1288': 2058,
            '1289': 1924,
            '1290': 2126,
            '1291': 1898,
            '1292': 1593,
            '1293': 1221,
            '1294': 1587,
            '1295': 2467,
            '1296': 1316,
            '1297': 980,
            '1298': 1407,
            '1299': 1274,
            '1306': 1593,
            '1307': 1251,
            '1308': 1933,
            '1309': 1593,
            '1425': 0,
            '1426': 0,
            '1427': 0,
            '1428': 0,
            '1429': 0,
            '1430': 0,
            '1431': 0,
            '1432': 0,
            '1433': 0,
            '1434': 0,
            '1435': 0,
            '1436': 0,
            '1437': 0,
            '1438': 0,
            '1439': 0,
            '1440': 0,
            '1441': 0,
            '1442': 0,
            '1443': 0,
            '1444': 0,
            '1445': 0,
            '1446': 0,
            '1447': 0,
            '1448': 0,
            '1449': 0,
            '1450': 0,
            '1451': 0,
            '1452': 0,
            '1453': 0,
            '1454': 0,
            '1455': 0,
            '1456': 0,
            '1457': 0,
            '1458': 0,
            '1459': 0,
            '1460': 0,
            '1461': 0,
            '1462': 0,
            '1463': 0,
            '1464': 0,
            '1465': 0,
            '1466': 0,
            '1467': 0,
            '1468': 0,
            '1469': 0,
            '1470': 784,
            '1471': 0,
            '1472': 1153,
            '1473': 0,
            '1474': 0,
            '1475': 682,
            '1476': 0,
            '1477': 0,
            '1478': 862,
            '1479': 0,
            '1488': 1397,
            '1489': 1311,
            '1490': 981,
            '1491': 1192,
            '1492': 1384,
            '1493': 618,
            '1494': 748,
            '1495': 1434,
            '1496': 1409,
            '1497': 618,
            '1498': 1180,
            '1499': 1133,
            '1500': 1171,
            '1501': 1475,
            '1502': 1487,
            '1503': 618,
            '1504': 883,
            '1505': 1430,
            '1506': 1266,
            '1507': 1382,
            '1508': 1335,
            '1509': 1128,
            '1510': 1247,
            '1511': 1339,
            '1512': 1180,
            '1513': 1649,
            '1514': 1470,
            '1520': 1237,
            '1521': 1237,
            '1522': 1237,
            '1523': 831,
            '1524': 1278,
            '7424': 1212,
            '7425': 1590,
            '7426': 1821,
            '7427': 1267,
            '7428': 1139,
            '7429': 1241,
            '7430': 1241,
            '7431': 1000,
            '7432': 1045,
            '7433': 569,
            '7434': 1024,
            '7435': 1159,
            '7436': 993,
            '7437': 1515,
            '7438': 1212,
            '7439': 1251,
            '7440': 1139,
            '7441': 1251,
            '7442': 1139,
            '7443': 1251,
            '7444': 1933,
            '7445': 1182,
            '7446': 1251,
            '7447': 1251,
            '7448': 1191,
            '7449': 1206,
            '7450': 1206,
            '7451': 939,
            '7452': 1211,
            '7453': 1251,
            '7454': 1498,
            '7455': 1251,
            '7456': 1139,
            '7457': 1593,
            '7458': 1024,
            '7459': 1078,
            '7460': 1010,
            '7461': 1260,
            '7462': 961,
            '7463': 1139,
            '7464': 1251,
            '7465': 1191,
            '7466': 1583,
            '7467': 1274,
            '7468': 1044,
            '7469': 1501,
            '7470': 1020,
            '7471': 1020,
            '7472': 1035,
            '7473': 984,
            '7474': 984,
            '7475': 1082,
            '7476': 1020,
            '7477': 433,
            '7478': 770,
            '7479': 1041,
            '7480': 857,
            '7481': 1181,
            '7482': 1015,
            '7483': 1020,
            '7484': 1121,
            '7485': 1019,
            '7486': 937,
            '7487': 1089,
            '7488': 849,
            '7489': 984,
            '7490': 1384,
            '7491': 787,
            '7492': 787,
            '7493': 830,
            '7494': 1252,
            '7495': 850,
            '7496': 850,
            '7497': 816,
            '7498': 816,
            '7499': 656,
            '7500': 656,
            '7501': 851,
            '7502': 350,
            '7503': 782,
            '7504': 1218,
            '7505': 825,
            '7506': 874,
            '7507': 828,
            '7508': 874,
            '7509': 874,
            '7510': 861,
            '7511': 487,
            '7512': 824,
            '7513': 824,
            '7514': 1218,
            '7515': 822,
            '7516': 882,
            '7517': 872,
            '7518': 795,
            '7519': 875,
            '7520': 1004,
            '7521': 809,
            '7522': 350,
            '7523': 572,
            '7524': 824,
            '7525': 822,
            '7526': 872,
            '7527': 795,
            '7528': 850,
            '7529': 1004,
            '7530': 809,
            '7531': 1877,
            '7532': 1251,
            '7533': 1251,
            '7534': 682,
            '7535': 1821,
            '7536': 1251,
            '7537': 1251,
            '7538': 797,
            '7539': 797,
            '7540': 1139,
            '7541': 682,
            '7542': 1024,
            '7543': 1251,
            '7544': 820,
            '7545': 1086,
            '7546': 1811,
            '7547': 569,
            '7548': 569,
            '7549': 1251,
            '7550': 1211,
            '7551': 1272,
            '7552': 1251,
            '7553': 1251,
            '7554': 682,
            '7555': 1488,
            '7556': 1139,
            '7557': 569,
            '7558': 1821,
            '7559': 1251,
            '7560': 1251,
            '7561': 797,
            '7562': 1139,
            '7563': 806,
            '7564': 1139,
            '7565': 1139,
            '7566': 1024,
            '7567': 1139,
            '7568': 1251,
            '7569': 1251,
            '7570': 1139,
            '7571': 980,
            '7572': 1045,
            '7573': 1206,
            '7574': 569,
            '7575': 1139,
            '7576': 654,
            '7577': 1251,
            '7578': 1078,
            '7579': 830,
            '7580': 828,
            '7581': 828,
            '7582': 885,
            '7583': 656,
            '7584': 437,
            '7585': 437,
            '7586': 851,
            '7587': 825,
            '7588': 350,
            '7589': 350,
            '7590': 350,
            '7591': 350,
            '7592': 565,
            '7593': 350,
            '7594': 350,
            '7595': 600,
            '7596': 1218,
            '7597': 1218,
            '7598': 825,
            '7599': 825,
            '7600': 880,
            '7601': 874,
            '7602': 1078,
            '7603': 736,
            '7604': 438,
            '7605': 487,
            '7606': 824,
            '7607': 888,
            '7608': 824,
            '7609': 824,
            '7610': 822,
            '7611': 670,
            '7612': 670,
            '7613': 926,
            '7614': 744,
            '7615': 800,
            '7616': 0,
            '7617': 0,
            '7618': 0,
            '7619': 0,
            '7620': 0,
            '7621': 0,
            '7622': 0,
            '7623': 0,
            '7624': 0,
            '7625': 0,
            '7626': 0,
            '7678': 0,
            '7679': 0,
            '7680': 1479,
            '7681': 1139,
            '7682': 1479,
            '7683': 1251,
            '7684': 1479,
            '7685': 1251,
            '7686': 1479,
            '7687': 1251,
            '7688': 1479,
            '7689': 1139,
            '7690': 1479,
            '7691': 1251,
            '7692': 1479,
            '7693': 1251,
            '7694': 1479,
            '7695': 1251,
            '7696': 1479,
            '7697': 1251,
            '7698': 1479,
            '7699': 1251,
            '7700': 1366,
            '7701': 1139,
            '7702': 1366,
            '7703': 1139,
            '7704': 1366,
            '7705': 1139,
            '7706': 1366,
            '7707': 1139,
            '7708': 1366,
            '7709': 1139,
            '7710': 1251,
            '7711': 682,
            '7712': 1593,
            '7713': 1251,
            '7714': 1479,
            '7715': 1251,
            '7716': 1479,
            '7717': 1251,
            '7718': 1479,
            '7719': 1251,
            '7720': 1479,
            '7721': 1251,
            '7722': 1479,
            '7723': 1251,
            '7724': 569,
            '7725': 569,
            '7726': 569,
            '7727': 569,
            '7728': 1479,
            '7729': 1139,
            '7730': 1479,
            '7731': 1139,
            '7732': 1479,
            '7733': 1139,
            '7734': 1251,
            '7735': 569,
            '7736': 1251,
            '7737': 569,
            '7738': 1251,
            '7739': 569,
            '7740': 1251,
            '7741': 569,
            '7742': 1706,
            '7743': 1821,
            '7744': 1706,
            '7745': 1821,
            '7746': 1706,
            '7747': 1821,
            '7748': 1479,
            '7749': 1251,
            '7750': 1479,
            '7751': 1251,
            '7752': 1479,
            '7753': 1251,
            '7754': 1479,
            '7755': 1251,
            '7756': 1593,
            '7757': 1251,
            '7758': 1593,
            '7759': 1251,
            '7760': 1593,
            '7761': 1251,
            '7762': 1593,
            '7763': 1251,
            '7764': 1366,
            '7765': 1251,
            '7766': 1366,
            '7767': 1251,
            '7768': 1479,
            '7769': 797,
            '7770': 1479,
            '7771': 797,
            '7772': 1479,
            '7773': 797,
            '7774': 1479,
            '7775': 797,
            '7776': 1366,
            '7777': 1139,
            '7778': 1366,
            '7779': 1139,
            '7780': 1366,
            '7781': 1139,
            '7782': 1366,
            '7783': 1139,
            '7784': 1366,
            '7785': 1139,
            '7786': 1251,
            '7787': 682,
            '7788': 1251,
            '7789': 682,
            '7790': 1251,
            '7791': 682,
            '7792': 1251,
            '7793': 682,
            '7794': 1479,
            '7795': 1251,
            '7796': 1479,
            '7797': 1251,
            '7798': 1479,
            '7799': 1251,
            '7800': 1479,
            '7801': 1251,
            '7802': 1479,
            '7803': 1251,
            '7804': 1366,
            '7805': 1139,
            '7806': 1366,
            '7807': 1139,
            '7808': 1933,
            '7809': 1593,
            '7810': 1933,
            '7811': 1593,
            '7812': 1933,
            '7813': 1593,
            '7814': 1933,
            '7815': 1593,
            '7816': 1933,
            '7817': 1593,
            '7818': 1366,
            '7819': 1139,
            '7820': 1366,
            '7821': 1139,
            '7822': 1366,
            '7823': 1139,
            '7824': 1251,
            '7825': 1024,
            '7826': 1251,
            '7827': 1024,
            '7828': 1251,
            '7829': 1024,
            '7830': 1251,
            '7831': 682,
            '7832': 1593,
            '7833': 1139,
            '7834': 1139,
            '7835': 569,
            '7838': 1465,
            '7840': 1479,
            '7841': 1139,
            '7842': 1479,
            '7843': 1139,
            '7844': 1479,
            '7845': 1139,
            '7846': 1479,
            '7847': 1139,
            '7848': 1479,
            '7849': 1139,
            '7850': 1479,
            '7851': 1139,
            '7852': 1479,
            '7853': 1139,
            '7854': 1479,
            '7855': 1139,
            '7856': 1479,
            '7857': 1139,
            '7858': 1479,
            '7859': 1139,
            '7860': 1479,
            '7861': 1139,
            '7862': 1479,
            '7863': 1139,
            '7864': 1366,
            '7865': 1139,
            '7866': 1366,
            '7867': 1139,
            '7868': 1366,
            '7869': 1139,
            '7870': 1366,
            '7871': 1139,
            '7872': 1366,
            '7873': 1139,
            '7874': 1366,
            '7875': 1139,
            '7876': 1366,
            '7877': 1139,
            '7878': 1366,
            '7879': 1139,
            '7880': 569,
            '7881': 569,
            '7882': 569,
            '7883': 569,
            '7884': 1593,
            '7885': 1251,
            '7886': 1593,
            '7887': 1251,
            '7888': 1593,
            '7889': 1251,
            '7890': 1593,
            '7891': 1251,
            '7892': 1593,
            '7893': 1251,
            '7894': 1593,
            '7895': 1251,
            '7896': 1593,
            '7897': 1251,
            '7898': 1715,
            '7899': 1375,
            '7900': 1715,
            '7901': 1375,
            '7902': 1715,
            '7903': 1375,
            '7904': 1715,
            '7905': 1375,
            '7906': 1715,
            '7907': 1375,
            '7908': 1479,
            '7909': 1251,
            '7910': 1479,
            '7911': 1251,
            '7912': 1656,
            '7913': 1462,
            '7914': 1656,
            '7915': 1462,
            '7916': 1656,
            '7917': 1462,
            '7918': 1656,
            '7919': 1462,
            '7920': 1656,
            '7921': 1462,
            '7922': 1366,
            '7923': 1139,
            '7924': 1366,
            '7925': 1139,
            '7926': 1366,
            '7927': 1139,
            '7928': 1366,
            '7929': 1139,
            '7936': 1270,
            '7937': 1270,
            '7938': 1270,
            '7939': 1270,
            '7940': 1270,
            '7941': 1270,
            '7942': 1270,
            '7943': 1270,
            '7944': 1479,
            '7945': 1479,
            '7946': 1779,
            '7947': 1779,
            '7948': 1779,
            '7949': 1779,
            '7950': 1779,
            '7951': 1779,
            '7952': 980,
            '7953': 980,
            '7954': 980,
            '7955': 980,
            '7956': 980,
            '7957': 980,
            '7960': 1566,
            '7961': 1566,
            '7962': 1966,
            '7963': 1966,
            '7964': 1966,
            '7965': 1966,
            '7968': 1251,
            '7969': 1251,
            '7970': 1251,
            '7971': 1251,
            '7972': 1251,
            '7973': 1251,
            '7974': 1251,
            '7975': 1251,
            '7976': 1679,
            '7977': 1679,
            '7978': 2079,
            '7979': 2079,
            '7980': 2079,
            '7981': 2079,
            '7982': 2079,
            '7983': 2079,
            '7984': 569,
            '7985': 569,
            '7986': 569,
            '7987': 569,
            '7988': 569,
            '7989': 569,
            '7990': 569,
            '7991': 569,
            '7992': 769,
            '7993': 769,
            '7994': 1169,
            '7995': 1169,
            '7996': 1169,
            '7997': 1169,
            '7998': 1169,
            '7999': 1169,
            '8000': 1251,
            '8001': 1251,
            '8002': 1251,
            '8003': 1251,
            '8004': 1251,
            '8005': 1251,
            '8008': 1693,
            '8009': 1693,
            '8010': 2193,
            '8011': 2193,
            '8012': 1993,
            '8013': 1993,
            '8016': 1211,
            '8017': 1211,
            '8018': 1211,
            '8019': 1211,
            '8020': 1211,
            '8021': 1211,
            '8022': 1211,
            '8023': 1211,
            '8025': 1666,
            '8027': 1966,
            '8029': 2166,
            '8031': 1966,
            '8032': 1709,
            '8033': 1709,
            '8034': 1709,
            '8035': 1709,
            '8036': 1709,
            '8037': 1709,
            '8038': 1709,
            '8039': 1709,
            '8040': 1699,
            '8041': 1699,
            '8042': 2199,
            '8043': 2199,
            '8044': 1999,
            '8045': 1999,
            '8046': 1999,
            '8047': 1999,
            '8048': 1270,
            '8049': 1270,
            '8050': 980,
            '8051': 980,
            '8052': 1251,
            '8053': 1251,
            '8054': 569,
            '8055': 569,
            '8056': 1251,
            '8057': 1251,
            '8058': 1211,
            '8059': 1211,
            '8060': 1709,
            '8061': 1709,
            '8064': 1270,
            '8065': 1270,
            '8066': 1270,
            '8067': 1270,
            '8068': 1270,
            '8069': 1270,
            '8070': 1270,
            '8071': 1270,
            '8072': 1479,
            '8073': 1479,
            '8074': 1779,
            '8075': 1779,
            '8076': 1779,
            '8077': 1779,
            '8078': 1779,
            '8079': 1779,
            '8080': 1251,
            '8081': 1251,
            '8082': 1251,
            '8083': 1251,
            '8084': 1251,
            '8085': 1251,
            '8086': 1251,
            '8087': 1251,
            '8088': 1679,
            '8089': 1679,
            '8090': 2079,
            '8091': 2079,
            '8092': 2079,
            '8093': 2079,
            '8094': 2079,
            '8095': 2079,
            '8096': 1709,
            '8097': 1709,
            '8098': 1709,
            '8099': 1709,
            '8100': 1709,
            '8101': 1709,
            '8102': 1709,
            '8103': 1709,
            '8104': 1699,
            '8105': 1699,
            '8106': 2199,
            '8107': 2199,
            '8108': 1999,
            '8109': 1999,
            '8110': 1999,
            '8111': 1999,
            '8112': 1270,
            '8113': 1270,
            '8114': 1270,
            '8115': 1270,
            '8116': 1270,
            '8118': 1270,
            '8119': 1270,
            '8120': 1479,
            '8121': 1479,
            '8122': 1479,
            '8123': 1479,
            '8124': 1479,
            '8125': 682,
            '8126': 682,
            '8127': 682,
            '8128': 682,
            '8129': 682,
            '8130': 1251,
            '8131': 1251,
            '8132': 1251,
            '8134': 1251,
            '8135': 1251,
            '8136': 1666,
            '8137': 1766,
            '8138': 1779,
            '8139': 1879,
            '8140': 1479,
            '8141': 682,
            '8142': 682,
            '8143': 682,
            '8144': 569,
            '8145': 569,
            '8146': 569,
            '8147': 569,
            '8150': 569,
            '8151': 569,
            '8152': 569,
            '8153': 569,
            '8154': 869,
            '8155': 969,
            '8157': 682,
            '8158': 682,
            '8159': 682,
            '8160': 1211,
            '8161': 1211,
            '8162': 1211,
            '8163': 1211,
            '8164': 1240,
            '8165': 1240,
            '8166': 1211,
            '8167': 1211,
            '8168': 1366,
            '8169': 1366,
            '8170': 1766,
            '8171': 1866,
            '8172': 1566,
            '8173': 682,
            '8174': 682,
            '8175': 682,
            '8178': 1709,
            '8179': 1709,
            '8180': 1709,
            '8182': 1709,
            '8183': 1709,
            '8184': 1893,
            '8185': 1693,
            '8186': 1899,
            '8187': 1699,
            '8188': 1599,
            '8189': 682,
            '8190': 682,
            '8192': 1024,
            '8193': 2048,
            '8194': 1024,
            '8195': 2048,
            '8196': 683,
            '8197': 512,
            '8198': 341,
            '8199': 1139,
            '8200': 569,
            '8201': 410,
            '8202': 171,
            '8203': 0,
            '8204': 0,
            '8205': 0,
            '8206': 0,
            '8207': 0,
            '8208': 682,
            '8210': 1139,
            '8211': 1139,
            '8212': 2048,
            '8213': 2048,
            '8214': 1019,
            '8215': 1131,
            '8216': 569,
            '8217': 569,
            '8218': 569,
            '8219': 569,
            '8220': 1024,
            '8221': 1024,
            '8222': 1024,
            '8223': 1024,
            '8224': 1139,
            '8225': 1139,
            '8226': 717,
            '8230': 2048,
            '8234': 0,
            '8235': 0,
            '8236': 0,
            '8237': 0,
            '8238': 0,
            '8239': 410,
            '8240': 2048,
            '8242': 491,
            '8243': 981,
            '8244': 981,
            '8249': 682,
            '8250': 682,
            '8252': 1237,
            '8254': 682,
            '8260': 342,
            '8286': 682,
            '8298': 0,
            '8299': 0,
            '8300': 0,
            '8301': 0,
            '8302': 0,
            '8303': 0,
            '8308': 873,
            '8309': 832,
            '8310': 830,
            '8311': 784,
            '8312': 851,
            '8313': 873,
            '8319': 811,
            '8320': 808,
            '8321': 721,
            '8322': 781,
            '8323': 796,
            '8324': 820,
            '8325': 809,
            '8326': 815,
            '8327': 749,
            '8328': 835,
            '8329': 807,
            '8336': 787,
            '8337': 816,
            '8338': 874,
            '8339': 809,
            '8340': 816,
            '8352': 1139,
            '8353': 1479,
            '8354': 1479,
            '8355': 1139,
            '8356': 1139,
            '8357': 1821,
            '8358': 1479,
            '8359': 2261,
            '8360': 2489,
            '8361': 1933,
            '8362': 1810,
            '8363': 1051,
            '8364': 1139,
            '8365': 1479,
            '8366': 1251,
            '8367': 2224,
            '8368': 1139,
            '8369': 1366,
            '8370': 1593,
            '8371': 1479,
            '8372': 1366,
            '8373': 1479,
            '8383': 1796,
            '8432': 0,
            '8453': 1813,
            '8467': 1057,
            '8470': 2347,
            '8471': 1509,
            '8482': 2048,
            '8486': 1573,
            '8494': 1229,
            '8525': 2048,
            '8526': 1025,
            '8531': 1708,
            '8532': 1708,
            '8539': 1708,
            '8540': 1708,
            '8541': 1708,
            '8542': 1708,
            '8580': 1139,
            '8592': 2048,
            '8593': 1024,
            '8594': 2048,
            '8595': 1024,
            '8596': 2048,
            '8597': 1024,
            '8616': 1024,
            '8660': 2048,
            '8706': 1012,
            '8710': 1253,
            '8719': 1686,
            '8721': 1460,
            '8722': 1196,
            '8725': 342,
            '8729': 569,
            '8730': 1124,
            '8734': 1460,
            '8735': 2005,
            '8745': 1479,
            '8747': 561,
            '8776': 1124,
            '8800': 1124,
            '8801': 1195,
            '8802': 2048,
            '8804': 1124,
            '8805': 1124,
            '8962': 1237,
            '8976': 1196,
            '8992': 1237,
            '8993': 1237,
            '9472': 1451,
            '9474': 1280,
            '9484': 1451,
            '9488': 1451,
            '9492': 1451,
            '9496': 1451,
            '9500': 1451,
            '9508': 1451,
            '9516': 1451,
            '9524': 1451,
            '9532': 1451,
            '9552': 1451,
            '9553': 1451,
            '9554': 1451,
            '9555': 1451,
            '9556': 1451,
            '9557': 1451,
            '9558': 1451,
            '9559': 1451,
            '9560': 1451,
            '9561': 1451,
            '9562': 1451,
            '9563': 1451,
            '9564': 1451,
            '9565': 1451,
            '9566': 1451,
            '9567': 1451,
            '9568': 1451,
            '9569': 1451,
            '9570': 1451,
            '9571': 1451,
            '9572': 1451,
            '9573': 1451,
            '9574': 1451,
            '9575': 1451,
            '9576': 1451,
            '9577': 1451,
            '9578': 1451,
            '9579': 1451,
            '9580': 1451,
            '9600': 1451,
            '9604': 1451,
            '9608': 1451,
            '9612': 1451,
            '9616': 1451,
            '9617': 1451,
            '9618': 1451,
            '9619': 1493,
            '9632': 1237,
            '9633': 1237,
            '9642': 726,
            '9643': 726,
            '9644': 2048,
            '9650': 2027,
            '9658': 2027,
            '9660': 2027,
            '9668': 2027,
            '9674': 1012,
            '9675': 1237,
            '9676': 1217,
            '9679': 1237,
            '9680': 1237,
            '9681': 1237,
            '9682': 1237,
            '9683': 1237,
            '9684': 1237,
            '9685': 1237,
            '9686': 1237,
            '9687': 1237,
            '9688': 1237,
            '9689': 1237,
            '9702': 726,
            '9786': 2091,
            '9787': 2155,
            '9788': 1877,
            '9791': 1536,
            '9792': 1536,
            '9793': 1536,
            '9794': 1536,
            '9795': 1536,
            '9796': 1536,
            '9797': 1536,
            '9798': 1536,
            '9799': 1536,
            '9824': 1088,
            '9827': 1344,
            '9829': 1216,
            '9830': 1045,
            '9833': 2048,
            '9834': 1024,
            '9835': 1536,
            '9836': 2048,
            '9839': 1024,
            '11360': 1251,
            '11361': 569,
            '11362': 1251,
            '11363': 1366,
            '11364': 1479,
            '11365': 1139,
            '11366': 682,
            '11367': 1479,
            '11368': 1251,
            '11369': 1479,
            '11370': 1139,
            '11371': 1251,
            '11372': 1024,
            '11373': 1592,
            '11377': 1236,
            '11378': 2139,
            '11379': 1758,
            '11380': 1139,
            '11381': 1133,
            '11382': 917,
            '11383': 1441,
            '11799': 682,
            '42775': 0,
            '42776': 0,
            '42777': 0,
            '42778': 0,
            '42779': 1024,
            '42780': 1024,
            '42781': 682,
            '42782': 682,
            '42783': 682,
            '42784': 0,
            '42785': 0,
            '42888': 682,
            '42889': 682,
            '42890': 796,
            '42891': 487,
            '42892': 487,
            '64257': 1251,
            '64258': 1251,
            '64285': 618,
            '64286': 0,
            '64287': 1237,
            '64288': 1266,
            '64289': 1397,
            '64290': 1192,
            '64291': 1384,
            '64292': 1133,
            '64293': 1171,
            '64294': 1475,
            '64295': 1180,
            '64296': 1470,
            '64297': 1237,
            '64298': 1649,
            '64299': 1649,
            '64300': 1649,
            '64301': 1649,
            '64302': 1397,
            '64303': 1397,
            '64304': 1397,
            '64305': 1311,
            '64306': 981,
            '64307': 1192,
            '64308': 1384,
            '64309': 618,
            '64310': 748,
            '64312': 1409,
            '64313': 618,
            '64314': 1180,
            '64315': 1133,
            '64316': 1171,
            '64318': 1487,
            '64320': 883,
            '64321': 1430,
            '64323': 1382,
            '64324': 1335,
            '64326': 1247,
            '64327': 1339,
            '64328': 1180,
            '64329': 1649,
            '64330': 1470,
            '64331': 618,
            '64332': 1311,
            '64333': 1133,
            '64334': 1335,
            '64335': 1368,
            '65056': 0,
            '65057': 0,
            '65058': 0,
            '65059': 0,
            '65532': 2048,
        },
    },
};
